document.addEventListener("DOMContentLoaded", () => {

  /* GH SEO V13 - Custom Jewelry looping reel: play only while visible. */
  const ghCustomOrderLoopVideos = document.querySelectorAll('.gh-custom-order-loop-video');
  if (ghCustomOrderLoopVideos.length) {
    if ('IntersectionObserver' in window) {
      const ghCustomVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, 0.2, 0.5] });
      ghCustomOrderLoopVideos.forEach((video) => ghCustomVideoObserver.observe(video));
    } else {
      ghCustomOrderLoopVideos.forEach((video) => {
        video.muted = true;
        video.play().catch(() => {});
      });
    }
  }

  /* =========================
     BASIC ELEMENTS
  ========================= */

  const windowEl = document.getElementById("window");
  const openWindow = document.getElementById("openWindow");
  const openCollection2 = document.getElementById("openCollection2");
  const openCollection3 = document.getElementById("openCollection3");

 const productAddress = document.getElementById("productAddress");
 const productQuickLinksHost = document.getElementById("ghProductQuickLinksHost");
 const productDonationNote = document.getElementById("productDonationNote");
 const productDonationText = document.getElementById("productDonationText");
 const productDonationLink = document.getElementById("productDonationLink");
 const productDonationThermometer = document.getElementById("productDonationThermometer");
 const fundraiserTitle = document.getElementById("fundraiserTitle");
 const fundraiserTrackFill = document.getElementById("fundraiserTrackFill");
 const fundraiserStatus = document.getElementById("fundraiserStatus");
 const fundraiserGoalText = document.getElementById("fundraiserGoalText");
 const fundraiserPercentText = document.getElementById("fundraiserPercentText");
 const fundraiserBlurb = document.getElementById("fundraiserBlurb");
 const fundraiserNonprofitLink = document.getElementById("fundraiserNonprofitLink");
 const fundraiserLogoBox = document.getElementById("fundraiserLogoBox");
 const fundraiserLogoImage = document.getElementById("fundraiserLogoImage");
 const productGivingPerSaleTop = document.getElementById("productGivingPerSaleTop");
 const productGivingPerSaleAmount = document.getElementById("productGivingPerSaleAmount");
 const ringsCollectionPage = document.getElementById("ringsCollectionPage");
 const collection2Page = document.getElementById("collection2Page");
 const collection2ProductsGrid = document.getElementById("collection2ProductsGrid");
 const collection3Page = document.getElementById("collection3Page");
 const collection3ProductsGrid = document.getElementById("collection3ProductsGrid");
 const collectionProductShortcuts =
  document.querySelectorAll(".collection-product-shortcut, .desktop-product-shortcut, .featured-product-desktop-icon");

  const closeBtn = document.getElementById("closeBtn");
  const minBtn = document.getElementById("minBtn");
  const maxBtn = document.getElementById("maxBtn");

  const ringsTask = document.getElementById("rings-task");

  const startButton = document.getElementById("start-button");
  const startMenu = document.getElementById("start-menu");
  const infoWindow = document.getElementById("infoWindow");
  const infoWindowTitle = document.getElementById("infoWindowTitle");
  const infoCloseBtn = document.getElementById("infoCloseBtn");
  const infoMinBtn = document.getElementById("infoMinBtn");
  const infoMaxBtn = document.getElementById("infoMaxBtn");
  const infoBackBtn = document.getElementById("infoBackBtn");
  const infoTask = document.getElementById("info-task");
  const infoAddress = document.getElementById("infoAddress");
  const infoPages = document.querySelectorAll(".info-page");
  const infoQuickLinksHost = document.getElementById("ghInfoQuickLinksHost");
  const infoQuickLinkMenus = infoQuickLinksHost
    ? infoQuickLinksHost.querySelectorAll("[data-info-quicklinks-for]")
    : [];
  



  const ghDesktop = document.getElementById("desktop");

  const startFocusOverlay = (() => {
    if (!ghDesktop) return null;

    const existingOverlay = document.getElementById("ghStartMenuFocusOverlay");
    if (existingOverlay) return existingOverlay;

    const overlay = document.createElement("div");
    overlay.id = "ghStartMenuFocusOverlay";
    overlay.className = "hidden";
    overlay.setAttribute("aria-hidden", "true");
    overlay.setAttribute("role", "presentation");
    ghDesktop.appendChild(overlay);
    return overlay;
  })();


  /* =========================
     XP ROUTING / SEO URLS
     Keep the app-like desktop in place while giving products, collections,
     and NameChain real shareable URLs. Direct visits to those URLs still
     render the correct Shopify SEO page on a full reload.
  ========================= */

  function ghCleanRoutePath(pathname) {
    const clean = String(pathname || "/").replace(/\/+$/, "");
    return clean || "/";
  }

  const GH_LEGACY_TEMPLATE_PRODUCT_PATH = "/products/interlocking-pendant";

  const GH_UTILITY_HASH_MESSENGER = "#messenger";
  const GH_UTILITY_HASH_METAL = "#metal-pricing";

  function ghNormalizeUtilityHash(hashValue) {
    const clean = String(hashValue || "").toLowerCase();
    if (clean === GH_UTILITY_HASH_MESSENGER || clean === GH_UTILITY_HASH_METAL) {
      return clean;
    }
    return "";
  }

  function ghOpenUtilityWindowForHash(hashValue) {
    const cleanHash = ghNormalizeUtilityHash(hashValue);
    if (!cleanHash) return false;

    if (cleanHash === GH_UTILITY_HASH_MESSENGER) {
      if (typeof openAimWindow === "function") {
        openAimWindow();
        return true;
      }
      return false;
    }

    if (cleanHash === GH_UTILITY_HASH_METAL) {
      if (typeof openMetalWindow === "function") {
        openMetalWindow();
        return true;
      }
      return false;
    }

    return false;
  }

  function ghScheduleUtilityWindowForHash(hashValue, delay = 0) {
    const cleanHash = ghNormalizeUtilityHash(hashValue);
    if (!cleanHash) return false;

    window.setTimeout(() => {
      ghOpenUtilityWindowForHash(cleanHash);
    }, delay);
    return true;
  }

  function ghUtilityHref(hashValue) {
    const cleanHash = ghNormalizeUtilityHash(hashValue);
    if (!cleanHash) return "";
    return window.location.pathname + window.location.search + cleanHash;
  }

  function ghClearUtilityHash(hashValue) {
    const cleanHash = ghNormalizeUtilityHash(hashValue);
    if (!cleanHash) return false;
    if (String(window.location.hash || "").toLowerCase() !== cleanHash) return false;

    return ghReplaceXpRoute(
      window.location.pathname + window.location.search,
      { type: "utility-closed" }
    );
  }

  function ghIsLegacyTemplateProductRoute(hrefOrPath) {
    if (!hrefOrPath) return false;
    try {
      return ghCleanRoutePath(new URL(hrefOrPath, window.location.href).pathname) === GH_LEGACY_TEMPLATE_PRODUCT_PATH;
    } catch (error) {
      return ghCleanRoutePath(String(hrefOrPath)) === GH_LEGACY_TEMPLATE_PRODUCT_PATH;
    }
  }

  function ghNormalizeLegacyTemplateRouteInPlace() {
    if (ghCleanRoutePath(window.location.pathname) !== GH_LEGACY_TEMPLATE_PRODUCT_PATH) return false;

    // This was the original theme's demo/fallback product address, never a real
    // storefront route. If an older browser-history entry lands here, normalize
    // it to the desktop without reloading so Back/Forward cannot get stuck in a
    // refresh loop or expose the template placeholder URL.
    window.history.replaceState(
      { ghXpRoute: true, type: "desktop-home", ghLegacyRouteRecovered: true },
      "",
      "/"
    );
    return true;
  }

  function ghReplaceXpRoute(href, routeState = {}) {
    if (!href || window.__ghSuppressRouteSync) return false;

    let targetUrl;
    try {
      targetUrl = new URL(href, window.location.href);
    } catch (error) {
      return false;
    }

    if (targetUrl.origin !== window.location.origin) return false;
    if (ghIsLegacyTemplateProductRoute(targetUrl.href)) return false;

    const nextUrl = targetUrl.pathname + targetUrl.search + targetUrl.hash;
    const currentUrl = window.location.pathname + window.location.search + window.location.hash;

    if (nextUrl !== currentUrl) {
      window.history.replaceState(
        Object.assign({ ghXpRoute: true }, routeState || {}),
        "",
        nextUrl
      );
    }

    return true;
  }

  function ghPushXpRoute(href, routeState = {}) {
    if (!href) return false;

    // During a fresh cross-route restore we reopen the other XP windows without
    // letting each restored window overwrite the destination URL.
    if (window.__ghSuppressRouteSync) return true;

    let targetUrl;
    try {
      targetUrl = new URL(href, window.location.href);
    } catch (error) {
      return false;
    }

    if (targetUrl.origin !== window.location.origin) return false;
    if (ghIsLegacyTemplateProductRoute(targetUrl.href)) return false;

    const nextUrl = targetUrl.pathname + targetUrl.search + targetUrl.hash;
    const currentUrl = window.location.pathname + window.location.search + window.location.hash;

    if (nextUrl !== currentUrl) {
      window.history.pushState(
        Object.assign({ ghXpRoute: true }, routeState || {}),
        "",
        nextUrl
      );
    }

    return true;
  }

  window.GHPushXpRoute = ghPushXpRoute;
  window.GHReplaceXpRoute = ghReplaceXpRoute;

  ghNormalizeLegacyTemplateRouteInPlace();

  function ghEnsureHomeStickyNote() {
    const desktop = document.getElementById("desktop");
    if (!desktop) return null;

    // The desktop note is a global desktop object, not route-specific UI.
    // Keeping it mounted and visible on every route prevents hard navigations,
    // BFCache restores, and repeated Back/Forward actions from making it blink
    // out and then reappear. SEO heading semantics are handled server-side:
    // the homepage owns the real H1; other routes render the note heading as
    // a non-H1 visual heading.
    let note = desktop.querySelector(".gh-home-seo-intro");

    if (desktop.dataset.homeSeoEnabled === "false") {
      if (note) note.classList.add("hidden");
      return note;
    }

    if (!note) {
      note = document.createElement("aside");
      note.className = "gh-home-seo-intro gh-home-seo-sticky-note gh-home-seo-runtime-note";
      note.setAttribute("aria-labelledby", "ghHomeSeoRuntimeHeading");

      const tapeLeft = document.createElement("span");
      tapeLeft.className = "gh-home-note-tape gh-home-note-tape-left";
      tapeLeft.setAttribute("aria-hidden", "true");

      const tapeRight = document.createElement("span");
      tapeRight.className = "gh-home-note-tape gh-home-note-tape-right";
      tapeRight.setAttribute("aria-hidden", "true");

      const body = document.createElement("div");
      body.className = "gh-home-seo-body";

      const kicker = document.createElement("p");
      kicker.className = "gh-home-seo-kicker";
      kicker.textContent = "GoldHearted desktop note";

      const heading = document.createElement("div");
      heading.id = "ghHomeSeoRuntimeHeading";
      heading.className = "gh-home-seo-runtime-heading";
      heading.setAttribute("role", "heading");
      heading.setAttribute("aria-level", "2");
      heading.textContent = desktop.dataset.homeSeoH1 || "Custom Jewelry, Built From My World";

      const copy = document.createElement("p");
      copy.textContent = desktop.dataset.homeSeoCopy || "";

      const linksLabel = document.createElement("div");
      linksLabel.className = "gh-home-seo-links-label";
      linksLabel.textContent = "Quick links";

      const links = document.createElement("nav");
      links.className = "gh-home-seo-links";
      links.setAttribute("aria-label", "Step Into My World jewelry");

      const addLink = (label, href, className, category) => {
        const anchor = document.createElement("a");
        anchor.href = href || "/";
        anchor.textContent = label;
        if (className) anchor.className = className;
        if (category) anchor.dataset.ghCategory = category;
        links.appendChild(anchor);
      };

      addLink("Custom Jewelry", desktop.dataset.customOrderPageUrl, "start-page-link", "custom_jewelry");
      addLink("Custom Grillz", desktop.dataset.customGrillzPageUrl, "start-page-link", "custom_grillz");
      addLink("Name Chains", desktop.dataset.namechainPageUrl, "gh-namechain-launcher", "name_chains");
      addLink("Shop All Jewelry", desktop.dataset.allProductsPageUrl, "start-page-link", "all_jewelry");
      addLink("GoldHearted EDU", desktop.dataset.customInfoPageUrl, "start-page-link", "jewelry_education");

      const social = document.createElement("div");
      social.className = "gh-home-social-links";
      social.setAttribute("aria-label", "GoldHearted social media");

      const socialLabel = document.createElement("span");
      socialLabel.textContent = "Follow GoldHearted:";
      social.appendChild(socialLabel);

      const addSocial = (label, href) => {
        if (!href) return;
        const anchor = document.createElement("a");
        anchor.href = href;
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
        anchor.textContent = label;
        social.appendChild(anchor);
      };

      addSocial("Instagram", desktop.dataset.homeInstagramUrl);
      addSocial("Facebook", desktop.dataset.homeFacebookUrl);

      body.append(kicker, heading, copy, linksLabel, links, social);
      note.append(tapeLeft, tapeRight, body);

      const icons = desktop.querySelector(".desktop-icons-grid");
      desktop.insertBefore(note, icons || desktop.firstChild);
    }

    note.classList.remove("hidden");
    note.removeAttribute("aria-hidden");
    return note;
  }

  window.GHEnsureHomeStickyNote = ghEnsureHomeStickyNote;

  function ghSetXpHomeRoute() {
    const currentUrl = window.location.pathname + window.location.search + window.location.hash;
    if (currentUrl === "/") {
      ghEnsureHomeStickyNote();
      return false;
    }

    window.history.replaceState(
      { ghXpRoute: true, type: "desktop-home" },
      "",
      "/"
    );

    ghEnsureHomeStickyNote();
    return true;
  }

  window.GHSetXpHomeRoute = ghSetXpHomeRoute;

  function ghInfoRouteConfig(pageId) {
    const routes = {
      customOrderPage: {
        pageId: "customOrderPage",
        targetPageId: "infoCustomOrderPage",
        title: ghThemeText("customOrderWindowTitle", "Custom Jewelry Order"),
        href: ghThemeText("customOrderPageUrl", "/pages/custom-jewelry")
      },
      customGrillzPage: {
        pageId: "customGrillzPage",
        targetPageId: "infoCustomGrillzPage",
        title: ghThemeText("customGrillzWindowTitle", "Custom Grillz"),
        href: ghThemeText("customGrillzPageUrl", "/pages/custom-grillz")
      },
      aboutPage: {
        pageId: "aboutPage",
        targetPageId: "infoAboutPage",
        title: ghThemeText("aboutWindowTitle", "About Me"),
        href: ghThemeText("aboutPageUrl", "/pages/about-goldhearted")
      },
      customInfoPage: {
        pageId: "customInfoPage",
        targetPageId: "infoCustomInfoPage",
        title: ghThemeText("customInfoWindowTitle", "GoldHearted EDU"),
        href: ghThemeText("customInfoPageUrl", "/pages/goldhearted-edu")
      },
      faqPage: {
        pageId: "faqPage",
        targetPageId: "infoFaqPage",
        title: ghThemeText("faqWindowTitle", "FAQ"),
        href: ghThemeText("faqPageUrl", "/pages/faq")
      },
      policiesPage: {
        pageId: "policiesPage",
        targetPageId: "infoPoliciesPage",
        title: ghThemeText("policiesWindowTitle", "GoldHearted Policies"),
        href: ghThemeText("policiesPageUrl", "/pages/privacy-policy")
      },
      genericPage: {
        pageId: "genericPage",
        targetPageId: "infoGenericPage",
        title: ghThemeText("genericWindowTitle", "GoldHearted"),
        href: ghThemeText("genericPageUrl", "")
      },
      allProductsPage: {
        pageId: "allProductsPage",
        targetPageId: "infoAllProductsPage",
        title: ghThemeText("allProductsWindowTitle", "All Products"),
        href: ghThemeText("allProductsPageUrl", "/collections/all")
      }
    };

    return routes[pageId] || null;
  }

  function ghInfoRouteFromPath(pathname) {
    const cleanPath = ghCleanRoutePath(pathname);
    const routeIds = ["customOrderPage", "customGrillzPage", "aboutPage", "customInfoPage", "faqPage", "policiesPage", "genericPage", "allProductsPage"];

    for (const pageId of routeIds) {
      const route = ghInfoRouteConfig(pageId);
      if (!route || !route.href) continue;

      try {
        const routePath = ghCleanRoutePath(new URL(route.href, window.location.href).pathname);
        if (routePath === cleanPath) return route;
      } catch (error) {}
    }

    return null;
  }

  const GH_XP_NAV_STACK_KEY = "ghXpFreshNavStackV85";
  const GH_XP_WINDOW_RESTORE_KEY = "ghXpWindowRestoreV85";

  function ghReadFreshNavStack() {
    try {
      const parsed = JSON.parse(window.sessionStorage.getItem(GH_XP_NAV_STACK_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function ghWriteFreshNavStack(stack) {
    try {
      window.sessionStorage.setItem(GH_XP_NAV_STACK_KEY, JSON.stringify((stack || []).slice(-24)));
    } catch (error) {}
  }

  function ghRememberFreshPreviousUrl(targetHref) {
    let targetUrl = null;
    try { targetUrl = new URL(targetHref, window.location.href); } catch (error) {}
    if (!targetUrl || targetUrl.origin !== window.location.origin) return;

    const currentUrl = window.location.href;
    if (currentUrl === targetUrl.href) return;

    const stack = ghReadFreshNavStack();
    if (!stack.length || stack[stack.length - 1] !== currentUrl) {
      stack.push(currentUrl);
      ghWriteFreshNavStack(stack);
    }
  }

  function ghPopFreshPreviousUrl() {
    const stack = ghReadFreshNavStack();
    while (stack.length) {
      const candidate = stack.pop();
      if (candidate && candidate !== window.location.href) {
        ghWriteFreshNavStack(stack);
        return candidate;
      }
    }
    ghWriteFreshNavStack([]);
    return "";
  }

  function ghReturnBrowserRouteToDesktopAfterClose() {
    /*
      Closing an XP route-backed app means the customer is back on the desktop.
      Use replaceState (not pushState) so closing a window does not create an
      extra Back-button step, while a refresh now correctly loads the homepage.
    */
    try {
      const currentState = window.history.state || {};
      window.history.replaceState(
        Object.assign({}, currentState, { ghXpRoute: true, type: "desktop", page: "desktop" }),
        "",
        "/"
      );
    } catch (error) {}

    ghEnsureHomeStickyNote();
    window.setTimeout(() => window.GHActivateTopVisibleWindow?.(), 0);
  }

  window.GHReturnBrowserRouteToDesktopAfterClose = ghReturnBrowserRouteToDesktopAfterClose;

  function ghCaptureVisibleWindowSnapshot() {
    const snapshot = { savedAt: Date.now() };
    const productWindow = document.getElementById("window");
    const namechainWindow = document.getElementById("namechainWindow");
    const aimWindowEl = document.getElementById("aimWindow");
    const metalWindowEl = document.getElementById("metalWindow");

    if (productWindow && !productWindow.classList.contains("hidden")) {
      const route = typeof ghGetProductRouteForCurrentWindow === "function"
        ? ghGetProductRouteForCurrentWindow()
        : null;
      snapshot.shopping = route && route.href ? {
        href: route.href,
        state: route.state || {},
        minimized: productWindow.classList.contains("minimized")
      } : null;
    }

    if (namechainWindow && !namechainWindow.classList.contains("hidden")) {
      snapshot.namechain = { minimized: namechainWindow.classList.contains("minimized") };
    }
    if (aimWindowEl && !aimWindowEl.classList.contains("hidden")) {
      snapshot.messenger = { minimized: aimWindowEl.classList.contains("minimized") };
    }
    if (metalWindowEl && !metalWindowEl.classList.contains("hidden")) {
      snapshot.metal = { minimized: metalWindowEl.classList.contains("minimized") };
    }

    return snapshot;
  }

  function ghSaveWindowSnapshotForNextRoute() {
    try {
      window.sessionStorage.setItem(
        GH_XP_WINDOW_RESTORE_KEY,
        JSON.stringify(ghCaptureVisibleWindowSnapshot())
      );
    } catch (error) {}
  }

  function ghTakeWindowSnapshotForRestore() {
    try {
      const raw = window.sessionStorage.getItem(GH_XP_WINDOW_RESTORE_KEY);
      window.sessionStorage.removeItem(GH_XP_WINDOW_RESTORE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.savedAt || Date.now() - parsed.savedAt > 120000) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function ghOpenInfoRoute(pageId, options = {}) {
    const route = ghInfoRouteConfig(pageId);
    if (!route) return false;

    let targetUrl = null;
    let targetPath = "";
    try {
      targetUrl = new URL(route.href, window.location.href);
      targetPath = ghCleanRoutePath(targetUrl.pathname);
    } catch (error) {}

    const currentPath = ghCleanRoutePath(window.location.pathname);

    /*
      IMPORTANT: the XP desktop section exists on several Shopify templates.
      Shopify stores section settings per template, so opening an info page only
      with pushState could display the copy/images that were embedded in the
      page we came FROM instead of the newest settings saved on the destination
      page template. A real same-origin navigation guarantees Shopify renders
      the destination route's current section settings every time.

      Direct-route startup and browser-history replay call this with push:false;
      those cases should simply reveal the server-rendered page already in DOM.
    */
    if (options.push !== false && targetUrl && targetUrl.origin === window.location.origin && targetPath !== currentPath) {
      ghRememberFreshPreviousUrl(targetUrl.href);
      ghSaveWindowSnapshotForNextRoute();
      window.location.assign(targetUrl.href);
      return true;
    }

    if (options.push !== false && targetPath === currentPath) {
      window.history.replaceState(
        { ghXpRoute: true, type: "info", page: pageId },
        "",
        targetUrl ? (targetUrl.pathname + targetUrl.search + targetUrl.hash) : route.href
      );
    }

    let addressText = route.href;
    try {
      addressText = targetUrl ? targetUrl.href : new URL(route.href, window.location.href).href;
    } catch (error) {}

    openInfoWindow(route.targetPageId, route.title, addressText);
    return true;
  }

  window.GHOpenInfoRoute = ghOpenInfoRoute;

  /*
    Chrome/Safari can restore this custom desktop from the back-forward cache
    exactly as it looked before navigation. Because this theme intentionally
    behaves like a small single-page desktop, that restored DOM can contain an
    older copy of route-specific section content. For real SEO routes, prefer a
    fresh Shopify render whenever the browser restores a frozen page snapshot.
  */
  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;

    // A forced reload made the homepage note/icons visibly disappear and then
    // reappear on mobile. Re-sync the restored XP state in-place instead.
    ghEnsureHomeStickyNote();

    window.requestAnimationFrame(() => {
      try { ghReplayShoppingRouteFromBrowser(); } catch (error) {}

      window.setTimeout(() => {
        ghEnsureHomeStickyNote();
        window.GHActivateTopVisibleWindow?.();
      }, 0);
    });
  });

  /* =========================
     EARLY BROWSER HISTORY BRIDGE
     Register this before the rest of the XP app initializes. Back/Forward
     should replay the same UI actions as a normal desktop shortcut click,
     so the URL and the visible shopping-slot window can never drift apart.
  ========================= */

  function ghReplayShoppingRouteFromBrowser() {
    if (ghNormalizeLegacyTemplateRouteInPlace()) {
      ghEnsureHomeStickyNote();
      window.setTimeout(() => window.GHActivateTopVisibleWindow?.(), 0);
      return;
    }

    const cleanPath = ghCleanRoutePath(window.location.pathname);
    const replayState = window.history.state || {};
    ghEnsureHomeStickyNote();

    /*
      Product pages have their own small interaction history now. The browser's
      real Back/Forward buttons can replay toolbar changes (metal, 3D, media,
      gallery) without leaving the product route. These entries intentionally
      keep the same SEO URL; the state object is what remembers the visible UI.
    */
    if (replayState.ghProductInternal) {
      const productStateMatch = cleanPath.match(/^\/products\/([^/]+)$/i);
      const stateHandle = String(replayState.productHandle || "").trim();
      const routeHandle = productStateMatch ? decodeURIComponent(productStateMatch[1]) : "";

      if (productStateMatch && stateHandle && stateHandle === routeHandle) {
        const activeHandle = typeof getActiveProductHandle === "function"
          ? String(getActiveProductHandle() || "")
          : "";

        if (activeShopifyProduct && activeHandle === stateHandle) {
          window.requestAnimationFrame(() => {
            ghApplyProductInternalHistoryState(replayState);
          });
          return;
        }

        // If Back/Forward re-enters this product from another route, let the
        // normal product resolver open it first, then apply this exact state.
        window.__ghPendingProductInternalState = replayState;
      }
    }

    const productWindow = document.getElementById("window");
    const namechainWindow = document.getElementById("namechainWindow");
    const productTask = document.getElementById("rings-task");
    const namechainTask = document.getElementById("namechain-task");

    function hideShoppingSlot() {
      [productWindow, namechainWindow].forEach((target) => {
        if (!target) return;
        target.classList.add("hidden");
        target.classList.remove("minimized", "active-window");
      });

      [productTask, namechainTask].forEach((target) => {
        if (!target) return;
        target.classList.add("hidden");
        target.classList.remove("active-task");
      });
    }

    function hideInfoSlot() {
      if (infoWindow) {
        infoWindow.classList.add("hidden");
        infoWindow.classList.remove("minimized", "active-window");
      }

      if (infoTask) {
        infoTask.classList.add("hidden");
        infoTask.classList.remove("active-task");
      }
    }

    const cleanHash = String(window.location.hash || "").toLowerCase();
    const utilityHash = ghNormalizeUtilityHash(cleanHash);

    if (cleanPath === "/" && cleanHash === "#email-signup") {
      window.requestAnimationFrame(() => {
        openInfoWindow(
          "infoEmailSignupPage",
          ghThemeText("emailSignupWindowTitle", "Email Signup"),
          window.location.origin + "/#email-signup"
        );
      });
      return;
    }

    const infoRoute = ghInfoRouteFromPath(cleanPath);
    if (infoRoute) {
      window.requestAnimationFrame(() => {
        ghOpenInfoRoute(infoRoute.pageId, { push: false });
        ghScheduleUtilityWindowForHash(utilityHash, 0);
      });
      return;
    }

    const desktop = document.getElementById("desktop");
    let namechainPath = "/pages/custom-name-chain";
    const configuredNamechainUrl = desktop && desktop.dataset
      ? desktop.dataset.namechainPageUrl
      : "";

    if (configuredNamechainUrl) {
      try {
        namechainPath = ghCleanRoutePath(
          new URL(configuredNamechainUrl, window.location.href).pathname
        );
      } catch (error) {}
    }

    if (cleanPath === "/") {
      hideInfoSlot();
      hideShoppingSlot();
      if (!ghScheduleUtilityWindowForHash(utilityHash, 0)) {
        window.setTimeout(() => window.GHActivateTopVisibleWindow?.(), 0);
      }
      return;
    }

    if (cleanPath === namechainPath) {
      hideInfoSlot();
      hideShoppingSlot();

      window.requestAnimationFrame(() => {
        if (typeof window.GHOpenNameChainWindow === "function") {
          window.GHOpenNameChainWindow();
          ghScheduleUtilityWindowForHash(utilityHash, 0);
          return;
        }

        const launcher = document.querySelector(
          '.gh-namechain-launcher[href], [data-namechain-launcher="true"][href]'
        );
        if (launcher) launcher.click();
        ghScheduleUtilityWindowForHash(utilityHash, 30);
      });
      return;
    }

    const productMatch = cleanPath.match(/^\/products\/([^/]+)$/i);
    if (productMatch) {
      const handle = decodeURIComponent(productMatch[1]);
      hideInfoSlot();
      hideShoppingSlot();

      window.requestAnimationFrame(() => {
        const productShortcuts = Array.from(document.querySelectorAll(
          '.featured-product-desktop-icon[data-featured-product-handle], ' +
          '.collection-product-shortcut[data-shopify-product-handle], ' +
          '.desktop-product-shortcut[data-shopify-product-handle], ' +
          '.desktop-product-shortcut[data-featured-product-handle]'
        ));

        const shortcut = productShortcuts.find((candidate) => {
          const featuredHandle = String(candidate.dataset.featuredProductHandle || "").trim();
          const shopifyHandle = String(candidate.dataset.shopifyProductHandle || "").trim();
          return featuredHandle === handle || shopifyHandle === handle;
        });

        if (shortcut) {
          shortcut.dispatchEvent(new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
          }));
          ghScheduleUtilityWindowForHash(utilityHash, 0);
          return;
        }

        // If this product is not represented by a shortcut in the current DOM,
        // resolve it directly from Shopify. This keeps browser Back/Forward smooth
        // instead of forcing a visible reload just because that product shortcut
        // is not present in the current route's server-rendered DOM.
        const existingProduct = typeof findDynamicProductByHandle === "function"
          ? findDynamicProductByHandle(handle)
          : null;

        const openResolvedProduct = (resolvedProduct) => {
          if (!resolvedProduct) return false;
          resolvedProduct.taskLabel = resolvedProduct.title || "Product";
          openDynamicShopifyProduct(resolvedProduct, "desktop");
          ghScheduleUtilityWindowForHash(utilityHash, 0);
          return true;
        };

        if (openResolvedProduct(existingProduct)) return;

        if (typeof fetchFeaturedProductByHandle === "function") {
          fetchFeaturedProductByHandle(handle, "", {})
            .then((resolvedProduct) => {
              if (ghCleanRoutePath(window.location.pathname) !== cleanPath) return;
              if (openResolvedProduct(resolvedProduct)) return;

              // A genuinely old/deleted product may still exist in browser history.
              // Do not refresh-loop the desktop; leave the URL/history stable and
              // let the next Back/Forward action continue normally.
            })
            .catch(() => {});
        }
      });
      return;
    }

    const collectionMatch = cleanPath.match(/^\/collections\/([^/]+)$/i);
    if (collectionMatch) {
      hideInfoSlot();
      hideShoppingSlot();

      window.requestAnimationFrame(() => {
        const currentPath = ghCleanRoutePath(window.location.pathname);
        const collectionLinks = Array.from(document.querySelectorAll(
          'a[href*="/collections/"]'
        ));

        const launcher = collectionLinks.find((candidate) => {
          try {
            return ghCleanRoutePath(
              new URL(candidate.getAttribute("href"), window.location.href).pathname
            ) === currentPath;
          } catch (error) {
            return false;
          }
        });

        if (launcher) {
          launcher.dispatchEvent(new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
          }));
          ghScheduleUtilityWindowForHash(utilityHash, 0);
          return;
        }

        window.location.reload();
      });
    }
  }

  // Register early. This is deliberately independent of the later product-fetch
  // restore code so a runtime issue elsewhere cannot leave only the address bar
  // changing while the old XP app remains visible.
  window.addEventListener("popstate", ghReplayShoppingRouteFromBrowser);
  window.GHReplayShoppingRouteFromBrowser = ghReplayShoppingRouteFromBrowser;

  function ghThemeText(settingName, fallbackText) {

    if (
      ghDesktop &&
      ghDesktop.dataset &&
      ghDesktop.dataset[settingName]
    ) {
      return ghDesktop.dataset[settingName];
    }

    return fallbackText;
  }

  function ghThemeAsset(settingName, fallbackUrl) {

    if (
      ghDesktop &&
      ghDesktop.dataset &&
      ghDesktop.dataset[settingName]
    ) {
      return ghDesktop.dataset[settingName];
    }

    return fallbackUrl;
  }

  function ghCssUrl(imageUrl) {
    return 'url("' + String(imageUrl).replace(/"/g, '\"') + '")';
  }

  function tryClickVisibleElement(selectors) {
    for (const selector of selectors) {
      const elements = Array.from(document.querySelectorAll(selector));
      for (const element of elements) {
        const rect = element.getBoundingClientRect();
        const style = window.getComputedStyle(element);
        if (rect.width > 0 && rect.height > 0 && style.display !== "none" && style.visibility !== "hidden") {
          try {
            element.click();
            return true;
          } catch (error) {}
        }
      }
    }
    return false;
  }

  function openShopifyInboxChat() {
    const inboxSelectors = [
      '[data-shopify-inbox]',
      '[data-shopify-chat]',
      '[aria-label*="chat" i]',
      '[aria-label*="message" i]',
      'button[class*="chat" i]',
      'button[class*="inbox" i]',
      'div[class*="chat" i] button',
      'iframe[src*="inbox.shopify"]'
    ];

    return tryClickVisibleElement(inboxSelectors);
  }

  function openEmailSignupApp() {
    const shopifyFormSelectors = [
      '[data-shopify-forms-modal-trigger]',
      '[data-shopify-forms-popup]',
      '[data-forms-trigger]',
      '[aria-label*="newsletter" i]',
      '[aria-label*="email" i]',
      'button[class*="newsletter" i]',
      'button[class*="forms" i]',
      'button[class*="signup" i]'
    ];

    if (tryClickVisibleElement(shopifyFormSelectors)) {
      return true;
    }

    if (window._klOnsite && openKlaviyoForm) {
      const formId = openKlaviyoForm.dataset.klaviyoFormId || "U3QMkU";
      window._klOnsite.push(["openForm", formId]);
      return true;
    }

    return false;
  }

  function escapeHtmlAttribute(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function getDefaultJudgeMeProduct() {
    if (!ghProductConfig || !ghProductConfig.cartProductId) return null;

    return {
      id: ghProductConfig.cartProductId,
      title: ghProductConfig.cartProductTitle || ghProductConfig.productTitle || "Product",
      url: ghProductConfig.cartProductUrl || ghProductConfig.productAddress || "",
      judgemeWidgetHtml: ghProductConfig.cartProductJudgemeWidgetHtml || "",
      judgemeReviewWidgetData: ghProductConfig.cartProductJudgemeReviewWidgetData || null
    };
  }

  function buildJudgeMeWidgetHtml(product) {
    const reviewProduct = product || getDefaultJudgeMeProduct();

    if (!reviewProduct || !reviewProduct.id) {
      return '<div class="judge-me-loading-note">Choose a Shopify product to load live Judge.me reviews.</div>';
    }

    const productId = escapeHtmlAttribute(reviewProduct.id);
    const productTitle = escapeHtmlAttribute(reviewProduct.title || "Product");
    const shopReviewsCount = escapeHtmlAttribute((ghProductConfig && ghProductConfig.shopJudgemeReviewsCount) || 0);
    const legacyHtml = reviewProduct.judgemeWidgetHtml && String(reviewProduct.judgemeWidgetHtml).trim().length > 20
      ? String(reviewProduct.judgemeWidgetHtml)
      : '';

    return (
      '<div style="clear:both"></div>' +
      '<div id="judgeme_product_reviews" class="jdgm-widget jdgm-review-widget" ' +
      'data-product-title="' + productTitle + '" ' +
      'data-id="' + productId + '" ' +
      'data-product-id="' + productId + '" ' +
      'data-widget="review" ' +
      'data-auto-install="false" ' +
      'data-shop-reviews-count="' + shopReviewsCount + '" ' +
      'data-entry-point="review_widget.js" ' +
      'data-entry-key="review-widget/main.js">' +
      (legacyHtml ? '<div class="jdgm-legacy-widget-content" style="display:none;">' + legacyHtml + '</div>' : '') +
      '</div>'
    );
  }

  function refreshJudgeMeWidget(product) {
    try {
      window.jdgm = window.jdgm || {};

      if (product && product.id && product.judgemeReviewWidgetData) {
        window.jdgm.data = window.jdgm.data || {};
        window.jdgm.data.reviewWidget = window.jdgm.data.reviewWidget || {};
        window.jdgm.data.reviewWidget[product.id] = product.judgemeReviewWidgetData;
      }

      [0, 250, 900, 1800].forEach((delay) => {
        window.setTimeout(() => {
          try {
            if (window.jdgm) {
              if (typeof window.jdgm.initWidgets === "function") window.jdgm.initWidgets();
              if (typeof window.jdgm.initializeWidgets === "function") window.jdgm.initializeWidgets();
              if (typeof window.jdgm.renderWidgets === "function") window.jdgm.renderWidgets();
              if (typeof window.jdgm.loadAll === "function") window.jdgm.loadAll();
            }
            document.dispatchEvent(new CustomEvent("judgeme:refresh"));
          } catch (error) {}
        }, delay);
      });
    } catch (error) {}
  }

  function updateReviewAppLinks(product) {
    /*
      FRIDAY STABLE FALLBACK:
      Use one shared GoldHearted Judge.me review wall for every XP product.
      The widget stays tied to the real Shopify product selected in the XP Desktop
      section settings, so it does not break when different XP products are opened.
    */
    const reviewProduct = getDefaultJudgeMeProduct();
    const productUrl =
      (reviewProduct && reviewProduct.url) ||
      (ghProductConfig && ghProductConfig.productAddress) ||
      "/products";

    const reviewUrl = String(productUrl) + "#judgeme_product_reviews";

    if (ghReadReviewsLink) {
      ghReadReviewsLink.href = reviewUrl;
    }

    if (ghLeaveReviewLink) {
      ghLeaveReviewLink.href = reviewUrl;
    }

    if (judgeMeWidgetShell) {
      if (!(judgeMeWidgetShell.dataset && judgeMeWidgetShell.dataset.ghServerRendered === "true")) {
        judgeMeWidgetShell.innerHTML = buildJudgeMeWidgetHtml(reviewProduct);
        if (judgeMeWidgetShell.dataset) {
          judgeMeWidgetShell.dataset.ghCurrentProductId = reviewProduct && reviewProduct.id ? String(reviewProduct.id) : "";
          judgeMeWidgetShell.dataset.ghServerRendered = "false";
        }
      }
      refreshJudgeMeWidget(reviewProduct);
    }
  }

  const windowContent = document.querySelector(".window-content");

  const toolbar = document.querySelector(".xp-toolbar");
  const addressBar = document.querySelector(".xp-address-bar");

  const productLayout = document.querySelector(".product-layout");
  const relatedProducts = document.querySelector(".related-products");

  const viewerBtn = document.getElementById("viewerBtn");
  const backBtn = document.getElementById("backBtn");
  const viewer3d = document.getElementById("viewer3d");
  const viewerLoading = document.getElementById("viewerLoading");
  const modelViewer = document.querySelector("model-viewer");
  let ghModelViewerLoadPromise = null;

  function ensureModelViewerComponent() {
    if (!modelViewer) return Promise.resolve();
    if (window.customElements && window.customElements.get("model-viewer")) return Promise.resolve();
    if (ghModelViewerLoadPromise) return ghModelViewerLoadPromise;

    ghModelViewerLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.type = "module";
      script.src = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      script.dataset.ghModelViewer = "true";
      script.onload = () => resolve();
      script.onerror = () => {
        ghModelViewerLoadPromise = null;
        reject(new Error("3D viewer component failed to load."));
      };
      document.head.appendChild(script);
    });

    return ghModelViewerLoadPromise;
  }

  const ghProductConfig = window.GH_PRODUCT_CONFIG || {};

  if (modelViewer && ghProductConfig.modelUrl) {
    modelViewer.setAttribute("src", ghProductConfig.modelUrl);
  }

  const mediaBtn = document.getElementById("mediaBtn");
  const wmpPlayer = document.getElementById("wmpPlayer");
  const viewerToolbarItem = viewerBtn ? viewerBtn.closest(".toolbar-item") : null;
  const mediaToolbarItem = mediaBtn ? mediaBtn.closest(".toolbar-item") : null;
  let activeProductHasModel = !!(ghProductConfig.modelUrl);
  let activeProductHasVideos = true;

  const oldInfoPages = document.querySelectorAll(".xp-info-page");

  const startPageLinks = document.querySelectorAll(".start-page-link, .gh-legal-page-link");
  const startSocialLinks = document.querySelectorAll(".start-social-link");
  const startEmailSignup = document.querySelector(".start-email-signup");
  const openKlaviyoForm = document.getElementById("openKlaviyoForm");
  const ghReadReviewsLink = document.getElementById("ghReadReviewsLink");
  const ghLeaveReviewLink = document.getElementById("ghLeaveReviewLink");
  const judgeMeWidgetShell = document.getElementById("judgeMeWidgetShell");

  const photoGallery = document.getElementById("photoGallery");

  let viewerLoaded = false;


  /* =========================
     WMP ELEMENTS
  ========================= */

  const video = document.getElementById("wmpVideo");

  let wmpChromeHydrated = false;
  function hydrateWmpChrome() {
    if (wmpChromeHydrated || !wmpPlayer) return;
    wmpChromeHydrated = true;
    wmpPlayer.querySelectorAll("img[data-src]").forEach((img) => {
      const src = img.getAttribute("data-src");
      if (!src) return;
      img.src = src;
      img.removeAttribute("data-src");
    });
  }

  const playPause = document.getElementById("playPause");
  const playOverlay = document.getElementById("playOverlay");
  const pauseOverlay = document.getElementById("pauseOverlay");

  const stopVideo = document.getElementById("stopVideo");
  const nextVideo = document.getElementById("nextVideo");
  const prevVideo = document.getElementById("prevVideo");
  const backToProduct = document.getElementById("backToProduct");
  const scrubber = document.getElementById("videoScrubber");
  const scrubberThumb = document.getElementById("scrubberThumb");

  const oldBackupVideos = [
    "https://cdn.shopify.com/videos/c/o/v/407a47c6fdd9449ca081eddfd8bd55db.mp4",
    "https://cdn.shopify.com/videos/c/o/v/524c20a7c9184d348c0d173dac81dd37.mp4",
    "https://cdn.shopify.com/videos/c/o/v/db4ee720211047e2b978c55edff17926.mp4"
  ];

  const rawPlaylist = (ghProductConfig.playlist && ghProductConfig.playlist.length)
    ? ghProductConfig.playlist.filter(Boolean)
    : oldBackupVideos;

  /*
    IMPORTANT:
    Shopify may keep old default videos in slot 2 and 3.
    We keep video slot 1 as the main/default video, but remove the old backup videos
    from slot 2 and 3 unless the user replaces them with new custom links.
  */
  const defaultPlaylist = rawPlaylist.filter((videoUrl, index) => {
    if (index === 0) return true;
    return !oldBackupVideos.includes(videoUrl);
  });

  let playlist = defaultPlaylist.slice();
  let currentVideo = 0;


  const GH_FALLBACK_IMAGE_URL = "https://cdn.shopify.com/s/files/1/0558/0180/6884/files/Small_Logo.png?v=1738205645";

  /* =========================
     PRODUCT ELEMENTS
  ========================= */

  const goldBtn = document.getElementById("goldBtn");
  const silverBtn = document.getElementById("silverBtn");

  const productImage = document.getElementById("productImage");
  const productTitle = document.getElementById("productTitle");
  const productPrice = document.getElementById("productPrice");
  const productDescription = document.getElementById("productDescription");
  const productWindowIcon = document.getElementById("productWindowIcon");
  const productWindowTitleText = document.getElementById("productWindowTitleText");
  const addToCartBtn = document.getElementById("addToCartBtn");
  const productQuantity = document.getElementById("productQuantity");
  const productGemstone = document.getElementById("productGemstone");
  const productThirdOption = document.getElementById("productThirdOption");
  const productOrderNote = document.getElementById("productOrderNote");
  const productNoteGroup = document.getElementById("productNoteGroup");
  const productOrderNoteLabel = document.getElementById("productOrderNoteLabel");
  const productOrderNoteHelp = document.getElementById("productOrderNoteHelp");
  const productOptionsContainer = document.querySelector(".product-options");
  const cartStatus = document.getElementById("cartStatus");
  const cartButtons = document.querySelectorAll(".cart-btn");
  const cartBadges = document.querySelectorAll("[data-cart-count-badge]");

  let currentMaterial = "gold";
  let autoMetalOptionIndex = null;
  let selectedAutomaticMetalValue = "";
  let automaticMetalToolbarItems = [];

  const goldProduct = {
    id: ghProductConfig.cartProductId || null,
    title: ghProductConfig.productTitle || "Interlocking Pendant",
    price: ghProductConfig.goldPrice || "$2,480",
    image: ghProductConfig.goldImage || GH_FALLBACK_IMAGE_URL,
    url: ghProductConfig.cartProductUrl || ghProductConfig.productAddress || "",
    judgemeWidgetHtml: ghProductConfig.cartProductJudgemeWidgetHtml || "",
    judgemeReviewWidgetData: ghProductConfig.cartProductJudgemeReviewWidgetData || null,
    xpAddToCartLabel: ghProductConfig.productAddToCartLabel || ""
  };

  const silverProduct = {
    id: ghProductConfig.cartProductId || null,
    title: ghProductConfig.productTitle || "Interlocking Pendant",
    price: ghProductConfig.silverPrice || "$1,680",
    image: ghProductConfig.silverImage || GH_FALLBACK_IMAGE_URL,
    url: ghProductConfig.cartProductUrl || ghProductConfig.productAddress || "",
    judgemeWidgetHtml: ghProductConfig.cartProductJudgemeWidgetHtml || "",
    judgemeReviewWidgetData: ghProductConfig.cartProductJudgemeReviewWidgetData || null,
    xpAddToCartLabel: ghProductConfig.productAddToCartLabel || ""
  };

  const defaultProductNoteSource = {
    xpNotesEnabled: !!ghProductConfig.productNotesEnabled,
    xpNotesLabel: ghProductConfig.productNotesLabel || "",
    xpNotesPlaceholder: ghProductConfig.productNotesPlaceholder || "",
    xpNotesHelp: ghProductConfig.productNotesHelp || ""
  };


  /* =========================
     CART COUNT / BADGE
  ========================= */

  function setCartCount(count) {
    const safeCount = Number.isFinite(Number(count)) ? Number(count) : 0;
    const displayCount = safeCount > 99 ? "99+" : String(safeCount);

    if (cartBadges && cartBadges.length) {
      cartBadges.forEach((badge) => {
        badge.textContent = displayCount;
        badge.classList.toggle("hidden", safeCount <= 0);
      });
    }

    if (cartButtons && cartButtons.length) {
      cartButtons.forEach((button) => {
        button.classList.toggle("has-cart-items", safeCount > 0);
      });
    }

    const desktopCartIcon = document.getElementById("openCartDesktop");
    if (desktopCartIcon) {
      desktopCartIcon.classList.toggle("has-cart-items", safeCount > 0);
    }
  }

  async function refreshCartCount() {
    try {
      const response = await fetch(getCartRoot() + "cart.js", {
        headers: {
          "Accept": "application/json"
        },
        cache: "no-store"
      });

      if (!response.ok) return;

      const cartData = await response.json();
      setCartCount(cartData && typeof cartData.item_count !== "undefined" ? cartData.item_count : 0);
    } catch (error) {
      // Keep the existing Liquid-rendered count if the live cart check fails.
    }
  }

  /* =========================
     REAL SHOPIFY ADD TO CART
  ========================= */

  let cartVariants = Array.isArray(ghProductConfig.cartVariants)
    ? ghProductConfig.cartVariants
    : [];

  const dynamicProducts = [];

  if (ghProductConfig.currentProduct && ghProductConfig.currentProduct.handle) {
    dynamicProducts.push(ghProductConfig.currentProduct);
  }

  if (Array.isArray(ghProductConfig.featuredProducts)) {
    ghProductConfig.featuredProducts.forEach((product) => {
      if (!product || !product.handle) return;
      if (!dynamicProducts.some((existing) => existing && existing.handle === product.handle)) {
        dynamicProducts.push(product);
      }
    });
  }

  if (Array.isArray(ghProductConfig.dynamicProducts)) {
    ghProductConfig.dynamicProducts.forEach((product) => {
      if (!product || !product.handle) return;
      if (!dynamicProducts.some((existing) => existing && existing.handle === product.handle)) {
        dynamicProducts.push(product);
      }
    });
  }

  let activeShopifyProduct = null;
  let productBackTarget = "collection";
  let automaticVariantControls = [];

  function getActiveProductHandle() {
    return activeShopifyProduct
      ? activeShopifyProduct.handle
      : ghProductConfig.cartProductHandle;
  }

  function activeProductHasOnlyDefaultVariant() {
    return !!(activeShopifyProduct
      ? activeShopifyProduct.hasOnlyDefaultVariant
      : ghProductConfig.cartProductHasOnlyDefaultVariant);
  }

  function findDynamicProductByHandle(handle) {
    const cleanHandle = String(handle || "");
    return dynamicProducts.find((product) => product && product.handle === cleanHandle) || null;
  }

  function formatGhMoneyFromCents(cents) {
    const amount = Number(cents || 0) / 100;
    return "$" + amount.toLocaleString(undefined, {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function stripGhHtml(html) {
    const temp = document.createElement("div");
    temp.innerHTML = String(html || "");
    return temp.textContent.replace(/\s+/g, " ").trim();
  }

  function normalizeGhProductImage(image) {
    if (!image) return null;
    if (typeof image === "string") return image;
    return image.src || image.url || null;
  }

  async function fetchFeaturedProductByHandle(handle, iconUrl, mediaOptions = {}) {
    const cleanHandle = String(handle || "").trim();
    if (!cleanHandle) return null;

    const manualModelUrl = String(mediaOptions.modelUrl || "").trim();
    const manualVideos = normalizeMediaList(mediaOptions.videos || []);
    const manualDonationNote = String(mediaOptions.donationNote || "").trim();
    const manualDonationLinkLabel = String(mediaOptions.donationLinkLabel || "").trim();
    const manualDonationLinkUrl = String(mediaOptions.donationLinkUrl || "").trim();
    const manualFundraiserEnabled = ghIsTrueLike(mediaOptions.fundraiserEnabled);
    const manualFundraiserTitle = String(mediaOptions.fundraiserTitle || "").trim();
    const manualFundraiserNonprofitName = String(mediaOptions.fundraiserNonprofitName || "").trim();
    const manualFundraiserNonprofitUrl = String(mediaOptions.fundraiserNonprofitUrl || "").trim();
    const manualFundraiserGoalRaw = String(mediaOptions.fundraiserGoal ?? "").trim();
    const manualFundraiserRaisedRaw = String(mediaOptions.fundraiserRaised ?? "").trim();
    const manualFundraiserPerSaleRaw = String(mediaOptions.fundraiserPerSale ?? "").trim();
    const manualFundraiserPerSaleSilverRaw = String(mediaOptions.fundraiserPerSaleSilver ?? "").trim();
    const manualFundraiserPerSaleGoldRaw = String(mediaOptions.fundraiserPerSaleGold ?? "").trim();
    const manualFundraiserPerSalePlatinumRaw = String(mediaOptions.fundraiserPerSalePlatinum ?? "").trim();
    const manualFundraiserGoal = Number(manualFundraiserGoalRaw || 0);
    const manualFundraiserRaised = Number(manualFundraiserRaisedRaw || 0);
    const manualFundraiserPerSale = Number(manualFundraiserPerSaleRaw || 0);
    const manualFundraiserPerSaleSilver = Number(manualFundraiserPerSaleSilverRaw || 0);
    const manualFundraiserPerSaleGold = Number(manualFundraiserPerSaleGoldRaw || 0);
    const manualFundraiserPerSalePlatinum = Number(manualFundraiserPerSalePlatinumRaw || 0);
    const manualFundraiserBlurb = String(mediaOptions.fundraiserBlurb || "").trim();
    const manualFundraiserLogoUrl = String(mediaOptions.fundraiserLogoUrl || "").trim();
    const manualFundraiserCurrency = String(mediaOptions.fundraiserCurrency || "").trim();
    const manualNotesEnabled = mediaOptions.notesEnabled;
    const manualNotesLabel = String(mediaOptions.notesLabel || "").trim();
    const manualNotesPlaceholder = String(mediaOptions.notesPlaceholder || "").trim();
    const manualNotesHelp = String(mediaOptions.notesHelp || "").trim();
    const manualCartButtonLabel = String(mediaOptions.cartButtonLabel || "").trim();

    function hasManualNotes() {
      return ghIsTrueLike(manualNotesEnabled) || !!manualNotesLabel || !!manualNotesPlaceholder || !!manualNotesHelp;
    }

    function applyManualNotes(product) {
      if (!product || !hasManualNotes()) return product;
      product.xpNotesEnabled = ghIsTrueLike(manualNotesEnabled) || product.xpNotesEnabled || !!manualNotesLabel || !!manualNotesPlaceholder || !!manualNotesHelp;
      product.xpNotesLabel = manualNotesLabel || product.xpNotesLabel || "";
      product.xpNotesPlaceholder = manualNotesPlaceholder || product.xpNotesPlaceholder || "";
      product.xpNotesHelp = manualNotesHelp || product.xpNotesHelp || "";
      return product;
    }

    function applyManualCartButtonLabel(product) {
      if (!product || !manualCartButtonLabel) return product;
      product.xpAddToCartLabel = manualCartButtonLabel;
      return product;
    }

    function hasManualFundraiser() {
      return manualFundraiserEnabled ||
        (Number.isFinite(manualFundraiserGoal) && manualFundraiserGoal > 0) ||
        (Number.isFinite(manualFundraiserRaised) && manualFundraiserRaised > 0) ||
        !!manualFundraiserNonprofitName ||
        !!manualFundraiserBlurb ||
        !!manualFundraiserLogoUrl;
    }

    function applyManualFundraiser(product) {
      if (!product || !hasManualFundraiser()) return product;

      const existing = product.xpFundraiser && typeof product.xpFundraiser === "object"
        ? product.xpFundraiser
        : {};

      const goal = Number.isFinite(manualFundraiserGoal) ? manualFundraiserGoal : Number(existing.goal || 0);
      const raised = Number.isFinite(manualFundraiserRaised) ? manualFundraiserRaised : Number(existing.raised || 0);
      const perSale = Number.isFinite(manualFundraiserPerSale) ? manualFundraiserPerSale : Number(existing.perSale || 0);
      const perSaleSilver = Number.isFinite(manualFundraiserPerSaleSilver) && manualFundraiserPerSaleSilver > 0 ? manualFundraiserPerSaleSilver : Number(existing.perSaleSilver || 0);
      const perSaleGold = Number.isFinite(manualFundraiserPerSaleGold) && manualFundraiserPerSaleGold > 0 ? manualFundraiserPerSaleGold : Number(existing.perSaleGold || 0);
      const perSalePlatinum = Number.isFinite(manualFundraiserPerSalePlatinum) && manualFundraiserPerSalePlatinum > 0 ? manualFundraiserPerSalePlatinum : Number(existing.perSalePlatinum || 0);

      product.xpFundraiser = {
        enabled: manualFundraiserEnabled || goal > 0 || ghIsTrueLike(existing.enabled),
        title: manualFundraiserTitle || existing.title || "GoldHearted Giving Goal",
        nonprofitName: manualFundraiserNonprofitName || existing.nonprofitName || "",
        nonprofitUrl: manualFundraiserNonprofitUrl || existing.nonprofitUrl || "",
        goal: goal,
        raised: raised,
        perSale: perSale,
        perSaleSilver: perSaleSilver,
        perSaleGold: perSaleGold,
        perSalePlatinum: perSalePlatinum,
        blurb: manualFundraiserBlurb || existing.blurb || "",
        logoUrl: manualFundraiserLogoUrl || existing.logoUrl || "",
        currency: manualFundraiserCurrency || existing.currency || "USD"
      };

      return product;
    }

    const cached = findDynamicProductByHandle(cleanHandle);
    if (cached) {
      // A mobile/background warm-up can cache Shopify's featured image before the
      // Liquid shortcut is clicked. If the shortcut carries the product XP icon
      // metafield, let that replace the fallback featured image.
      if (iconUrl && (!cached.xpIcon || cached.xpIcon === cached.image)) {
        cached.xpIcon = iconUrl;
      }
      if (manualModelUrl) cached.xpModelUrl = manualModelUrl;
      if (manualVideos.length) cached.xpVideos = manualVideos;
      if (manualDonationNote) {
        cached.xpDonationNote = manualDonationNote;
        cached.xpDonationLinkLabel = manualDonationLinkLabel;
        cached.xpDonationLinkUrl = manualDonationLinkUrl;
      }
      applyManualNotes(cached);
      applyManualCartButtonLabel(cached);
      applyManualFundraiser(cached);
      return cached;
    }

    try {
      const dataResponse = await fetch(getCartRoot() + "products/" + encodeURIComponent(cleanHandle) + "?view=gh-xp-data", {
        headers: { "Accept": "application/json" }
      });

      if (dataResponse.ok) {
        const text = await dataResponse.text();
        const dynamicData = JSON.parse(text);
        if (dynamicData && dynamicData.handle) {
          // The dedicated xp_icon metafield is authoritative. A shortcut icon is
          // the next choice. If neither exists, use the clean GoldHearted logo
          // instead of borrowing a product image or any legacy placeholder.
          dynamicData.xpIcon = dynamicData.xpIcon || iconUrl || GH_FALLBACK_IMAGE_URL;
          if (manualModelUrl) dynamicData.xpModelUrl = manualModelUrl;
          if (manualVideos.length) dynamicData.xpVideos = manualVideos;
          if (manualDonationNote) {
            dynamicData.xpDonationNote = manualDonationNote;
            dynamicData.xpDonationLinkLabel = manualDonationLinkLabel;
            dynamicData.xpDonationLinkUrl = manualDonationLinkUrl;
          }
          applyManualNotes(dynamicData);
          applyManualCartButtonLabel(dynamicData);
          applyManualFundraiser(dynamicData);
          dynamicProducts.push(dynamicData);
          return dynamicData;
        }
      }
    } catch (error) {
      // Fall back to Shopify's public product JSON when the metafield view is unavailable.
    }

    const response = await fetch(getCartRoot() + "products/" + encodeURIComponent(cleanHandle) + ".js", {
      headers: { "Accept": "application/json" },
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error("Product not found");
    }

    const product = await response.json();
    const primaryImage = normalizeGhProductImage(product.featured_image) ||
      (Array.isArray(product.images) && product.images.length ? normalizeGhProductImage(product.images[0]) : null);

    const variants = Array.isArray(product.variants)
      ? product.variants.map((variant) => ({
          id: variant.id,
          title: variant.title || "Default Title",
          available: typeof variant.available === "undefined" ? true : !!variant.available,
          options: [variant.option1, variant.option2, variant.option3].filter(Boolean),
          price: formatGhMoneyFromCents(variant.price),
          image: normalizeGhProductImage(variant.featured_image) || primaryImage
        }))
      : [];

    const optionNames = Array.isArray(product.options)
      ? product.options.map((option) => typeof option === "string" ? option : option.name).filter(Boolean)
      : [];

    const dynamicProduct = {
      id: product.id,
      handle: product.handle || cleanHandle,
      title: product.title || "Featured Product",
      url: product.url || ("/products/" + (product.handle || cleanHandle)),
      description: stripGhHtml(product.description || ""),
      descriptionHtml: product.description || "",
      price: variants[0] ? variants[0].price : "",
      image: primaryImage,
      xpIcon: iconUrl || GH_FALLBACK_IMAGE_URL,
      xpModelUrl: manualModelUrl || null,
      xpVideos: manualVideos,
      xpGalleryImages: [],
      xpDonationNote: manualDonationNote || "",
      xpDonationLinkLabel: manualDonationLinkLabel || "",
      xpDonationLinkUrl: manualDonationLinkUrl || "",
      xpFundraiser: null,
      xpNotesEnabled: ghIsTrueLike(manualNotesEnabled) || !!manualNotesLabel || !!manualNotesPlaceholder || !!manualNotesHelp,
      xpNotesLabel: manualNotesLabel || "",
      xpNotesPlaceholder: manualNotesPlaceholder || "",
      xpNotesHelp: manualNotesHelp || "",
      xpAddToCartLabel: manualCartButtonLabel || "",
      judgemeWidgetHtml: "",
      judgemeReviewWidgetData: null,
      hasOnlyDefaultVariant: variants.length === 1 && String(variants[0].title || "").toLowerCase() === "default title",
      optionNames: optionNames,
      variants: variants,
      images: Array.isArray(product.images) ? product.images.map(normalizeGhProductImage).filter(Boolean) : []
    };

    applyManualFundraiser(dynamicProduct);
    dynamicProducts.push(dynamicProduct);
    return dynamicProduct;
  }


  const collection2State = { loaded: false, loading: false, products: [] };

  function getPrimaryCollectionHandle() {
    return ghThemeText("ringsHandle", "rings").trim() || "rings";
  }

  function getCollection2Handle() {
    return ghThemeText("collection2Handle", "").trim();
  }

  function getCollection2Label() {
    return ghThemeText("collection2TaskTitle", ghThemeText("collection2IconLabel", "Collection Template 2"));
  }

  function getCollection2IconUrl() {
    return ghThemeAsset("collection2IconUrl", ghThemeAsset("ringsIconUrl", ""));
  }

  function getCollection3Handle() {
    return ghThemeText("collection3Handle", "").trim();
  }

  function getCollection3Label() {
    return ghThemeText("collection3TaskTitle", "Collection 3");
  }

  function getCollection3IconUrl() {
    return ghThemeAsset("collection3IconUrl", ghThemeAsset("ringsIconUrl", ""));
  }

  const warmedCollectionHandles = new Set();

  function warmCollectionProductData(pageEl) {
    if (!pageEl) return;
    const handles = Array.from(pageEl.querySelectorAll("[data-shopify-product-handle], [data-featured-product-handle]"))
      .map(el => el.getAttribute("data-shopify-product-handle") || el.getAttribute("data-featured-product-handle") || "")
      .filter(Boolean)
      .filter(handle => !findDynamicProductByHandle(handle) && !warmedCollectionHandles.has(handle))
      .slice(0, 6);

    if (!handles.length) return;
    handles.forEach(handle => warmedCollectionHandles.add(handle));

    const warm = () => {
      handles.forEach(handle => {
        fetchFeaturedProductByHandle(handle, "").catch(() => {
          warmedCollectionHandles.delete(handle);
        });
      });
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(warm, { timeout: 900 });
    } else {
      window.setTimeout(warm, 180);
    }
  }

  function collection2ProductImage(product) {
    if (product && product.image && product.image.src) return product.image.src;
    if (product && Array.isArray(product.images) && product.images.length) {
      return product.images[0].src || product.images[0];
    }
    return "";
  }

  function makeCollection2ProductButton(product, backTarget) {
    const button = document.createElement("a");
    button.className = "collection-product-shortcut collection2-product-button" + (backTarget === "allProducts" ? " desktop-product-shortcut all-products-shortcut" : "");
    button.href = getCartRoot() + "products/" + encodeURIComponent(product.handle || "");
    button.setAttribute("data-featured-product-handle", product.handle || "");
    const imageUrl = collection2ProductImage(product);
    // products.json does not expose custom metafields. Use the product image only
    // for the folder thumbnail; do not mislabel it as the XP title-bar icon.
    // fetchFeaturedProductByHandle will resolve custom.xp_icon from gh-xp-data.

    const imgHtml = imageUrl
      ? '<img src="' + imageUrl.replace(/"/g, "&quot;") + '" alt="">'
      : '<span class="desktop-product-placeholder">💎</span>';
    button.innerHTML = imgHtml + '<span>' + (product.title || "Product") + '</span>';

    button.addEventListener("click", async (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      try {
        const productData = await fetchFeaturedProductByHandle(product.handle, "");
        if (productData) {
          applyCollectionNotesFallback(productData, getCollection2NotesFallback());
          productData.taskLabel = product.title || getCollection2Label();
          openDynamicShopifyProduct(productData, backTarget);
        }
      } catch (error) {
        alert("This product could not be opened yet. Check the product handle/collection in the theme editor.");
      }
    });
    return button;
  }

  async function loadCollection2Products() {
    const handle = getCollection2Handle();
    if (!handle) return [];

    // Shopify Liquid already renders Collection 2 into the XP folder.
    // Do not refetch the whole collection on mobile unless the grid is actually empty.
    if (collection2ProductsGrid && collection2ProductsGrid.children.length) {
      collection2State.loaded = true;
      return collection2State.products;
    }

    if (collection2State.loaded) return collection2State.products;
    if (collection2State.loading) return collection2State.products;

    collection2State.loading = true;
    try {
      const response = await fetch(getCartRoot() + "collections/" + encodeURIComponent(handle) + "/products.json?limit=48", {
        headers: { "Accept": "application/json" }
      });
      if (!response.ok) throw new Error("Collection not found");
      const data = await response.json();
      collection2State.products = Array.isArray(data.products) ? data.products : [];
      collection2State.loaded = true;
      renderCollection2Products();
      return collection2State.products;
    } catch (error) {
      collection2State.loaded = true;
      collection2State.products = [];
      if (collection2ProductsGrid) {
        collection2ProductsGrid.innerHTML = "";
      }
      return [];
    } finally {
      collection2State.loading = false;
    }
  }

  function renderCollection2Products() {
    if (collection2ProductsGrid) {
      collection2ProductsGrid.innerHTML = "";
      collection2State.products.forEach((product) => {
        collection2ProductsGrid.appendChild(makeCollection2ProductButton(product, "collection2"));
      });
    }
  }

  function getCartRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function cleanVariantText(value) {
    return String(value || "").toLowerCase();
  }

  function parseKeywordList(value, fallback) {
    const source = String(value || fallback || "");

    return source
      .split(",")
      .map((keyword) => cleanVariantText(keyword).trim())
      .filter(Boolean);
  }

  const variantMatching = ghProductConfig.variantMatching || {};
  const materialSelectorEnabled = ghProductConfig.materialSelectorEnabled !== false;
  const automaticMetalToolbarEnabled = ghProductConfig.automaticMetalToolbarEnabled !== false;
  const automaticMetalOptionKeywords = parseKeywordList(ghProductConfig.automaticMetalOptionKeywords, "metal, material");
  const automaticMetalToolbarIcons = Array.isArray(ghProductConfig.automaticMetalToolbarIcons) ? ghProductConfig.automaticMetalToolbarIcons.filter(Boolean) : [];
  const automaticMetalToolbarIconRules = Array.isArray(ghProductConfig.automaticMetalToolbarIconRules)
    ? ghProductConfig.automaticMetalToolbarIconRules
        .map((rule) => ({
          icon: rule && rule.icon ? String(rule.icon) : "",
          keywords: parseKeywordList(rule && rule.keywords, "")
        }))
        .filter((rule) => rule.icon && rule.keywords.length)
    : [];
  const secondaryVariantSelectorEnabled = ghProductConfig.secondaryVariantSelectorEnabled !== false;
  const tertiaryVariantSelectorEnabled = ghProductConfig.tertiaryVariantSelectorEnabled === true;
  const goldVariantKeywords = parseKeywordList(variantMatching.goldKeywords, "gold, 14k, 10k, 18k, yellow, white gold, rose gold");
  const silverVariantKeywords = parseKeywordList(variantMatching.silverKeywords, "silver, sterling, .925, 925");
  const naturalGemstoneKeywords = parseKeywordList(variantMatching.naturalKeywords, "natural, natural diamond");
  const labGemstoneKeywords = parseKeywordList(variantMatching.labKeywords, "lab, lab grown, lab-grown, laboratory, lab diamond");
  const tertiaryChoice1Keywords = parseKeywordList(variantMatching.tertiaryChoice1Keywords, "18, 18 inch, 18 inches, 18in");
  const tertiaryChoice2Keywords = parseKeywordList(variantMatching.tertiaryChoice2Keywords, "20, 20 inch, 20 inches, 20in");

  function variantSearchText(variant) {
    const optionsText = Array.isArray(variant.options)
      ? variant.options.join(" ")
      : "";

    return cleanVariantText((variant.title || "") + " " + optionsText);
  }

  function getFirstAvailableVariant() {
    return cartVariants.find((variant) => variant && variant.available) ||
      cartVariants[0] ||
      null;
  }

  function getSelectedGemstoneValue() {
    if (!secondaryVariantSelectorEnabled || !productGemstone) {
      return "none";
    }

    return cleanVariantText(productGemstone.value || "none");
  }

  function getSelectedTertiaryValue() {
    if (!tertiaryVariantSelectorEnabled || !productThirdOption) {
      return "none";
    }

    return cleanVariantText(productThirdOption.value || "none");
  }

  function getGemstoneKeywords(gemstoneValue) {
    const value = cleanVariantText(gemstoneValue);

    if (!value || value === "none") {
      return [];
    }

    if (value === "lab") {
      return labGemstoneKeywords;
    }

    if (value === "natural") {
      return naturalGemstoneKeywords;
    }

    return parseKeywordList(value, value);
  }

  function getTertiaryKeywords(optionValue) {
    const value = cleanVariantText(optionValue);

    if (!value || value === "none") {
      return [];
    }

    if (value === "choice1") {
      return tertiaryChoice1Keywords;
    }

    if (value === "choice2") {
      return tertiaryChoice2Keywords;
    }

    return parseKeywordList(value, value);
  }


  function cleanOptionValue(value) {
    return cleanVariantText(value).replace(/\s+/g, " ").trim();
  }

  function getActiveProductOptionNames() {
    const names = activeShopifyProduct
      ? activeShopifyProduct.optionNames
      : ghProductConfig.cartOptionNames;

    return Array.isArray(names) ? names : [];
  }

  function getAutomaticOptionData() {
    if (!cartVariants.length || activeProductHasOnlyDefaultVariant()) {
      return [];
    }

    const optionNames = getActiveProductOptionNames();
    const maxOptionCount = cartVariants.reduce((count, variant) => {
      const variantOptions = Array.isArray(variant && variant.options) ? variant.options : [];
      return Math.max(count, variantOptions.length);
    }, optionNames.length || 0);

    const options = [];

    for (let index = 0; index < maxOptionCount; index += 1) {
      const name = optionNames[index] || `Option ${index + 1}`;
      const values = [];
      const seen = new Set();

      cartVariants.forEach((variant) => {
        const variantOptions = Array.isArray(variant && variant.options) ? variant.options : [];
        const rawValue = variantOptions[index];
        const cleanValue = cleanOptionValue(rawValue);

        if (!cleanValue || seen.has(cleanValue)) return;

        seen.add(cleanValue);
        values.push(String(rawValue));
      });

      const isDefaultOnlyOption = values.length === 1 && cleanOptionValue(values[0]) === "default title";
      const isTitleOption = cleanOptionValue(name) === "title";

      if (!values.length || isDefaultOnlyOption || (isTitleOption && values.length === 1)) {
        continue;
      }

      options.push({
        index,
        name,
        values
      });
    }

    return options;
  }

  function removeAutomaticVariantControls() {
    automaticVariantControls.forEach((control) => {
      if (control && control.group && control.group.parentNode) {
        control.group.parentNode.removeChild(control.group);
      }
    });

    automaticVariantControls = [];
  }

  function removeAutomaticMetalToolbar() {
    automaticMetalToolbarItems.forEach((item) => {
      if (item && item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });

    automaticMetalToolbarItems = [];
    autoMetalOptionIndex = null;
    selectedAutomaticMetalValue = "";
  }

  function optionNameLooksLikeMetal(option) {
    if (!option) return false;

    const cleanName = cleanOptionValue(option.name || "");
    return automaticMetalOptionKeywords.some((keyword) => cleanName.includes(keyword));
  }

  function optionLooksLikeMetal(option) {
    if (!option) return false;

    if (optionNameLooksLikeMetal(option)) return true;

    const metalValueWords = ["gold", "silver", "platinum", "14k", "18k", "10k", "sterling", "925"];
    const values = Array.isArray(option.values) ? option.values : [];

    return values.some((value) => {
      const cleanValue = cleanOptionValue(value);
      return metalValueWords.some((word) => cleanValue.includes(word));
    });
  }

  function normalizeMetalIconText(value) {
    return cleanOptionValue(value)
      .replace(/[^a-z0-9.]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getAutomaticMetalIcon(value, index) {
    const cleanValue = normalizeMetalIconText(value);
    let bestRule = null;
    let bestScore = -1;

    automaticMetalToolbarIconRules.forEach((rule) => {
      rule.keywords.forEach((keyword) => {
        const cleanKeyword = normalizeMetalIconText(keyword);
        if (!cleanKeyword) return;

        const matched = cleanValue === cleanKeyword || cleanValue.includes(cleanKeyword);
        if (!matched) return;

        // Most specific phrase wins. This prevents a broad word like "gold"
        // from stealing the icon for "green gold" or "yellow gold".
        const score = cleanValue === cleanKeyword ? cleanKeyword.length + 1000 : cleanKeyword.length;
        if (score > bestScore) {
          bestScore = score;
          bestRule = rule;
        }
      });
    });

    if (bestRule && bestRule.icon) {
      return bestRule.icon;
    }

    return automaticMetalToolbarIcons[index] || automaticMetalToolbarIcons[0] || "";
  }

  function setAutomaticMetalToolbarActive(value) {
    selectedAutomaticMetalValue = String(value || "");

    automaticMetalToolbarItems.forEach((toolbarItem) => {
      const toolbarButton = toolbarItem.querySelector(".auto-metal-btn");
      if (!toolbarButton) return;

      const isActive = cleanOptionValue(toolbarButton.dataset.optionValue) === cleanOptionValue(selectedAutomaticMetalValue);
      toolbarButton.classList.toggle("active-material", isActive);
    });
  }

  function renderAutomaticMetalToolbar(metalOption) {
    removeAutomaticMetalToolbar();

    if (!metalOption || !Array.isArray(metalOption.values) || !metalOption.values.length || !automaticMetalToolbarEnabled || !materialSelectorEnabled) {
      return false;
    }

    const toolbar = document.querySelector(".xp-toolbar");
    const navGroup = toolbar ? toolbar.querySelector(".xp-nav-group") : null;

    if (!toolbar || !navGroup) {
      return false;
    }

    autoMetalOptionIndex = metalOption.index;
    selectedAutomaticMetalValue = metalOption.values[0];

    metalOption.values.forEach((value, index) => {
      const item = document.createElement("div");
      item.className = "toolbar-item auto-metal-toolbar-item";

      const button = document.createElement("button");
      button.type = "button";
      button.className = "xp-image-btn material-image-btn auto-metal-btn";
      button.dataset.optionIndex = String(metalOption.index);
      button.dataset.optionValue = String(value);
      button.setAttribute("aria-label", String(value));

      const iconUrl = getAutomaticMetalIcon(value, index);
      if (iconUrl) {
        const image = document.createElement("img");
        image.src = iconUrl;
        image.alt = "";
        button.appendChild(image);
      } else {
        button.textContent = String(value).charAt(0).toUpperCase();
      }

      const label = document.createElement("span");
      label.className = "toolbar-text";
      label.textContent = String(value);

      button.addEventListener("click", () => {
        if (button.disabled) return;

        ghRunProductInternalInteraction(() => {
          setAutomaticMetalToolbarActive(value);
          // Preserve the customer's currently selected stone/other options when
          // that exact Shopify combination exists.
          syncAutoVariantControlsToBestVariant(false);
          refreshAutomaticVariantAvailability();
          updateCartStatus("", false);
          updateDynamicProductDisplay();
        }, "material");
      });

      if (index === 0) {
        button.classList.add("active-material");
      }

      item.appendChild(button);
      item.appendChild(label);

      const previousMetalItem = automaticMetalToolbarItems[automaticMetalToolbarItems.length - 1];
      if (previousMetalItem && previousMetalItem.parentNode) {
        previousMetalItem.insertAdjacentElement("afterend", item);
      } else {
        navGroup.insertAdjacentElement("afterend", item);
      }
      automaticMetalToolbarItems.push(item);
    });

    return automaticMetalToolbarItems.length > 0;
  }

  function buildAutomaticVariantControls(optionData) {
    removeAutomaticVariantControls();

    if (!productOptionsContainer || !optionData || !optionData.length) {
      return false;
    }

    const quantityGroup = productQuantity ? productQuantity.closest(".option-group") : null;

    optionData.forEach((option) => {
      const group = document.createElement("div");
      group.className = "option-group auto-variant-group";
      group.dataset.optionIndex = String(option.index);

      const label = document.createElement("label");
      label.textContent = option.name;

      const select = document.createElement("select");
      select.className = "xp-select auto-variant-select";
      select.dataset.optionIndex = String(option.index);
      select.setAttribute("aria-label", option.name);

      option.values.forEach((value) => {
        const optionEl = document.createElement("option");
        optionEl.value = String(value);
        optionEl.textContent = String(value);
        select.appendChild(optionEl);
      });

      select.addEventListener("change", () => {
        syncAutoVariantControlsToBestVariant();
        refreshAutomaticVariantAvailability();
        updateCartStatus("", false);
        updateDynamicProductDisplay();
      });

      group.appendChild(label);
      group.appendChild(select);

      if (quantityGroup && quantityGroup.parentNode === productOptionsContainer) {
        productOptionsContainer.insertBefore(group, quantityGroup);
      } else {
        productOptionsContainer.appendChild(group);
      }

      automaticVariantControls.push({
        index: option.index,
        select,
        group
      });
    });

    return automaticVariantControls.length > 0;
  }

  function getSelectedAutomaticOptions() {
    const selected = [];

    if (autoMetalOptionIndex !== null && selectedAutomaticMetalValue) {
      selected[autoMetalOptionIndex] = selectedAutomaticMetalValue;
    }

    automaticVariantControls.forEach((control) => {
      if (!control || !control.select) return;
      selected[control.index] = control.select.value;
    });

    return selected;
  }

  function automaticOptionCombinationExists(optionIndex, candidateValue) {
    if (!cartVariants.length) return false;

    const selectedOptions = getSelectedAutomaticOptions();
    const cleanCandidate = cleanOptionValue(candidateValue);

    /*
      Variant-aware option availability is based on whether the combination
      actually exists in Shopify, not inventory quantity. This is important for
      made-to-order jewelry where a valid variant can temporarily have zero
      tracked inventory. Deleted/nonexistent combinations are what get disabled.
    */
    return cartVariants.some((variant) => {
      if (!variant) return false;

      const variantOptions = Array.isArray(variant.options) ? variant.options : [];
      if (cleanOptionValue(variantOptions[optionIndex]) !== cleanCandidate) {
        return false;
      }

      return selectedOptions.every((selectedValue, index) => {
        if (index === optionIndex) return true;
        if (typeof selectedValue === "undefined" || selectedValue === null || selectedValue === "") {
          return true;
        }

        return cleanOptionValue(variantOptions[index]) === cleanOptionValue(selectedValue);
      });
    });
  }

  function refreshAutomaticVariantAvailability() {
    if (!cartVariants.length) return;

    if (autoMetalOptionIndex !== null) {
      automaticMetalToolbarItems.forEach((toolbarItem) => {
        if (!toolbarItem) return;

        const toolbarButton = toolbarItem.querySelector(".auto-metal-btn");
        if (!toolbarButton) return;

        const optionValue = toolbarButton.dataset.optionValue || "";
        const combinationExists = automaticOptionCombinationExists(autoMetalOptionIndex, optionValue);

        toolbarButton.disabled = !combinationExists;
        toolbarButton.setAttribute("aria-disabled", combinationExists ? "false" : "true");
        toolbarItem.classList.toggle("gh-variant-unavailable", !combinationExists);

        if (combinationExists) {
          toolbarButton.removeAttribute("title");
        } else {
          toolbarButton.title = `${optionValue} is unavailable with the selected product option`;
        }
      });
    }

    automaticVariantControls.forEach((control) => {
      if (!control || !control.select) return;

      Array.from(control.select.options || []).forEach((optionEl) => {
        if (!optionEl) return;

        const baseLabel = optionEl.dataset.ghBaseLabel || optionEl.value || optionEl.textContent || "";
        optionEl.dataset.ghBaseLabel = baseLabel;

        const combinationExists = automaticOptionCombinationExists(control.index, optionEl.value);
        optionEl.disabled = !combinationExists;
        optionEl.textContent = combinationExists ? baseLabel : `${baseLabel} — unavailable`;
      });
    });
  }

  function applyAutomaticSelectionsFromVariant(variant) {
    if (!variant || !Array.isArray(variant.options)) return;

    if (autoMetalOptionIndex !== null) {
      const metalValue = variant.options[autoMetalOptionIndex];
      if (typeof metalValue !== "undefined") {
        setAutomaticMetalToolbarActive(metalValue);
      }
    }

    automaticVariantControls.forEach((control) => {
      if (!control || !control.select) return;

      const nextValue = variant.options[control.index];
      if (typeof nextValue === "undefined") return;

      const matchingOption = Array.from(control.select.options || []).find((option) => {
        return cleanOptionValue(option.value) === cleanOptionValue(nextValue);
      });

      if (matchingOption) {
        control.select.value = matchingOption.value;
      }
    });
  }

  function getVariantsMatchingAutomaticMetal(value, availableOnly) {
    if (autoMetalOptionIndex === null || !value) return [];

    return cartVariants.filter((variant) => {
      if (!variant) return false;
      if (availableOnly && !variant.available) return false;

      const variantOptions = Array.isArray(variant.options) ? variant.options : [];
      return cleanOptionValue(variantOptions[autoMetalOptionIndex]) === cleanOptionValue(value);
    });
  }

  function pickBestVariantForAutomaticMetal(value) {
    const availableCandidates = getVariantsMatchingAutomaticMetal(value, true);
    const allCandidates = availableCandidates.length ? availableCandidates : getVariantsMatchingAutomaticMetal(value, false);

    if (!allCandidates.length) {
      return null;
    }

    const cleanMetalValue = cleanOptionValue(value);

    /*
      If a product has both a broad option like Plating = Silver and another
      detailed option like Metal = Silver / 14K Yellow Gold, prefer the variant
      where the detailed selector matches the toolbar button. This keeps the
      toolbar and visible selectors talking to each other instead of showing
      Silver in the toolbar and 14K Yellow Gold in the selector.
    */
    const sameValueCandidate = allCandidates.find((variant) => {
      const variantOptions = Array.isArray(variant.options) ? variant.options : [];
      return variantOptions.some((optionValue, index) => {
        return index !== autoMetalOptionIndex && cleanOptionValue(optionValue) === cleanMetalValue;
      });
    });

    return sameValueCandidate || allCandidates[0];
  }

  function syncAutoVariantControlsToBestVariant(preferMetalCandidate) {
    if (!cartVariants.length) return;

    const finishSync = (variant) => {
      if (variant) {
        applyAutomaticSelectionsFromVariant(variant);
      }
      refreshAutomaticVariantAvailability();
    };

    const metalVariant = pickBestVariantForAutomaticMetal(selectedAutomaticMetalValue);
    if (preferMetalCandidate && metalVariant) {
      finishSync(metalVariant);
      return;
    }

    const exactVariant = getVariantForAutomaticSelections();
    if (exactVariant) {
      finishSync(exactVariant);
      return;
    }

    if (metalVariant) {
      finishSync(metalVariant);
      return;
    }

    const fallbackVariant = getFirstAvailableVariant();
    finishSync(fallbackVariant);
  }

  function variantMatchesAutomaticSelections(variant) {
    const selectedOptions = getSelectedAutomaticOptions();
    const variantOptions = Array.isArray(variant && variant.options) ? variant.options : [];

    return selectedOptions.every((selectedValue, index) => {
      if (typeof selectedValue === "undefined" || selectedValue === null || selectedValue === "") {
        return true;
      }

      return cleanOptionValue(variantOptions[index]) === cleanOptionValue(selectedValue);
    });
  }

  function getVariantForAutomaticSelections() {
    if (!automaticVariantControls.length && autoMetalOptionIndex === null) {
      return null;
    }

    return (
      cartVariants.find((variant) => variant && variant.available && variantMatchesAutomaticSelections(variant)) ||
      cartVariants.find((variant) => variant && variantMatchesAutomaticSelections(variant)) ||
      null
    );
  }

  function variantHasAnyKeyword(variant, keywords) {
    if (!keywords || !keywords.length) {
      return true;
    }

    const text = variantSearchText(variant);
    return keywords.some((keyword) => text.includes(keyword));
  }

  function getVariantForMaterial(material) {
    if (!cartVariants.length) {
      return null;
    }

    /*
      If the selected Shopify product has no real variants, Shopify still gives
      it one default variant. In that case, do not try to match metal/gemstone
      words — just add the default variant.
    */
    if (activeProductHasOnlyDefaultVariant() || cartVariants.length === 1) {
      return getFirstAvailableVariant();
    }

    if (automaticVariantControls.length || autoMetalOptionIndex !== null) {
      return getVariantForAutomaticSelections();
    }

    const materialKeywords = materialSelectorEnabled
      ? (material === "silver" ? silverVariantKeywords : goldVariantKeywords)
      : [];

    const gemstoneKeywords = secondaryVariantSelectorEnabled
      ? getGemstoneKeywords(getSelectedGemstoneValue())
      : [];

    const tertiaryKeywords = tertiaryVariantSelectorEnabled
      ? getTertiaryKeywords(getSelectedTertiaryValue())
      : [];

    const requireMaterialMatch = materialSelectorEnabled && materialKeywords.length > 0;
    const requiredOptionKeywordGroups = [gemstoneKeywords, tertiaryKeywords].filter((keywords) => keywords && keywords.length);

    const matchVariant = (availableOnly, requireMaterial) => {
      return cartVariants.find((variant) => {
        if (!variant) return false;
        if (availableOnly && !variant.available) return false;

        const materialOk = !requireMaterial || variantHasAnyKeyword(variant, materialKeywords);
        const productOptionsOk = requiredOptionKeywordGroups.every((keywords) => variantHasAnyKeyword(variant, keywords));

        return materialOk && productOptionsOk;
      });
    };

    /*
      Important: if the customer picks a visible product option such as Lab,
      Natural, 18 inches, or 20 inches, we do NOT fall back to a variant that
      ignores that option. This prevents the cart from adding the wrong variant.
    */
    if (requiredOptionKeywordGroups.length > 0) {
      return (
        matchVariant(true, requireMaterialMatch) ||
        matchVariant(false, requireMaterialMatch) ||
        matchVariant(true, false) ||
        matchVariant(false, false) ||
        null
      );
    }

    return (
      matchVariant(true, requireMaterialMatch) ||
      matchVariant(false, requireMaterialMatch) ||
      getFirstAvailableVariant()
    );
  }

  function setupVariantControls() {
    const hideBecauseSingleVariant = !!(
      activeProductHasOnlyDefaultVariant() &&
      ghProductConfig.autoHideVariantControlsWhenSingleVariant
    );

    const automaticOptionData = hideBecauseSingleVariant ? [] : getAutomaticOptionData();
    if (hideBecauseSingleVariant) removeAutomaticMetalToolbar();
    const automaticMetalOption = automaticOptionData.find(optionNameLooksLikeMetal) || automaticOptionData.find(optionLooksLikeMetal) || null;
    const usingAutomaticMetalToolbar = !hideBecauseSingleVariant && renderAutomaticMetalToolbar(automaticMetalOption);
    const optionControlsToBuild = usingAutomaticMetalToolbar
      ? automaticOptionData.filter((option) => option.index !== automaticMetalOption.index)
      : automaticOptionData;
    const usingAutomaticControls = buildAutomaticVariantControls(optionControlsToBuild) || usingAutomaticMetalToolbar;

    if (usingAutomaticControls) {
      const startingVariant = getFirstAvailableVariant();
      if (startingVariant) {
        applyAutomaticSelectionsFromVariant(startingVariant);
      }
      syncAutoVariantControlsToBestVariant();
    }

    if (productGemstone) {
      const gemstoneGroup = productGemstone.closest(".option-group");
      const noChoices = productGemstone.options && productGemstone.options.length === 0;
      if (gemstoneGroup) gemstoneGroup.style.display = "";
      if (gemstoneGroup && (usingAutomaticControls || !secondaryVariantSelectorEnabled || hideBecauseSingleVariant || noChoices)) {
        gemstoneGroup.style.display = "none";
      }
    }

    if (productThirdOption) {
      const thirdOptionGroup = productThirdOption.closest(".option-group");
      const noThirdChoices = productThirdOption.options && productThirdOption.options.length === 0;
      if (thirdOptionGroup) thirdOptionGroup.style.display = "";
      if (thirdOptionGroup && (usingAutomaticControls || !tertiaryVariantSelectorEnabled || hideBecauseSingleVariant || noThirdChoices)) {
        thirdOptionGroup.style.display = "none";
      }
    }

    [goldBtn, silverBtn].forEach((button) => {
      if (!button) return;
      const toolbarItem = button.closest(".toolbar-item");
      if (toolbarItem) toolbarItem.style.display = "";
    });

    if (usingAutomaticControls || !materialSelectorEnabled || hideBecauseSingleVariant) {
      [goldBtn, silverBtn].forEach((button) => {
        if (!button) return;
        const toolbarItem = button.closest(".toolbar-item");
        if (toolbarItem) toolbarItem.style.display = "none";
      });
    }
  }

  setupVariantControls();

  [productGemstone, productThirdOption].forEach((select) => {
    if (!select) return;
    select.addEventListener("change", () => {
      updateCartStatus("", false);
      if (activeShopifyProduct) {
        updateDynamicProductDisplay();
      }
    });
  });

  /* =========================
     PRODUCT INTERNAL HISTORY
     The real browser Back/Forward buttons now remember product-toolbar state
     without changing the canonical product URL.
  ========================= */

  let ghProductInternalHistoryRestoring = false;

  function ghProductRouteHandleFromLocation() {
    const match = ghCleanRoutePath(window.location.pathname).match(/^\/products\/([^/]+)$/i);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function ghCurrentProductInternalView() {
    if (wmpPlayer && !wmpPlayer.classList.contains("hidden")) return "media";
    if (viewer3d && !viewer3d.classList.contains("hidden")) return "3d";
    if (photoGallery && !photoGallery.classList.contains("hidden")) return "gallery";
    return "product";
  }

  function ghCaptureProductInternalState() {
    if (!activeShopifyProduct) return null;

    const productHandle = String(getActiveProductHandle() || "").trim();
    const routeHandle = ghProductRouteHandleFromLocation();
    if (!productHandle || !routeHandle || productHandle !== routeHandle) return null;

    const automaticOptions = typeof getSelectedAutomaticOptions === "function"
      ? getSelectedAutomaticOptions().map((value) => (
          typeof value === "undefined" || value === null ? null : String(value)
        ))
      : [];

    return {
      ghXpRoute: true,
      ghProductInternal: true,
      type: "product-internal",
      productHandle,
      view: ghCurrentProductInternalView(),
      material: currentMaterial || "gold",
      automaticOptions,
      gemstoneValue: productGemstone ? String(productGemstone.value || "") : "",
      thirdOptionValue: productThirdOption ? String(productThirdOption.value || "") : ""
    };
  }

  function ghProductInternalStateKey(state) {
    if (!state) return "";
    return JSON.stringify({
      productHandle: state.productHandle || "",
      view: state.view || "product",
      material: state.material || "gold",
      automaticOptions: Array.isArray(state.automaticOptions) ? state.automaticOptions : [],
      gemstoneValue: state.gemstoneValue || "",
      thirdOptionValue: state.thirdOptionValue || ""
    });
  }

  function ghWriteCurrentProductHistoryState(state) {
    if (!state) return false;
    const currentUrl = window.location.pathname + window.location.search + window.location.hash;
    window.history.replaceState(
      Object.assign({}, window.history.state || {}, state),
      "",
      currentUrl
    );
    return true;
  }

  function ghRunProductInternalInteraction(callback, interactionName) {
    if (typeof callback !== "function") return;

    if (ghProductInternalHistoryRestoring || !activeShopifyProduct) {
      callback();
      return;
    }

    const beforeState = ghCaptureProductInternalState();
    if (!beforeState) {
      callback();
      return;
    }

    // Make the current history entry describe the UI exactly as it looks before
    // the click. The new state gets its own same-URL entry after the click.
    ghWriteCurrentProductHistoryState(beforeState);

    const previousRouteSuppression = !!window.__ghSuppressRouteSync;
    window.__ghSuppressRouteSync = true;

    try {
      callback();
    } finally {
      window.__ghSuppressRouteSync = previousRouteSuppression;
    }

    const afterState = ghCaptureProductInternalState();
    if (!afterState || ghProductInternalStateKey(beforeState) === ghProductInternalStateKey(afterState)) {
      return;
    }

    const currentUrl = window.location.pathname + window.location.search + window.location.hash;
    window.history.pushState(
      Object.assign({}, afterState, { ghProductInteraction: interactionName || "product-ui" }),
      "",
      currentUrl
    );
  }

  function ghSetLegacyMaterialButtonState(material) {
    const isSilver = String(material || "").toLowerCase() === "silver";
    if (goldBtn) goldBtn.classList.toggle("active-material", !isSilver);
    if (silverBtn) silverBtn.classList.toggle("active-material", isSilver);
  }

  function ghRestoreAutomaticOptions(state) {
    const automaticOptions = Array.isArray(state && state.automaticOptions)
      ? state.automaticOptions
      : [];

    if (autoMetalOptionIndex !== null) {
      const metalValue = automaticOptions[autoMetalOptionIndex];
      if (metalValue !== null && typeof metalValue !== "undefined" && metalValue !== "") {
        setAutomaticMetalToolbarActive(metalValue);
      }
    }

    automaticVariantControls.forEach((control) => {
      if (!control || !control.select) return;
      const desiredValue = automaticOptions[control.index];
      if (desiredValue === null || typeof desiredValue === "undefined") return;

      const matchingOption = Array.from(control.select.options || []).find((option) => (
        cleanOptionValue(option.value) === cleanOptionValue(desiredValue)
      ));

      if (matchingOption) control.select.value = matchingOption.value;
    });
  }

  function ghApplyProductInternalHistoryState(state) {
    if (!state || !state.ghProductInternal || !activeShopifyProduct) return false;

    const activeHandle = String(getActiveProductHandle() || "").trim();
    if (!activeHandle || activeHandle !== String(state.productHandle || "").trim()) return false;

    const previousRouteSuppression = !!window.__ghSuppressRouteSync;
    ghProductInternalHistoryRestoring = true;
    window.__ghSuppressRouteSync = true;

    try {
      if (state.material) currentMaterial = state.material;

      ghRestoreAutomaticOptions(state);

      if (productGemstone && typeof state.gemstoneValue === "string" && state.gemstoneValue) {
        productGemstone.value = state.gemstoneValue;
      }

      if (productThirdOption && typeof state.thirdOptionValue === "string" && state.thirdOptionValue) {
        productThirdOption.value = state.thirdOptionValue;
      }

      refreshAutomaticVariantAvailability();
      updateCartStatus("", false);
      updateDynamicProductDisplay();

      switch (state.view) {
        case "3d":
          show3DViewer();
          break;
        case "media":
          showWMP();
          break;
        case "gallery":
          showPhotoGallery();
          break;
        default:
          showStorePage();
          break;
      }

      ghSetLegacyMaterialButtonState(currentMaterial);
    } finally {
      window.__ghSuppressRouteSync = previousRouteSuppression;
      ghProductInternalHistoryRestoring = false;
    }

    return true;
  }

  function ghBackWithinProductInternalHistory() {
    const state = window.history.state || {};
    const activeHandle = String(getActiveProductHandle() || "").trim();

    if (
      state.ghProductInternal &&
      activeHandle &&
      String(state.productHandle || "") === activeHandle &&
      state.view &&
      state.view !== "product"
    ) {
      window.history.back();
      return true;
    }

    return false;
  }

  function getAddToCartButtonLabel(product) {
    const source = product || activeShopifyProduct || goldProduct || null;
    const productLabel = source && source.xpAddToCartLabel ? String(source.xpAddToCartLabel).trim() : "";
    const defaultProductLabel = ghProductConfig.productAddToCartLabel ? String(ghProductConfig.productAddToCartLabel).trim() : "";
    const sectionLabel = ghProductConfig.addToCartLabel ? String(ghProductConfig.addToCartLabel).trim() : "";
    return productLabel || defaultProductLabel || sectionLabel || "Add To Cart";
  }

  function updateAddToCartButtonLabel(product) {
    if (!addToCartBtn || addToCartBtn.disabled) return;
    const label = getAddToCartButtonLabel(product);
    addToCartBtn.dataset.originalLabel = label;
    addToCartBtn.textContent = label;
  }

  function updateCartStatus(message, isError) {
    if (!cartStatus) return;

    cartStatus.textContent = message || "";
    cartStatus.classList.toggle("is-error", !!isError);
  }

  function getSelectedQuantity() {
    const quantity = productQuantity ? parseInt(productQuantity.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  async function addSelectedProductToCart() {
    if (!addToCartBtn) return;

    const selectedVariant = getVariantForMaterial(currentMaterial);

    if (!selectedVariant || !selectedVariant.id) {
      const hasProduct = !!getActiveProductHandle();
      updateCartStatus(
        hasProduct
          ? "No Shopify variant matches this product option choice. Check Variant Matching settings."
          : "Choose a real Shopify product in the XP Desktop settings first.",
        true
      );
      addToCartBtn.textContent = hasProduct ? "No Matching Variant" : "Choose Shopify Product";
      window.setTimeout(() => {
        addToCartBtn.textContent = getAddToCartButtonLabel(activeShopifyProduct);
      }, 2200);
      return;
    }

    const originalLabel = getAddToCartButtonLabel(activeShopifyProduct);
    addToCartBtn.dataset.originalLabel = originalLabel;
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = "Adding...";
    updateCartStatus("", false);

    const lineItem = {
      id: selectedVariant.id,
      quantity: getSelectedQuantity()
    };

    const personalizationNote = productOrderNote
      ? String(productOrderNote.value || "").trim()
      : "";

    const lineItemProperties = {};

    if (personalizationNote) {
      lineItemProperties["Personalization / Order Notes"] = personalizationNote;
    }

    const activeFundraiser = ghGetProductFundraiser(activeShopifyProduct);
    if (activeFundraiser && ghIsTrueLike(activeFundraiser.enabled)) {
      const donationPerUnit = ghFundraiserPerSaleForMetal(activeFundraiser, selectedVariant);
      if (donationPerUnit > 0) {
        lineItemProperties["_GH Giving Unit"] = String(donationPerUnit);
        lineItemProperties["_GH Giving Metal"] = ghFundraiserMetalLabel(selectedVariant);
        lineItemProperties["_GH Giving Eligible"] = "yes";
      }
    }

    if (Object.keys(lineItemProperties).length) {
      lineItem.properties = lineItemProperties;
    }

    try {
      const response = await fetch(getCartRoot() + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          items: [lineItem]
        })
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.description || data.message || "Could not add this item to cart.");
      }

      addToCartBtn.textContent = "Added ✓";
      updateCartStatus("Added to cart. Click the cart icon to checkout.", false);
      await refreshCartCount();

      window.setTimeout(() => {
        addToCartBtn.textContent = originalLabel;
      }, 1600);
    } catch (error) {
      addToCartBtn.textContent = "Try Again";
      updateCartStatus(error.message || "Could not add this item to cart.", true);
    } finally {
      addToCartBtn.disabled = false;
    }
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", addSelectedProductToCart);
  }

  if (cartButtons && cartButtons.length) {
    cartButtons.forEach((button) => {
      button.addEventListener("click", () => {
        window.location.href = getCartRoot() + "cart";
      });

      button.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          window.location.href = getCartRoot() + "cart";
        }
      });
    });
  }

  refreshCartCount();


  /* =========================
     GALLERY ELEMENTS
  ========================= */

  const openGalleryBtn = document.getElementById("openGalleryBtn");

  const galleryPrev = document.getElementById("galleryPrev");
  const galleryNext = document.getElementById("galleryNext");
  const galleryRotateLeft = document.getElementById("galleryRotateLeft");
  const galleryRotateRight = document.getElementById("galleryRotateRight");
  const galleryMainImage = document.getElementById("galleryMainImage");
  const productGalleryThumbRow = document.getElementById("productGalleryThumbRow");
  let galleryThumbs = document.querySelectorAll(".gallery-thumb");

  const customInfoGallery = document.getElementById("customInfoGallery");
  const ghEduInlineSignupForm = document.getElementById("ghEduInlineSignupForm");
  const ghEduInlineSignupStatus = document.getElementById("ghEduInlineSignupStatus");
  const customInfoGalleryPrev = document.getElementById("customInfoGalleryPrev");
  const customInfoGalleryNext = document.getElementById("customInfoGalleryNext");
  const customInfoGalleryRotateLeft = document.getElementById("customInfoGalleryRotateLeft");
  const customInfoGalleryRotateRight = document.getElementById("customInfoGalleryRotateRight");
  const customInfoGalleryMainImage = document.getElementById("customInfoGalleryMainImage");
  const customInfoGalleryThumbs = document.querySelectorAll(".gh-info-gallery-thumb");
  const customInfoGalleryImages = Array.from(customInfoGalleryThumbs)
    .map((thumb) => thumb.dataset.src)
    .filter(Boolean);
  let customInfoGalleryIndex = 0;
  let customInfoGalleryRotation = 0;

  const defaultGalleryImages = [
    GH_FALLBACK_IMAGE_URL,
    GH_FALLBACK_IMAGE_URL,
    GH_FALLBACK_IMAGE_URL
  ];

  let galleryImages =
    (ghProductConfig.galleryImages && ghProductConfig.galleryImages.filter(Boolean).length)
      ? ghProductConfig.galleryImages.filter(Boolean)
      : defaultGalleryImages;

  let galleryIndex = 0;
  let galleryRotation = 0;


  /* =========================
     FULLSCREEN PHOTO ELEMENTS
  ========================= */

  const photoFullscreen = document.getElementById("photoFullscreen");
  const photoFullscreenImage = document.getElementById("photoFullscreenImage");
  const photoFullscreenClose = document.getElementById("photoFullscreenClose");

  function openPhotoFullscreenWithSrc(src, altText = "") {
    if (!photoFullscreen || !photoFullscreenImage || !src) {
      return;
    }

    photoFullscreenImage.src = src;
    photoFullscreenImage.alt = altText || "GoldHearted custom jewelry full-screen image";
    photoFullscreen.classList.remove("hidden");
  }


  /* =========================
     PLAY / PAUSE VISUALS
  ========================= */

  function showPlayOverlay() {

    if (playOverlay) {
      playOverlay.classList.remove("hidden");
      playOverlay.style.setProperty("display", "block", "important");
      playOverlay.style.setProperty("visibility", "visible", "important");
      playOverlay.style.setProperty("opacity", "1", "important");
      playOverlay.style.setProperty("z-index", "30", "important");
    }

    if (pauseOverlay) {
      pauseOverlay.classList.remove("hidden");
      pauseOverlay.style.setProperty("display", "none", "important");
      pauseOverlay.style.setProperty("visibility", "hidden", "important");
      pauseOverlay.style.setProperty("opacity", "0", "important");
    }
  }

  function showPauseOverlay() {

    if (playOverlay) {
      playOverlay.classList.remove("hidden");
      playOverlay.style.setProperty("display", "none", "important");
      playOverlay.style.setProperty("visibility", "hidden", "important");
      playOverlay.style.setProperty("opacity", "0", "important");
    }

    if (pauseOverlay) {
      pauseOverlay.classList.remove("hidden");
      pauseOverlay.style.setProperty("display", "block", "important");
      pauseOverlay.style.setProperty("visibility", "visible", "important");
      pauseOverlay.style.setProperty("opacity", "1", "important");
      pauseOverlay.style.setProperty("z-index", "30", "important");
    }
  }


  /* =========================
     PAGE HELPERS
  ========================= */

  /* =========================
   XP WINDOW MANAGER
   XP app windows:
   1) Product / Collection
   2) NameChain.exe
   3) Info
   4) Messenger
   5) Metal Pricing
========================= */

let topWindowZ = 2147482400;
const GH_WINDOW_Z_BASE = 2147482400;
const GH_WINDOW_Z_CEILING = 2147482980;

function getWindowZValue(singleWindow) {

  if (!singleWindow) {
    return 0;
  }

  const inlineZ = parseInt(singleWindow.style.zIndex, 10);
  const computedZ = parseInt(window.getComputedStyle(singleWindow).zIndex, 10);

  if (!isNaN(inlineZ)) {
    return inlineZ;
  }

  if (!isNaN(computedZ)) {
    return computedZ;
  }

  return 0;
}

function normalizeVisibleWindowZStack(priorityWindow) {

  const visibleWindows = getAppWindows()
    .filter(isAppWindowVisible)
    .sort((a, b) => getWindowZValue(a) - getWindowZValue(b));

  let nextZ = GH_WINDOW_Z_BASE;

  visibleWindows.forEach((singleWindow) => {
    if (singleWindow === priorityWindow) {
      return;
    }

    nextZ += 1;
    singleWindow.style.setProperty('z-index', String(nextZ), 'important');
  });

  if (priorityWindow && visibleWindows.includes(priorityWindow)) {
    nextZ += 1;
    priorityWindow.style.setProperty('z-index', String(nextZ), 'important');
  }

  topWindowZ = nextZ;
}

function getAppWindowById(id) {
  return document.getElementById(id);
}

function getAppWindows() {
  return [
    getAppWindowById("window"),
    getAppWindowById("infoWindow"),
    getAppWindowById("aimWindow"),
    getAppWindowById("metalWindow"),
    getAppWindowById("namechainWindow")
  ].filter(Boolean);
}

function getTaskForAppWindow(targetWindow) {

  if (!targetWindow) {
    return null;
  }

  if (targetWindow.id === "window") {
    return getAppWindowById("rings-task");
  }

  if (targetWindow.id === "infoWindow") {
    return getAppWindowById("info-task");
  }

  if (targetWindow.id === "aimWindow") {
    return getAppWindowById("aim-task");
  }

  if (targetWindow.id === "metalWindow") {
    return getAppWindowById("metal-task");
  }

  if (targetWindow.id === "namechainWindow") {
    return getAppWindowById("namechain-task");
  }

  return null;
}

function getAppWindowForTask(taskButton) {

  if (!taskButton) {
    return null;
  }

  if (taskButton.id === "rings-task") {
    return getAppWindowById("window");
  }

  if (taskButton.id === "info-task") {
    return getAppWindowById("infoWindow");
  }

  if (taskButton.id === "aim-task") {
    return getAppWindowById("aimWindow");
  }

  if (taskButton.id === "metal-task") {
    return getAppWindowById("metalWindow");
  }

  if (taskButton.id === "namechain-task") {
    return getAppWindowById("namechainWindow");
  }

  return null;
}

function isAppWindowVisible(targetWindow) {

  if (!targetWindow) {
    return false;
  }

  const styles = window.getComputedStyle(targetWindow);

  return (
    !targetWindow.classList.contains("hidden") &&
    !targetWindow.classList.contains("minimized") &&
    styles.display !== "none" &&
    styles.visibility !== "hidden" &&
    styles.opacity !== "0"
  );
}

function getHighestWindowZ() {

  let highestZ = topWindowZ;

  getAppWindows().forEach((singleWindow) => {

    const finalZ = getWindowZValue(singleWindow);

    if (finalZ > highestZ) {
      highestZ = finalZ;
    }

  });

  return highestZ;
}

function isShoppingSlotWindow(targetWindow) {
  return !!targetWindow && (targetWindow.id === "window" || targetWindow.id === "namechainWindow");
}

function activateShoppingSlot(targetWindow) {

  if (!isShoppingSlotWindow(targetWindow)) {
    return;
  }

  // V70: Product/Collection and NameChain.exe are independent XP windows.
  // Do not close one just because the other is brought forward. This allows
  // Product + NameChain + Messenger + one Info page to stay open together.
}

// Expose the shared shopping-slot rule to NameChain.exe and any later XP apps.
window.GHActivateShoppingSlot = activateShoppingSlot;

function updateTaskbarActiveState(activeWindow) {

  [
    "rings-task",
    "info-task",
    "aim-task",
    "metal-task",
    "namechain-task"
  ].forEach((taskId) => {

    const taskButton = getAppWindowById(taskId);

    if (taskButton) {
      taskButton.classList.remove("active-task");
    }

  });

  const activeTask = getTaskForAppWindow(activeWindow);

  if (activeTask && activeWindow && isAppWindowVisible(activeWindow)) {
    activeTask.classList.remove("hidden");
    activeTask.classList.add("active-task");
  }

}

function ghIsRouteElementVisible(element) {
  if (!element) {
    return false;
  }

  const styles = window.getComputedStyle(element);
  return (
    !element.classList.contains("hidden") &&
    styles.display !== "none" &&
    styles.visibility !== "hidden" &&
    styles.opacity !== "0"
  );
}

function ghGetNameChainRouteHref() {
  return (
    (ghDesktop && ghDesktop.dataset && ghDesktop.dataset.namechainPageUrl) ||
    (window.GH_PRODUCT_CONFIG && window.GH_PRODUCT_CONFIG.namechainPageUrl) ||
    "/pages/custom-name-chain"
  );
}

function ghGetInfoRouteForActivePage() {
  if (!infoWindow) {
    return null;
  }

  const activePage =
    infoWindow.querySelector(".info-page.active-info-page:not(.hidden)") ||
    infoWindow.querySelector(".info-page:not(.hidden)");

  const activePageId = activePage ? activePage.id : "";
  const infoPageRouteMap = {
    infoCustomOrderPage: "customOrderPage",
    infoCustomGrillzPage: "customGrillzPage",
    infoAboutPage: "aboutPage",
    infoCustomInfoPage: "customInfoPage",
    infoFaqPage: "faqPage",
    infoPoliciesPage: "policiesPage",
    infoGenericPage: "genericPage",
    infoAllProductsPage: "allProductsPage"
  };

  const routePageId = infoPageRouteMap[activePageId];
  const configuredRoute = routePageId ? ghInfoRouteConfig(routePageId) : null;

  if (configuredRoute && configuredRoute.href) {
    return {
      href: configuredRoute.href,
      state: { type: "info", page: configuredRoute.pageId }
    };
  }

  if (activePageId === "infoEmailSignupPage") {
    return {
      href: "/#email-signup",
      state: { type: "info", page: "emailSignupPage" }
    };
  }

  const addressText = String(infoAddress?.innerText || "").trim();
  if (addressText) {
    return {
      href: addressText,
      state: { type: "info", page: activePageId || "info" }
    };
  }

  return null;
}

function ghGetProductRouteForCurrentWindow() {
  if (ghIsRouteElementVisible(collection3Page)) {
    const handle = getCollection3Handle();
    if (handle) {
      return {
        href: `/collections/${handle}`,
        state: { type: "collection", handle }
      };
    }
  }

  if (ghIsRouteElementVisible(collection2Page)) {
    const handle = getCollection2Handle();
    if (handle) {
      return {
        href: `/collections/${handle}`,
        state: { type: "collection", handle }
      };
    }
  }

  if (ghIsRouteElementVisible(ringsCollectionPage)) {
    const handle = getPrimaryCollectionHandle();
    return {
      href: `/collections/${handle}`,
      state: { type: "collection", handle }
    };
  }

  const productHandle =
    (activeShopifyProduct && activeShopifyProduct.handle) ||
    (ghProductConfig.cartProductHandle || "");

  // Only synchronize a product route when we actually have a Shopify product.
  // The old theme fallback `/products/interlocking-pendant` was a template/demo
  // address and could poison browser history when an empty product window briefly
  // became active during window restoration.
  const productHref =
    (activeShopifyProduct && activeShopifyProduct.url) ||
    (ghProductConfig.cartProductHandle ? (ghProductConfig.cartProductUrl || "") : "");

  if (productHref && !ghIsLegacyTemplateProductRoute(productHref)) {
    return {
      href: productHref,
      state: { type: "product", handle: productHandle || "" }
    };
  }

  return null;
}

function ghGetRouteForAppWindow(targetWindow) {
  if (!targetWindow) {
    return null;
  }

  if (targetWindow.id === "window") {
    return ghGetProductRouteForCurrentWindow();
  }

  if (targetWindow.id === "infoWindow") {
    return ghGetInfoRouteForActivePage();
  }

  if (targetWindow.id === "namechainWindow") {
    return {
      href: ghGetNameChainRouteHref(),
      state: { type: "namechain" }
    };
  }

  if (targetWindow.id === "aimWindow") {
    // Utility windows should be visible in the address bar, but must NOT create
    // new browser-history entries. ghSyncXpRouteForAppWindow uses replaceState,
    // so Back/Forward remains owned by real product/collection/page navigation.
    return {
      href: ghUtilityHref(GH_UTILITY_HASH_MESSENGER),
      state: { type: "utility", utility: "messenger" }
    };
  }

  if (targetWindow.id === "metalWindow") {
    return {
      href: ghUtilityHref(GH_UTILITY_HASH_METAL),
      state: { type: "utility", utility: "metal-pricing" }
    };
  }

  return null;
}

function ghSyncXpRouteForAppWindow(targetWindow) {
  const route = ghGetRouteForAppWindow(targetWindow);
  if (!route || !route.href) {
    return false;
  }

  return ghReplaceXpRoute(route.href, route.state || {});
}

window.GHSyncXpRouteForWindow = ghSyncXpRouteForAppWindow;

function bringToFront(targetWindow) {

  if (!targetWindow) {
    return;
  }

  // Product/Collection and NameChain.exe may coexist; activation only manages focus.
  activateShoppingSlot(targetWindow);

  if (!isAppWindowVisible(targetWindow)) {
    return;
  }

  const highestWindowZ = getHighestWindowZ();

  if (highestWindowZ >= GH_WINDOW_Z_CEILING) {
    normalizeVisibleWindowZStack(targetWindow);
  } else {
    topWindowZ = Math.max(highestWindowZ, GH_WINDOW_Z_BASE) + 1;
    targetWindow.style.setProperty(
      "z-index",
      String(topWindowZ),
      "important"
    );
  }

  getAppWindows().forEach((singleWindow) => {
    singleWindow.classList.remove("active-window");
  });

  targetWindow.classList.add("active-window");

  updateTaskbarActiveState(targetWindow);
  ghSyncXpRouteForAppWindow(targetWindow);
}

function activateTopVisibleWindow() {

  const visibleWindows = getAppWindows()
    .filter(isAppWindowVisible)
    .sort((a, b) => {

      const zA =
        parseInt(a.style.zIndex, 10) ||
        parseInt(window.getComputedStyle(a).zIndex, 10) ||
        0;

      const zB =
        parseInt(b.style.zIndex, 10) ||
        parseInt(window.getComputedStyle(b).zIndex, 10) ||
        0;

      return zB - zA;

    });

  if (visibleWindows.length) {
    bringToFront(visibleWindows[0]);
    return;
  }

  getAppWindows().forEach((singleWindow) => {
    singleWindow.classList.remove("active-window");
  });

  updateTaskbarActiveState(null);

  // IMPORTANT: do not rewrite the browser URL here. During hard navigation,
  // BFCache replay, and cross-route window restoration there are legitimate
  // frames where every XP window is temporarily hidden. The old behavior used
  // that transient state to replace the current route with `/`, which is why
  // Back/Forward could randomly jump home. Explicit navigation owns history.
  ghEnsureHomeStickyNote();
}


function initAutoActivateWindowAfterClose() {

  if (!window.MutationObserver) {
    return;
  }

  getAppWindows().forEach((observedWindow) => {

    const windowObserver = new MutationObserver(() => {

      if (
        observedWindow.classList.contains("active-window") &&
        !isAppWindowVisible(observedWindow)
      ) {
        observedWindow.classList.remove("active-window");
        window.setTimeout(activateTopVisibleWindow, 0);
        window.setTimeout(activateTopVisibleWindow, 60);
      }

    });

    windowObserver.observe(observedWindow, {
      attributes: true,
      attributeFilter: ["class", "style"]
    });

  });

}

initAutoActivateWindowAfterClose();

window.GHBringToFront = bringToFront;
window.GHActivateTopVisibleWindow = activateTopVisibleWindow;


function hideInfoPagesNew() {

  infoPages.forEach((page) => {

    page.classList.add("hidden");
    page.classList.remove("active-info-page");

    page.style.display = "none";

  });

}

function openInfoWindow(pageId, title, addressText) {

  if (!infoWindow) {
    return;
  }

  hideInfoPagesNew();

  let hasInfoQuickLinks = false;
  infoQuickLinkMenus.forEach((menu) => {
    const isCurrentMenu = menu.dataset.infoQuicklinksFor === pageId;
    menu.classList.toggle("hidden", !isCurrentMenu);
    if (isCurrentMenu) hasInfoQuickLinks = true;
  });

  if (infoQuickLinksHost) {
    infoQuickLinksHost.classList.toggle("hidden", !hasInfoQuickLinks);
  }

  const targetPage = document.getElementById(pageId);

  if (targetPage) {
    targetPage.classList.remove("hidden");
    targetPage.classList.add("active-info-page");
    targetPage.style.display = "block";

    /*
      GH SEO V65 - Every info page starts at the true top.
      The active info page is its own scroll container, so its scrollTop can
      survive XP page switches and make the new page look like an older layout
      because the heading/intro are above the visible area.
    */
    targetPage.scrollTop = 0;
    window.requestAnimationFrame(() => {
      targetPage.scrollTop = 0;
    });
    window.setTimeout(() => {
      targetPage.scrollTop = 0;
    }, 80);
  }

  if (infoWindowTitle) {
    infoWindowTitle.innerText = title;
  }

  const infoWindowIcon = document.getElementById("infoWindowIcon");

  let currentInfoIconUrl = ghThemeAsset(
    "startAboutIconUrl",
    ghThemeAsset("aboutIconUrl", "https://cdn-icons-png.flaticon.com/512/3135/3135715.png")
  );

  if (pageId === "infoCustomInfoPage") {
    currentInfoIconUrl = ghThemeAsset(
      "startCustomInfoIconUrl",
      ghThemeAsset("customInfoIconUrl", ghThemeAsset("aboutIconUrl", "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"))
    );
    updateCustomInfoGalleryImage();
  }

  if (pageId === "infoFaqPage") {
    currentInfoIconUrl = ghThemeAsset(
      "startFaqIconUrl",
      "https://cdn-icons-png.flaticon.com/512/1828/1828919.png"
    );
  }

  if (pageId === "infoCustomOrderPage") {
    currentInfoIconUrl = ghThemeAsset(
      "startCustomOrderIconUrl",
      "https://cdn-icons-png.flaticon.com/512/1040/1040230.png"
    );
  }

  if (pageId === "infoCustomGrillzPage") {
    currentInfoIconUrl = ghThemeAsset(
      "startCustomGrillzIconUrl",
      ghThemeAsset("customGrillzIconUrl", "https://cdn-icons-png.flaticon.com/512/1040/1040230.png")
    );
  }

  if (pageId === "infoEmailSignupPage") {
    currentInfoIconUrl = ghThemeAsset(
      "startEmailSignupIconUrl",
      "https://cdn-icons-png.flaticon.com/512/561/561127.png"
    );
  }

  if (pageId === "infoAllProductsPage") {
    currentInfoIconUrl = ghThemeAsset(
      "startAllProductsIconUrl",
      "https://cdn-icons-png.flaticon.com/512/3081/3081559.png"
    );
  }

  if (infoWindowIcon) {
    infoWindowIcon.src = currentInfoIconUrl;
  }

  if (infoTask) {
    infoTask.style.setProperty(
      "--gh-info-task-icon",
      ghCssUrl(currentInfoIconUrl)
    );
  }

  if (infoAddress) {
    infoAddress.innerText = addressText;
  }

  infoWindow.classList.remove("hidden");
  infoWindow.classList.remove("minimized");

  if (infoTask) {
    infoTask.classList.remove("hidden");
    infoTask.innerText = title;
  }

  closeStartMenu();

  enforceActiveInfoPageOnly();
  bringToFront(infoWindow);
}

  function setStartMenuFocusMode(active) {
    const shouldActivate = !!active;
    const desktopTarget = ghDesktop || document.getElementById("desktop");
    const overlayTarget = startFocusOverlay || document.getElementById("ghStartMenuFocusOverlay");

    if (desktopTarget) {
      desktopTarget.classList.toggle("gh-start-menu-focus-mode", shouldActivate);
    }

    if (overlayTarget) {
      overlayTarget.classList.toggle("hidden", !shouldActivate);
      overlayTarget.setAttribute("aria-hidden", shouldActivate ? "false" : "true");
    }
  }

  function shouldUseStartMenuFocusMode() {
    // Any time the Start Menu is open, turn on focus mode.
    // This works with zero windows, one window, or all four app slots open.
    return !!(startMenu && !startMenu.classList.contains("hidden"));
  }

  function syncStartMenuFocusMode() {
    setStartMenuFocusMode(shouldUseStartMenuFocusMode());
  }

  function closeStartMenu() {

    if (startMenu) {
      startMenu.classList.add("hidden");
    }

    if (startButton) {
      startButton.classList.remove("active");
    }

    setStartMenuFocusMode(false);
  }

function hideInfoPages() {

  oldInfoPages.forEach((page) => {
    page.classList.add("hidden");
  });
}

  function showMainWindow() {

    if (windowEl) {
      activateShoppingSlot(windowEl);
      windowEl.classList.remove("hidden");
      windowEl.classList.remove("minimized");
      windowEl.classList.remove("viewer-mode");
      windowEl.classList.remove("gallery-mode");
    }

    if (ringsTask) {
      ringsTask.classList.remove("hidden");
    }

    if (toolbar) {
      toolbar.classList.remove("hidden");
    }

    if (addressBar) {
      addressBar.classList.remove("hidden");
    }

    if (windowContent) {
      windowContent.scrollTop = 0;
    }
  }

  function hideEverythingInsideWindow() {

    if (ringsCollectionPage) {
      ringsCollectionPage.classList.add("hidden");
    }
    if (collection2Page) {
      collection2Page.classList.add("hidden");
    }
    if (collection3Page) {
      collection3Page.classList.add("hidden");
    }

    if (productQuickLinksHost) {
      productQuickLinksHost.classList.add("hidden");
    }

    hideInfoPages();

    if (productLayout) {
      productLayout.classList.add("hidden");
    }

    if (relatedProducts) {
      relatedProducts.classList.add("hidden");
    }

    if (viewer3d) {
      viewer3d.classList.add("hidden");
    }

    if (photoGallery) {
      photoGallery.classList.add("hidden");
    }

    if (viewerBtn) {
      viewerBtn.classList.remove("active-viewer");
    }

    if (windowEl) {
      windowEl.classList.remove("viewer-mode");
    }
  }

  function decodeHtmlEntities(value) {
    const temp = document.createElement("textarea");
    temp.innerHTML = String(value || "");
    return temp.value;
  }

  function cleanMoneyText(value) {
    return decodeHtmlEntities(value)
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function updateProduct(product) {

    if (productImage && product.image) {
      productImage.src = product.image;
      productImage.alt = product.title || "GoldHearted jewelry product";
    }

    if (productTitle) {
      productTitle.innerText = product.title || "Product";
    }

    if (productPrice) {
      productPrice.innerText = cleanMoneyText(product.price || "");
    }

    if (productDescription) {
      if (typeof product.descriptionHtml !== "undefined" && product.descriptionHtml) {
        // Preserve Shopify's rich-text HTML for products opened from collections,
        // desktop shortcuts, direct URLs, and public product JSON fallbacks.
        productDescription.innerHTML = formatGhProductDescriptionHtml(product.descriptionHtml);
      } else if (typeof product.description !== "undefined") {
        productDescription.textContent = product.description || "";
      }
    }
  }

  function ghEscapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function ghDescriptionTextFromHtml(html) {
    const temp = document.createElement("div");
    temp.innerHTML = String(html || "");

    // Shopify's editor can represent visual spacing with a mix of paragraphs,
    // divs and BR tags. Convert those boundaries to real newlines first so the
    // specification parser does not depend on one particular editor output.
    temp.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
    temp.querySelectorAll("p,div,li,h1,h2,h3,h4,h5,h6").forEach((el) => {
      el.appendChild(document.createTextNode("\n"));
    });

    return String(temp.textContent || "")
      .replace(/\u00a0/g, " ")
      .replace(/[ \t]+/g, " ")
      .replace(/ *\n */g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
  }

  function ghSpecRowsFromWeightText(value) {
    const text = String(value || "").replace(/\n+/g, " ").trim();
    const rows = [];
    const weightPattern = /([^—–]+?)\s*[—–]\s*(?:approx(?:imately)?\.?\s*)?(\d+(?:\.\d+)?)\s*g\b/gi;
    let match;

    while ((match = weightPattern.exec(text))) {
      let label = String(match[1] || "").replace(/^[,;:\s]+|[,;:\s]+$/g, "").trim();
      // If editor spacing collapsed, a previous label can cling to the next one.
      // Keep only the material phrase after the last obvious sentence boundary.
      label = label.split(/(?:\.|\n)\s+/).pop().trim();
      if (label) rows.push([label, `${match[2]} g`]);
    }

    return rows;
  }

  function ghStoneOptionsFromText(value) {
    const text = String(value || "").trim();
    if (!text) return [];

    const known = [
      "Natural Diamond",
      "Lab-Grown Diamond",
      "Lab Grown Diamond",
      "Moissanite",
      "Natural Moissanite",
      "Colored Gemstones",
      "Colored Gemstone",
      "Gemstones",
      "Gemstone"
    ];
    const hits = [];

    known.forEach((name) => {
      const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      if (new RegExp(escaped, "i").test(text)) hits.push(name.replace("Lab Grown", "Lab-Grown"));
    });

    if (hits.length) return Array.from(new Set(hits));

    return text
      .split(/\n|,|\||;/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function ghBuildProductSpecsHtml(text) {
    const specHeading = /(?:pendant|product)?\s*specifications?\s*:?/i;
    const headingMatch = specHeading.exec(text);
    if (!headingMatch) return null;

    const story = text.slice(0, headingMatch.index).trim();
    const specs = text.slice(headingMatch.index + headingMatch[0].length).trim();

    const height = specs.match(/height\s*:\s*([\d.]+)\s*mm/i);
    const width = specs.match(/width\s*:\s*([\d.]+)\s*mm/i);
    const depth = specs.match(/depth\s*:\s*([\d.]+)\s*mm/i);

    const weightHeading = /approx(?:imate|imately)?\s+metal\s+weight\s*:?/i;
    const stoneHeading = /stone\s+options?\s*:?/i;
    const weightMatch = weightHeading.exec(specs);
    const stoneMatch = stoneHeading.exec(specs);

    let weightsText = "";
    if (weightMatch) {
      const start = weightMatch.index + weightMatch[0].length;
      const end = stoneMatch && stoneMatch.index > start ? stoneMatch.index : specs.length;
      weightsText = specs.slice(start, end).trim();
    }

    const weightRows = ghSpecRowsFromWeightText(weightsText);
    const stoneText = stoneMatch
      ? specs.slice(stoneMatch.index + stoneMatch[0].length).trim()
      : "";
    const stones = ghStoneOptionsFromText(stoneText);

    // If the expected fields aren't present, leave Shopify's original rich text alone.
    if (!height && !width && !depth && !weightRows.length && !stones.length) return null;

    const dimensionRows = [];
    if (height) dimensionRows.push(["Height", `${height[1]} mm`]);
    if (width) dimensionRows.push(["Width", `${width[1]} mm`]);
    if (depth) dimensionRows.push(["Depth", `${depth[1]} mm`]);

    const rowHtml = (rows) => rows.map(([label, value]) => `
      <div class="gh-product-spec-row">
        <span class="gh-product-spec-label">${ghEscapeHtml(label)}</span>
        <span class="gh-product-spec-value">${ghEscapeHtml(value)}</span>
      </div>`).join("");

    const storyHtml = story
      ? `<div class="gh-product-story"><p>${ghEscapeHtml(story)}</p></div>`
      : "";

    const dimensionsHtml = dimensionRows.length ? `
      <div class="gh-product-spec-group gh-product-spec-dimensions">
        <div class="gh-product-spec-subtitle">Dimensions</div>
        <div class="gh-product-spec-rows">${rowHtml(dimensionRows)}</div>
      </div>` : "";

    const weightsHtml = weightRows.length ? `
      <div class="gh-product-spec-group gh-product-spec-weights">
        <div class="gh-product-spec-subtitle">Approximate Metal Weight</div>
        <div class="gh-product-spec-rows">${rowHtml(weightRows)}</div>
      </div>` : "";

    const stonesHtml = stones.length ? `
      <div class="gh-product-spec-group gh-product-spec-stones">
        <div class="gh-product-spec-subtitle">Stone Options</div>
        <div class="gh-product-stone-list">${stones.map((stone) => `<span>${ghEscapeHtml(stone)}</span>`).join("")}</div>
      </div>` : "";

    return `${storyHtml}
      <div class="gh-product-spec-card" aria-label="Product specifications">
        <div class="gh-product-spec-title">Pendant Specifications</div>
        <div class="gh-product-spec-layout">
          ${dimensionsHtml}
          ${weightsHtml}
          ${stonesHtml}
        </div>
      </div>`;
  }

  function formatGhProductDescriptionHtml(html) {
    const sourceHtml = String(html || "");
    const normalizedText = ghDescriptionTextFromHtml(sourceHtml);
    const customSpecs = ghBuildProductSpecsHtml(normalizedText);

    // Only the specification area is custom. Products without the expected
    // specification labels continue to use Shopify's original rich text.
    if (customSpecs) return customSpecs;

    const temp = document.createElement("div");
    temp.innerHTML = sourceHtml;

    const headingNames = new Set([
      "pendant specifications",
      "product specifications",
      "specifications",
      "stone options",
      "material options",
      "materials",
      "dimensions",
      "metal weights",
      "approximate metal weight"
    ]);

    Array.from(temp.querySelectorAll("p")).forEach((paragraph) => {
      const clean = String(paragraph.textContent || "").replace(/\s+/g, " ").trim();
      if (headingNames.has(clean.toLowerCase())) {
        const heading = document.createElement("h3");
        heading.textContent = clean;
        paragraph.replaceWith(heading);
      }
    });

    return temp.innerHTML;
  }

  function normalizeMediaList(items) {
    return (Array.isArray(items) ? items : [])
      .map((item) => String(item || "").trim())
      .filter(Boolean);
  }

  function getDefaultProductIconUrl() {
    return ghThemeAsset(
      "ringsIconUrl",
      "https://cdn-icons-png.flaticon.com/512/716/716784.png"
    );
  }

  function setProductWindowIcon(iconUrl) {
    const finalIcon = iconUrl || getDefaultProductIconUrl();

    if (productWindowIcon && finalIcon) {
      productWindowIcon.src = finalIcon;
    }

    if (ringsTask && finalIcon) {
      ringsTask.style.setProperty("--gh-rings-task-icon", ghCssUrl(finalIcon));
    }
  }

  function setProductWindowTaskTitle(title) {
    const finalTitle = title || ghThemeText("ringsTaskTitle", "Collection Template");

    if (ringsTask) {
      ringsTask.innerText = finalTitle;
    }

    if (productWindowTitleText) {
      productWindowTitleText.innerText = finalTitle;
    }
  }

  function setProductToolbarAvailability(hasModel, hasVideos) {
    activeProductHasModel = !!hasModel;
    activeProductHasVideos = !!hasVideos;

    if (viewerToolbarItem) {
      viewerToolbarItem.classList.toggle("hidden", !activeProductHasModel);
    }

    if (mediaToolbarItem) {
      mediaToolbarItem.classList.toggle("hidden", !activeProductHasVideos);
    }

    if (!activeProductHasModel && viewer3d) {
      viewer3d.classList.add("hidden");
    }

    if (!activeProductHasVideos && wmpPlayer) {
      wmpPlayer.classList.add("hidden");
    }
  }

  function setProductModelUrl(modelUrl, allowFallback = true) {
    const finalModelUrl = String(modelUrl || (allowFallback ? ghProductConfig.modelUrl : "") || "").trim();

    if (!modelViewer) return;

    if (!finalModelUrl) {
      modelViewer.removeAttribute("src");
      viewerLoaded = false;
      if (viewerLoading) {
        viewerLoading.classList.add("hidden");
      }
      return;
    }

    const currentSrc = modelViewer.getAttribute("src") || "";
    if (currentSrc !== finalModelUrl) {
      modelViewer.setAttribute("src", finalModelUrl);
      viewerLoaded = false;
      if (viewerLoading) {
        viewerLoading.classList.remove("hidden");
      }
    }
  }

  function setProductPlaylist(videoUrls, allowFallback = true) {
    const productVideos = normalizeMediaList(videoUrls);
    playlist = productVideos.length ? productVideos : (allowFallback ? defaultPlaylist.slice() : []);
    currentVideo = 0;

    if (video) {
      video.pause();
      video.src = playlist[0] || "";
      showPlayOverlay();
    }
  }

  function applyProductXpAssets(product) {
    if (!product) {
      setProductWindowIcon(GH_FALLBACK_IMAGE_URL);
      setProductWindowTaskTitle(ghThemeText("ringsTaskTitle", "Collection Template"));
      setProductToolbarAvailability(!!ghProductConfig.modelUrl, defaultPlaylist.length > 0);
      setProductModelUrl(ghProductConfig.modelUrl, true);
      setProductPlaylist(defaultPlaylist, true);
      updateReviewAppLinks(null);
      return;
    }

    const productVideos = normalizeMediaList(product.xpVideos || []);

    setProductWindowIcon(product.xpIcon || GH_FALLBACK_IMAGE_URL);
    setProductWindowTaskTitle(product.taskLabel || ghThemeText("ringsTaskTitle", "Collection Template"));
    /* Keep the 3D and media buttons visible for featured products, but do not fall back to template files. */
    setProductToolbarAvailability(true, true);
    setProductModelUrl(product.xpModelUrl || "", false);
    setProductPlaylist(productVideos, false);
    updateReviewAppLinks(product);
  }

  function getProductGalleryList(product) {
    if (!product) {
      return ghProductConfig.galleryImages || [];
    }

    /*
      Use the Shopify product image list first so View Gallery always reflects every
      image currently uploaded to the product. The older XP gallery metafields remain
      only as a fallback for legacy products that do not expose product.images.
    */
    if (Array.isArray(product.images) && product.images.filter(Boolean).length) {
      return product.images;
    }

    const xpGallery = normalizeMediaList(product.xpGalleryImages || []);
    if (xpGallery.length) {
      return xpGallery;
    }

    return product.image ? [product.image] : [];
  }

  function bindProductGalleryThumb(thumb) {
    if (!thumb) return;
    thumb.addEventListener("click", () => {
      galleryIndex = Number(thumb.dataset.index) || 0;
      galleryRotation = 0;
      updateGalleryImage();
    });
  }

  function getProductGalleryAlt(index) {
    const activeTitle = (productTitle && productTitle.textContent ? productTitle.textContent : ghProductConfig.productTitle || "GoldHearted jewelry").trim();
    return activeTitle + " product image " + (Number(index || 0) + 1);
  }

  function renderProductGalleryThumbs() {
    if (!productGalleryThumbRow) return;

    productGalleryThumbRow.innerHTML = "";

    galleryImages.forEach((src, index) => {
      if (!src) return;

      const thumb = document.createElement("button");
      thumb.type = "button";
      thumb.className = "gallery-thumb" + (index === 0 ? " active-gallery-thumb" : "");
      thumb.dataset.index = String(index);
      thumb.setAttribute("aria-label", "Open Picture " + (index + 1));

      const image = document.createElement("img");
      image.src = src;
      image.alt = getProductGalleryAlt(index);
      image.loading = "lazy";
      image.decoding = "async";

      const label = document.createElement("span");
      label.textContent = "Picture " + (index + 1);

      thumb.appendChild(image);
      thumb.appendChild(label);
      productGalleryThumbRow.appendChild(thumb);
      bindProductGalleryThumb(thumb);
    });

    galleryThumbs = document.querySelectorAll(".gallery-thumb");
  }

  function setProductGalleryImages(images) {
    const cleanImages = Array.isArray(images) ? images.filter(Boolean) : [];
    galleryImages = cleanImages.length ? cleanImages : (ghProductConfig.galleryImages || []).filter(Boolean);
    if (!galleryImages.length) galleryImages = defaultGalleryImages;

    galleryIndex = 0;
    galleryRotation = 0;
    renderProductGalleryThumbs();

    if (galleryMainImage && galleryImages[0]) {
      galleryMainImage.src = galleryImages[0];
      galleryMainImage.alt = getProductGalleryAlt(0);
      galleryMainImage.style.transform = "rotate(0deg)";
    }
  }


  function updateProductDonation(product) {
    if (!productDonationNote) return;

    const hasDynamicProduct = !!product;
    const note = hasDynamicProduct
      ? String(product.xpDonationNote || "").trim()
      : String(productDonationNote.dataset.fallbackText || "").trim();
    const fallbackEnabled = productDonationNote.dataset.fallbackEnabled === "true";

    if (hasDynamicProduct && !note) {
      productDonationNote.classList.add("hidden");
      return;
    }

    if (!hasDynamicProduct && (!fallbackEnabled || !note)) {
      productDonationNote.classList.add("hidden");
      return;
    }

    const linkLabel = hasDynamicProduct
      ? String(product.xpDonationLinkLabel || "").trim()
      : String(productDonationNote.dataset.fallbackLinkLabel || "").trim();
    const linkUrl = hasDynamicProduct
      ? String(product.xpDonationLinkUrl || "").trim()
      : String(productDonationNote.dataset.fallbackLinkUrl || "").trim();

    if (productDonationText) {
      productDonationText.textContent = note;
    }

    if (productDonationLink) {
      if (linkLabel && linkUrl && linkUrl !== "#") {
        productDonationLink.textContent = linkLabel;
        productDonationLink.href = linkUrl;
        productDonationLink.classList.remove("hidden");
      } else if (linkLabel && !hasDynamicProduct) {
        productDonationLink.textContent = linkLabel;
        productDonationLink.href = linkUrl || "#";
        productDonationLink.classList.remove("hidden");
      } else {
        productDonationLink.classList.add("hidden");
      }
    }

    productDonationNote.classList.remove("hidden");
  }

  function ghNumber(value, fallback = 0) {
    const clean = String(value ?? "")
      .replace(/[$,]/g, "")
      .trim();
    const number = Number(clean);
    return Number.isFinite(number) ? number : fallback;
  }

  function ghFormatDonationMoney(value, currency) {
    const amount = ghNumber(value, 0);
    const code = String(currency || "USD").trim() || "USD";

    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: code,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (error) {
      return "$" + amount.toLocaleString("en-US", {
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      });
    }
  }

  function ghFundraiserFromDataset(element) {
    if (!element) return null;

    return {
      enabled: ghIsTrueLike(element.dataset.enabled),
      title: element.dataset.title || "GoldHearted Giving Goal",
      nonprofitName: element.dataset.nonprofitName || "",
      nonprofitUrl: element.dataset.nonprofitUrl || "",
      goal: ghNumber(element.dataset.goal, 0),
      raised: ghNumber(element.dataset.raised, 0),
      perSale: ghNumber(element.dataset.perSale, 0),
      perSaleSilver: ghNumber(element.dataset.perSaleSilver, 0),
      perSaleGold: ghNumber(element.dataset.perSaleGold, 0),
      perSalePlatinum: ghNumber(element.dataset.perSalePlatinum, 0),
      blurb: element.dataset.blurb || "",
      logoUrl: element.dataset.logoUrl || "",
      currency: element.dataset.currency || "USD"
    };
  }

  function ghGetProductFundraiser(product) {
    if (product && product.xpFundraiser) {
      return product.xpFundraiser;
    }

    if (!product && ghProductConfig.productFundraiser) {
      return ghProductConfig.productFundraiser;
    }

    if (!product) {
      return ghFundraiserFromDataset(productDonationThermometer);
    }

    return null;
  }

  function ghSelectedFundraiserMetal(selectedVariant) {
    const parts = [];

    if (selectedAutomaticMetalValue) parts.push(selectedAutomaticMetalValue);
    if (selectedVariant && Array.isArray(selectedVariant.options)) parts.push(...selectedVariant.options);
    if (selectedVariant && selectedVariant.title) parts.push(selectedVariant.title);
    if (currentMaterial) parts.push(currentMaterial);

    const text = cleanOptionValue(parts.filter(Boolean).join(" "));

    if (text.includes("platinum") || text.includes(" plat ") || text.startsWith("plat ") || text.endsWith(" plat")) {
      return "platinum";
    }

    if (text.includes("sterling") || text.includes("silver") || text.includes("925") || text.includes(".925")) {
      return "silver";
    }

    if (text.includes("gold") || text.includes("10k") || text.includes("14k") || text.includes("18k") || text.includes("22k")) {
      return "gold";
    }

    return "";
  }

  function ghFundraiserMetalLabel(selectedVariant) {
    const metal = ghSelectedFundraiserMetal(selectedVariant);
    if (metal === "silver") return "Silver";
    if (metal === "gold") return "Gold";
    if (metal === "platinum") return "Platinum";
    return "Selected metal";
  }

  function ghFundraiserPerSaleForMetal(fundraiser, selectedVariant) {
    const fallback = Math.max(0, ghNumber(fundraiser?.perSale, 0));
    const metal = ghSelectedFundraiserMetal(selectedVariant);

    if (metal === "silver") {
      const amount = ghNumber(fundraiser?.perSaleSilver, 0);
      return amount > 0 ? amount : fallback;
    }

    if (metal === "gold") {
      const amount = ghNumber(fundraiser?.perSaleGold, 0);
      return amount > 0 ? amount : fallback;
    }

    if (metal === "platinum") {
      const amount = ghNumber(fundraiser?.perSalePlatinum, 0);
      return amount > 0 ? amount : fallback;
    }

    return fallback;
  }

  function updateProductFundraiser(product, selectedVariantOverride = null) {
    if (!productDonationThermometer) return;

    const fundraiser = ghGetProductFundraiser(product);
    const enabled = !!(fundraiser && ghIsTrueLike(fundraiser.enabled));
    const goal = ghNumber(fundraiser?.goal, 0);
    const raised = Math.max(0, ghNumber(fundraiser?.raised, 0));
    const currency = fundraiser?.currency || productDonationThermometer.dataset.currency || "USD";

    if (!enabled || goal <= 0) {
      productDonationThermometer.classList.add("hidden");
      if (productGivingPerSaleTop) productGivingPerSaleTop.classList.add("hidden");
      return;
    }

    const percent = Math.max(0, Math.min(100, (raised / goal) * 100));
    const percentText = Math.round(percent) + "% funded";
    const title = String(fundraiser.title || "GoldHearted Giving Goal").trim();
    const nonprofitName = String(fundraiser.nonprofitName || "").trim();
    const nonprofitUrl = String(fundraiser.nonprofitUrl || "").trim();
    const selectedVariant = selectedVariantOverride || getVariantForMaterial(currentMaterial) || getFirstAvailableVariant();
    const perSale = ghFundraiserPerSaleForMetal(fundraiser, selectedVariant);
    const blurb = String(fundraiser.blurb || "").trim();
    const logoUrl = String(fundraiser.logoUrl || "").trim();
    const goalMoney = ghFormatDonationMoney(goal, currency);
    const perSaleMoney = perSale > 0 ? ghFormatDonationMoney(perSale, currency) : "";

    if (productGivingPerSaleTop && productGivingPerSaleAmount) {
      if (perSaleMoney) {
        productGivingPerSaleAmount.textContent = perSaleMoney + " per sale";
        productGivingPerSaleTop.classList.remove("hidden");
      } else {
        productGivingPerSaleTop.classList.add("hidden");
      }
    }

    productDonationThermometer.style.setProperty("--gh-fundraiser-percent", percent.toFixed(2) + "%");

    if (fundraiserTitle) {
      fundraiserTitle.textContent = title;
    }

    if (fundraiserTrackFill) {
      fundraiserTrackFill.style.width = percent.toFixed(2) + "%";
    }

    if (fundraiserStatus) {
      fundraiserStatus.textContent = ghFormatDonationMoney(raised, currency) + " raised";
    }

    if (fundraiserGoalText) {
      // The selected-metal donation is shown beside the product price instead.
      // Keep the thermometer footer focused on the overall fundraising goal.
      fundraiserGoalText.textContent = "Goal: " + goalMoney;
    }

    if (fundraiserPercentText) {
      fundraiserPercentText.textContent = percentText;
    }

    if (fundraiserBlurb) {
      const defaultBlurb = nonprofitName
        ? "Every eligible purchase helps support " + nonprofitName + "."
        : "Every eligible purchase helps this GoldHearted giving goal.";
      fundraiserBlurb.textContent = blurb || defaultBlurb;
    }

    if (fundraiserNonprofitLink) {
      if (nonprofitName && nonprofitUrl && nonprofitUrl !== "#") {
        fundraiserNonprofitLink.textContent = "Learn about " + nonprofitName;
        fundraiserNonprofitLink.href = nonprofitUrl;
        fundraiserNonprofitLink.classList.remove("hidden");
      } else if (nonprofitName) {
        fundraiserNonprofitLink.textContent = nonprofitName;
        fundraiserNonprofitLink.removeAttribute("href");
        fundraiserNonprofitLink.classList.remove("hidden");
      } else {
        fundraiserNonprofitLink.classList.add("hidden");
      }
    }


    if (fundraiserLogoBox && fundraiserLogoImage) {
      if (logoUrl) {
        fundraiserLogoImage.src = logoUrl;
        fundraiserLogoImage.alt = nonprofitName ? nonprofitName + " logo" : "Donation partner logo";
        fundraiserLogoBox.classList.remove("hidden");
      } else {
        fundraiserLogoImage.removeAttribute("src");
        fundraiserLogoImage.alt = "";
        fundraiserLogoBox.classList.add("hidden");
      }
    }

    productDonationThermometer.classList.remove("hidden");
  }


  function ghCleanNoteText(value) {
    return String(value || "").trim();
  }

  function ghIsTrueLike(value) {
    if (value === true) return true;
    const text = String(value || "").trim().toLowerCase();
    return text === "true" || text === "1" || text === "yes" || text === "on";
  }

  function getProductNoteConfig(product) {
    const source = product || defaultProductNoteSource;

    const productLabel = ghCleanNoteText(source.xpNotesLabel);
    const productPlaceholder = ghCleanNoteText(source.xpNotesPlaceholder);
    const productHelp = ghCleanNoteText(source.xpNotesHelp);

    const collectionLabel = ghCleanNoteText(source.xpCollectionNotesLabel);
    const collectionPlaceholder = ghCleanNoteText(source.xpCollectionNotesPlaceholder);
    const collectionHelp = ghCleanNoteText(source.xpCollectionNotesHelp);

    const enabled =
      ghIsTrueLike(source.xpNotesEnabled) ||
      ghIsTrueLike(source.xpCollectionNotesEnabled) ||
      !!productLabel ||
      !!productPlaceholder ||
      !!productHelp ||
      !!collectionLabel ||
      !!collectionPlaceholder ||
      !!collectionHelp;

    return {
      enabled: enabled,
      label: productLabel || collectionLabel || "Personalization / Order Notes",
      placeholder: productPlaceholder || collectionPlaceholder || "Name chain, engraving text, spelling, or special order notes...",
      help: productHelp || collectionHelp || "Optional — this will stay attached to the cart item and order."
    };
  }

  function updateProductNoteBox(product) {
    if (!productNoteGroup || !productOrderNote) {
      return;
    }

    const config = getProductNoteConfig(product);

    if (!config.enabled) {
      productNoteGroup.classList.add("hidden");
      productOrderNote.value = "";
      return;
    }

    if (productOrderNoteLabel) {
      productOrderNoteLabel.textContent = config.label;
    }

    productOrderNote.placeholder = config.placeholder;

    if (productOrderNoteHelp) {
      productOrderNoteHelp.textContent = config.help;
      productOrderNoteHelp.classList.toggle("hidden", !config.help);
    }

    productNoteGroup.classList.remove("hidden");
  }

  function getCollection2NotesFallback() {
    if (!ghDesktop || !ghDesktop.dataset) {
      return null;
    }

    return {
      xpCollectionNotesEnabled: ghDesktop.dataset.collection2NotesEnabled === "true",
      xpCollectionNotesLabel: ghDesktop.dataset.collection2NotesLabel || "",
      xpCollectionNotesPlaceholder: ghDesktop.dataset.collection2NotesPlaceholder || "",
      xpCollectionNotesHelp: ghDesktop.dataset.collection2NotesHelp || ""
    };
  }

  function getCollection3NotesFallback() {
    if (!ghDesktop || !ghDesktop.dataset) {
      return null;
    }

    return {
      xpCollectionNotesEnabled: ghDesktop.dataset.collection3NotesEnabled === "true",
      xpCollectionNotesLabel: ghDesktop.dataset.collection3NotesLabel || "",
      xpCollectionNotesPlaceholder: ghDesktop.dataset.collection3NotesPlaceholder || "",
      xpCollectionNotesHelp: ghDesktop.dataset.collection3NotesHelp || ""
    };
  }

  function applyCollectionNotesFallback(product, fallback) {
    if (!product || !fallback) {
      return product;
    }

    product.xpCollectionNotesEnabled = !!fallback.xpCollectionNotesEnabled;
    product.xpCollectionNotesLabel = fallback.xpCollectionNotesLabel || "";
    product.xpCollectionNotesPlaceholder = fallback.xpCollectionNotesPlaceholder || "";
    product.xpCollectionNotesHelp = fallback.xpCollectionNotesHelp || "";

    return product;
  }

  function updateDynamicProductDisplay() {
    if (!activeShopifyProduct) return;

    const selectedVariant = getVariantForMaterial(currentMaterial) || getFirstAvailableVariant();
    const image = (selectedVariant && selectedVariant.image) || activeShopifyProduct.image || (galleryImages && galleryImages[0]) || goldProduct.image;
    const price = (selectedVariant && selectedVariant.price) || activeShopifyProduct.price || "";

    updateProduct({
      title: activeShopifyProduct.title,
      price: price,
      image: image,
      description: activeShopifyProduct.description || "",
      // Preserve Shopify rich-text HTML here too. Without this, every dynamic
      // product refresh (open, metal/variant change, etc.) overwrites the
      // formatted/specification description with stripped plain text.
      descriptionHtml: activeShopifyProduct.descriptionHtml || ""
    });
    updateProductDonation(activeShopifyProduct);
    updateProductFundraiser(activeShopifyProduct, selectedVariant);
    updateAddToCartButtonLabel(activeShopifyProduct);
  }

  function openDynamicShopifyProduct(product, backTarget = "collection") {
    if (!product) return;

    activeShopifyProduct = product;
    productBackTarget = backTarget;
    cartVariants = Array.isArray(product.variants) ? product.variants : [];
    currentMaterial = "gold";

    applyProductXpAssets(product);
    setProductGalleryImages(getProductGalleryList(product));

    if (productAddress) {
      productAddress.innerText = product.url || ghProductConfig.productAddress || "";
    }

    if (goldBtn) goldBtn.classList.add("active-material");
    if (silverBtn) silverBtn.classList.remove("active-material");

    setupVariantControls();
    updateCartStatus("", false);
    updateDynamicProductDisplay();
    showStorePage();

    if (windowEl) {
      bringToFront(windowEl);
    }

    const pendingInternalState = window.__ghPendingProductInternalState;
    if (
      pendingInternalState &&
      pendingInternalState.ghProductInternal &&
      String(pendingInternalState.productHandle || "") === String(product.handle || "")
    ) {
      window.__ghPendingProductInternalState = null;
      window.requestAnimationFrame(() => {
        ghApplyProductInternalHistoryState(pendingInternalState);
      });
    }
  }
  function showCollectionPage(collectionName) {
  const isCollection2 = collectionName === "collection2";
  const isCollection3 = collectionName === "collection3";
  const activeCollectionPage = isCollection3
    ? collection3Page
    : (isCollection2 ? collection2Page : ringsCollectionPage);
  const activeTaskTitle = isCollection3
    ? getCollection3Label()
    : (isCollection2 ? getCollection2Label() : ghThemeText("ringsTaskTitle", "Collection 1"));
  const activeIconUrl = isCollection3
    ? getCollection3IconUrl()
    : (isCollection2 ? getCollection2IconUrl() : ghThemeAsset("ringsIconUrl", ""));
  const activeSlug = isCollection3
    ? getCollection3Handle()
    : (isCollection2 ? getCollection2Handle() : getPrimaryCollectionHandle());

  showMainWindow();
  applyProductXpAssets(null);
  if (activeIconUrl) setProductWindowIcon(activeIconUrl);

  if (windowEl) {
    windowEl.classList.add("simple-toolbar-mode");
    windowEl.classList.remove("viewer-mode");
  }

  if (wmpPlayer) wmpPlayer.classList.add("hidden");
  if (video) video.pause();
  showPlayOverlay();

  if (ringsCollectionPage) ringsCollectionPage.classList.add("hidden");
  if (collection2Page) collection2Page.classList.add("hidden");
  if (collection3Page) collection3Page.classList.add("hidden");
  if (activeCollectionPage) activeCollectionPage.classList.remove("hidden");

  if (productQuickLinksHost) {
    productQuickLinksHost.classList.toggle("hidden", isCollection2 || isCollection3);
  }

  if (productLayout) productLayout.classList.add("hidden");
  if (relatedProducts) relatedProducts.classList.add("hidden");
  if (viewer3d) viewer3d.classList.add("hidden");
  if (photoGallery) photoGallery.classList.add("hidden");

  if (productAddress && activeSlug) {
    productAddress.innerText = window.location.origin + "/collections/" + activeSlug;
  }

  if (ringsTask) {
    ringsTask.classList.remove("hidden");
    ringsTask.innerText = activeTaskTitle;
  }

  if (productWindowTitleText) productWindowTitleText.innerText = activeTaskTitle;
  if (windowContent) windowContent.scrollTop = 0;

  // Collection 2 has a legacy JSON fallback only when server-rendered products are absent.
  if (isCollection2) loadCollection2Products();

  // Once the folder is visible, quietly warm a few product-data responses so
  // the next mobile tap opens the product window with less waiting.
  warmCollectionProductData(activeCollectionPage);

  closeStartMenu();
  if (windowEl) bringToFront(windowEl);
}

function showStorePage() {
  showMainWindow();

  if (windowEl) {
    windowEl.classList.remove("simple-toolbar-mode");
    windowEl.classList.remove("viewer-mode");
  }

  if (wmpPlayer) {
    wmpPlayer.classList.add("hidden");
  }

  if (video) {
    video.pause();
  }

  showPlayOverlay();

  /* FORCE PRODUCT VIEW ONLY */
  if (ringsCollectionPage) {
    ringsCollectionPage.classList.add("hidden");
  }
  if (collection2Page) {
    collection2Page.classList.add("hidden");
  }
  if (collection3Page) {
    collection3Page.classList.add("hidden");
  }

  if (productQuickLinksHost) {
    productQuickLinksHost.classList.add("hidden");
  }

  if (productLayout) {
    productLayout.classList.remove("hidden");
  }

  if (relatedProducts) {
    relatedProducts.classList.remove("hidden");
  }

  if (viewer3d) {
    viewer3d.classList.add("hidden");
  }

  if (photoGallery) {
    photoGallery.classList.add("hidden");
  }

  if (productAddress) {
    productAddress.innerText =
      (activeShopifyProduct && activeShopifyProduct.url) ||
      (ghProductConfig.cartProductHandle ? (ghProductConfig.cartProductUrl || "") : "") ||
      (window.location.origin + "/");
  }

  if (activeShopifyProduct) {
    updateDynamicProductDisplay();
    updateProductNoteBox(activeShopifyProduct);
    updateReviewAppLinks(activeShopifyProduct);
  } else {
    updateProduct(goldProduct);
    updateProductDonation(null);
    updateProductFundraiser(null);
    updateProductNoteBox(defaultProductNoteSource);
    updateAddToCartButtonLabel(goldProduct);
    updateReviewAppLinks(null);
  }

  if (goldBtn) {
    goldBtn.classList.add("active-material");
  }

  if (silverBtn) {
    silverBtn.classList.remove("active-material");
  }

  if (windowContent) {
    windowContent.scrollTop = 0;
  }

  closeStartMenu();

  if (windowEl) {
    bringToFront(windowEl);
  }
}

function showInternalPage(pageId) {

  showMainWindow();

  if (windowEl) {
    windowEl.classList.add("simple-toolbar-mode");
  }

  if (wmpPlayer) {
    wmpPlayer.classList.add("hidden");
  }

  if (video) {
    video.pause();
  }

  showPlayOverlay();

  hideEverythingInsideWindow();

  const targetPage = document.getElementById(pageId);

  if (targetPage) {
    targetPage.classList.remove("hidden");
  }

  closeStartMenu();
}

  function show3DViewer() {

    // Load Google's 3D web component only when the customer actually asks for 3D.
    // This keeps the initial mobile desktop/product menus lighter.
    ensureModelViewerComponent().catch((error) => console.error(error));

    showMainWindow();

    if (windowEl) {
     windowEl.classList.remove("simple-toolbar-mode");
    }

    if (wmpPlayer) {
      wmpPlayer.classList.add("hidden");
    }

    if (video) {
      video.pause();
    }

    showPlayOverlay();

    hideEverythingInsideWindow();

    if (windowEl) {
      windowEl.classList.add("viewer-mode");
    }

    if (viewer3d) {
      viewer3d.classList.remove("hidden");
    }

    if (viewerBtn) {
      viewerBtn.classList.add("active-viewer");
    }

    if (viewerLoading && !viewerLoaded) {
      viewerLoading.classList.remove("hidden");
    }

    closeStartMenu();
  }

  function showWMP() {

    hydrateWmpChrome();

    if (windowEl) {
      windowEl.classList.add("hidden");
      windowEl.classList.remove("viewer-mode");
    }

    hideInfoPages();

    if (viewer3d) {
      viewer3d.classList.add("hidden");
    }

    if (viewerBtn) {
      viewerBtn.classList.remove("active-viewer");
    }

    if (wmpPlayer) {
      wmpPlayer.classList.remove("hidden");
    }

    if (video) {
      video.play().then(() => {
        showPauseOverlay();
      }).catch(() => {
        showPlayOverlay();
      });
    }

    closeStartMenu();
  }


  /* =========================
     WMP HELPERS
  ========================= */

  function loadCurrentVideoAndPlay() {

    if (!video) {
      return;
    }

    video.src = playlist[currentVideo];

    video.play().then(() => {
      showPauseOverlay();
    }).catch(() => {
      showPlayOverlay();
    });
  }

  function updateScrubberVisual() {

    if (!video || !scrubber || !video.duration) {
      return;
    }

    const percent = video.currentTime / video.duration;

    scrubber.value = percent * 100;

    if (scrubberThumb) {
      scrubberThumb.style.transform =
        "translateX(" + (percent * 26.5) + "%)";
    }
  }


  /* =========================
     GALLERY HELPERS
  ========================= */

  function updateGalleryImage() {

    if (!galleryMainImage) {
      return;
    }

    galleryMainImage.src = galleryImages[galleryIndex];
    galleryMainImage.alt = getProductGalleryAlt(galleryIndex);

    galleryMainImage.style.transform =
      "rotate(" + galleryRotation + "deg)";

    galleryThumbs.forEach((thumb) => {
      thumb.classList.remove("active-gallery-thumb");
    });

    const activeThumb =
      document.querySelector(
        '.gallery-thumb[data-index="' + galleryIndex + '"]'
      );

    if (activeThumb) {
      activeThumb.classList.add("active-gallery-thumb");
    }
  }

  function updateCustomInfoGalleryImage() {
    if (!customInfoGalleryMainImage || !customInfoGalleryImages.length) {
      return;
    }

    customInfoGalleryMainImage.src = customInfoGalleryImages[customInfoGalleryIndex];
    const eduActiveThumb = customInfoGalleryThumbs[customInfoGalleryIndex];
    const eduActiveLabel = eduActiveThumb ? (eduActiveThumb.querySelector("span")?.textContent || "").trim() : "";
    customInfoGalleryMainImage.alt = "GoldHearted EDU " + (eduActiveLabel || ("gallery image " + (customInfoGalleryIndex + 1)));
    customInfoGalleryMainImage.style.transform =
      "rotate(" + customInfoGalleryRotation + "deg)";

    customInfoGalleryThumbs.forEach((thumb) => {
      thumb.classList.remove("active-gh-info-gallery-thumb");
    });

    const activeThumb = document.querySelector(
      '.gh-info-gallery-thumb[data-index="' + customInfoGalleryIndex + '"]'
    );

    if (activeThumb) {
      activeThumb.classList.add("active-gh-info-gallery-thumb");
    }
  }

  function showPhotoGallery() {

    showMainWindow();

    if (windowEl) {
     windowEl.classList.remove("simple-toolbar-mode");
   }

    if (wmpPlayer) {
      wmpPlayer.classList.add("hidden");
    }

    if (video) {
      video.pause();
    }

    showPlayOverlay();

    hideEverythingInsideWindow();

    if (windowEl) {
      windowEl.classList.add("gallery-mode");
      windowEl.classList.remove("viewer-mode");
    }

    if (photoGallery) {
      photoGallery.classList.remove("hidden");
    }

    galleryRotation = 0;

    updateGalleryImage();

    closeStartMenu();
  }


  /* =========================
     INIT
  ========================= */

  if (wmpPlayer) {
    wmpPlayer.classList.add("hidden");
  }

  showPlayOverlay();

  updateProduct(goldProduct);

  if (goldBtn) {
    goldBtn.classList.add("active-material");
  }

  if (silverBtn) {
    silverBtn.classList.remove("active-material");
  }

  if (video) {
    video.src = playlist[0];
  }


  /* =========================
     WINDOW CONTROLS
  ========================= */

if (openWindow) {
  openWindow.addEventListener("click", (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();

    ghPushXpRoute(openWindow.getAttribute("href"), {
      type: "collection",
      handle: getPrimaryCollectionHandle()
    });
    showCollectionPage("rings");

  });
}

if (openCollection2) {
  openCollection2.addEventListener("click", (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();

    ghPushXpRoute(openCollection2.getAttribute("href"), {
      type: "collection",
      handle: getCollection2Handle()
    });
    showCollectionPage("collection2");

  });
}

if (openCollection3) {
  openCollection3.addEventListener("click", (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();

    ghPushXpRoute(openCollection3.getAttribute("href"), {
      type: "collection",
      handle: getCollection3Handle()
    });
    showCollectionPage("collection3");
  });
}
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {

      if (windowEl) {
        windowEl.classList.add("hidden");
      }

      if (ringsTask) {
        ringsTask.classList.add("hidden");
      }

      if (/^\/(products|collections)\//i.test(ghCleanRoutePath(window.location.pathname))) {
        ghReturnBrowserRouteToDesktopAfterClose();
      }

    });
  }

  if (minBtn) {
    minBtn.addEventListener("click", () => {

      if (windowEl) {
        windowEl.classList.add("minimized");
      }

    });
  }

  if (maxBtn) {
    maxBtn.addEventListener("click", () => {

      if (windowEl) {
        windowEl.classList.toggle("maximized");
      }

    });
  }

/* =========================
   RESTORE PRODUCT WINDOW FROM TASKBAR
   Keeps current product window page/state
========================= */

if (ringsTask) {

  ringsTask.addEventListener("click", () => {

    if (!windowEl) {
      return;
    }

    windowEl.classList.remove("hidden");
    windowEl.classList.remove("minimized");

    closeStartMenu();

    bringToFront(windowEl);

  });

}


  /* =========================
     START MENU
  ========================= */

  if (startButton && startMenu) {
    startButton.addEventListener("click", () => {

      startMenu.classList.toggle("hidden");
      startButton.classList.toggle("active");

      if (!startMenu.classList.contains("hidden")) {
        startMenu.style.setProperty("z-index", "2147483600", "important");
      }

      syncStartMenuFocusMode();

    });
  }

  startFocusOverlay?.addEventListener("click", closeStartMenu);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && startMenu && !startMenu.classList.contains("hidden")) {
      closeStartMenu();
    }
  });

startPageLinks.forEach((item) => {

  item.addEventListener("click", (event) => {
    if (item.tagName === "A" && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
      return;
    }

    /*
      GH SEO V65 - Always use a real document navigation for Shopify info pages.
      The XP desktop exists on multiple templates, and an in-place route swap can
      otherwise reuse the copy/settings embedded in the page we came from.
      A full navigation guarantees Custom Order, About, FAQ, EDU, Grillz, etc.
      are rendered from their actual destination route every time.
    */
    if (item.tagName === "A") {
      const rawHref = item.getAttribute("href") || "";
      if (!rawHref || rawHref === "#") return;

      let targetUrl = null;
      try {
        targetUrl = new URL(rawHref, window.location.href);
      } catch (error) {}

      if (targetUrl && targetUrl.origin === window.location.origin) {
        event.preventDefault();

        const targetFullPath = targetUrl.pathname + targetUrl.search + targetUrl.hash;
        const currentFullPath = window.location.pathname + window.location.search + window.location.hash;

        if (targetFullPath === currentFullPath) {
          window.location.reload();
        } else {
          ghRememberFreshPreviousUrl(targetUrl.href);
          ghSaveWindowSnapshotForNextRoute();
          window.location.assign(targetUrl.href);
        }
        return;
      }

      return;
    }

    ghOpenInfoRoute(item.dataset.page, { push: true });
  });

});

if (startEmailSignup) {
  startEmailSignup.addEventListener("click", () => {

    openInfoWindow(
      "infoEmailSignupPage",
      ghThemeText("emailSignupWindowTitle", "Email Signup"),
      window.location.origin + "/#email-signup"
    );

  });
}


  startSocialLinks.forEach((item) => {

    item.addEventListener("click", (event) => {

      const url = item.getAttribute("href") || item.dataset.url;

      if (item.tagName === "A" && url && url !== "#") {
        closeStartMenu();
        return;
      }

      event.preventDefault();

      if (url && url !== "#") {
        window.open(url, "_blank", "noopener,noreferrer");
      }

      closeStartMenu();

    });

  });

  if (openKlaviyoForm) {
    openKlaviyoForm.addEventListener("click", () => {
      const opened = openEmailSignupApp();

      if (!opened) {
        alert("Email signup app is not open yet. Enable Shopify Forms/Klaviyo app embed, then try again.");
      }
    });
  }


  async function ghRestoreShoppingSnapshot(shopping) {
    if (!shopping || !shopping.href) return;

    let targetPath = "";
    try { targetPath = ghCleanRoutePath(new URL(shopping.href, window.location.href).pathname); } catch (error) {}
    if (!targetPath) return;

    const productMatch = targetPath.match(/^\/products\/([^/]+)$/i);
    if (productMatch) {
      const handle = decodeURIComponent(productMatch[1]);
      const shortcut = Array.from(document.querySelectorAll(
        '.featured-product-desktop-icon[data-featured-product-handle], ' +
        '.collection-product-shortcut[data-shopify-product-handle], ' +
        '.desktop-product-shortcut[data-shopify-product-handle], ' +
        '.desktop-product-shortcut[data-featured-product-handle]'
      )).find((candidate) => {
        return String(candidate.dataset.featuredProductHandle || "").trim() === handle ||
          String(candidate.dataset.shopifyProductHandle || "").trim() === handle;
      });

      try {
        let restoredProduct = findDynamicProductByHandle(handle);
        if (!restoredProduct) {
          restoredProduct = await fetchFeaturedProductByHandle(
            handle,
            shortcut?.dataset?.featuredIconUrl || "",
            shortcut ? getFeaturedShortcutMediaOptions(shortcut) : {}
          );
        }
        if (restoredProduct) {
          const backTarget = shortcut?.dataset?.ghBackTarget ||
            (shortcut?.closest?.("#infoAllProductsPage") ? "allProducts" : "desktop");
          openDynamicShopifyProduct(restoredProduct, backTarget);
        }
      } catch (error) {
        console.warn("GoldHearted could not restore the previous product window.", error);
      }
    } else {
      const handle = targetPath.split('/').filter(Boolean).pop() || "";
      if (handle && handle === getCollection3Handle()) showCollectionPage("collection3");
      else if (handle && handle === getCollection2Handle()) showCollectionPage("collection2");
      else if (handle && handle === getPrimaryCollectionHandle()) showCollectionPage("rings");
    }

    if (shopping.minimized) document.getElementById("window")?.classList.add("minimized");
  }

  function ghPrimeSiblingWindowsFromSnapshot(snapshot) {
    if (!snapshot) return;

    const reveal = (windowId, taskId, state) => {
      const targetWindow = document.getElementById(windowId);
      const targetTask = document.getElementById(taskId);

      if (targetWindow) {
        targetWindow.classList.remove("hidden");
        if (state?.minimized) targetWindow.classList.add("minimized");
        else targetWindow.classList.remove("minimized");
      }

      if (targetTask) {
        targetTask.classList.remove("hidden");
      }
    };

    if (snapshot.shopping) reveal("window", "rings-task", snapshot.shopping);
    if (snapshot.namechain) reveal("namechainWindow", "namechain-task", snapshot.namechain);
    if (snapshot.messenger) reveal("aimWindow", "aim-task", snapshot.messenger);
    if (snapshot.metal) reveal("metalWindow", "metal-task", snapshot.metal);

    if (infoWindow && !infoWindow.classList.contains("hidden")) {
      bringToFront(infoWindow);
    }
  }

  async function ghWaitForWindowFunction(name, timeoutMs = 1600) {
    const started = Date.now();

    while (typeof window[name] !== "function" && Date.now() - started < timeoutMs) {
      await new Promise((resolve) => window.setTimeout(resolve, 30));
    }

    return typeof window[name] === "function" ? window[name] : null;
  }

  async function ghRestoreSiblingWindowsAfterHardNavigation() {
    const snapshot = ghTakeWindowSnapshotForRestore();
    if (!snapshot) return;

    // Show the existing window shells immediately. This prevents the visual
    // "everything vanished, then came back" flash while live state restores.
    ghPrimeSiblingWindowsFromSnapshot(snapshot);

    const destinationHref = window.location.href;
    window.__ghSuppressRouteSync = true;

    try {
      if (snapshot.shopping) await ghRestoreShoppingSnapshot(snapshot.shopping);

      if (snapshot.namechain) {
        const openNameChain = await ghWaitForWindowFunction("GHOpenNameChainWindow");
        if (openNameChain) {
          await openNameChain();
          if (snapshot.namechain.minimized) document.getElementById("namechainWindow")?.classList.add("minimized");
        }
      }

      if (snapshot.messenger && typeof openAimWindow === "function") {
        openAimWindow();
        if (snapshot.messenger.minimized) document.getElementById("aimWindow")?.classList.add("minimized");
      }

      if (snapshot.metal && typeof openMetalWindow === "function") {
        openMetalWindow();
        if (snapshot.metal.minimized) document.getElementById("metalWindow")?.classList.add("minimized");
      }

      // Keep the route that the customer intentionally opened on top.
      if (infoWindow && !infoWindow.classList.contains("hidden")) {
        bringToFront(infoWindow);
      }
      window.history.replaceState(
        Object.assign({}, window.history.state || {}, { ghXpRoute: true }),
        "",
        destinationHref
      );
    } finally {
      window.__ghSuppressRouteSync = false;
    }
  }

  const ghRunSiblingRestore = () => {
    ghRestoreSiblingWindowsAfterHardNavigation().catch((error) => {
      window.__ghSuppressRouteSync = false;
      console.warn("GoldHearted XP window restore stopped early.", error);
    });
  };

  // app.js is loaded at the end of <body>, so the window shells already exist.
  // Restore immediately instead of waiting for every page image/video to finish.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ghRunSiblingRestore, { once: true });
  } else {
    window.setTimeout(ghRunSiblingRestore, 0);
  }


  /* =========================
     CLOCK
  ========================= */

  function updateClock() {

    const clock = document.getElementById("clock");

    if (!clock) {
      return;
    }

    const now = new Date();

    let hours = now.getHours();
    let minutes = now.getMinutes();

    minutes = minutes < 10 ? "0" + minutes : minutes;

    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;

    clock.innerText = hours + ":" + minutes + " " + ampm;
  }

  setInterval(updateClock, 1000);
  updateClock();


  /* =========================
     MAIN TOOLBAR
  ========================= */

if (backBtn) {
  backBtn.addEventListener("click", () => {

    if (!windowEl) {
      return;
    }

    if (windowEl.classList.contains("simple-toolbar-mode")) {
      return;
    }

    /*
      If the customer is inside Live 3D View or Photo Gallery,
      Back should return to the product page, not the collection folder.
    */
    if (
      windowEl.classList.contains("viewer-mode") ||
      windowEl.classList.contains("gallery-mode") ||
      (viewer3d && !viewer3d.classList.contains("hidden")) ||
      (photoGallery && !photoGallery.classList.contains("hidden"))
    ) {
      if (!ghBackWithinProductInternalHistory()) {
        showStorePage();
      }
      return;
    }

    if (productBackTarget === "desktop") {
      windowEl.classList.add("hidden");
      if (ringsTask) {
        ringsTask.classList.add("hidden");
      }
      return;
    }

    if (productBackTarget === "allProducts") {
      windowEl.classList.add("hidden");
      if (ringsTask) {
        ringsTask.classList.add("hidden");
      }
      ghOpenInfoRoute("allProductsPage", { push: true });
      return;
    }

    if (productBackTarget === "collection2") {
      showCollectionPage("collection2");
      return;
    }

    if (productBackTarget === "collection3") {
      showCollectionPage("collection3");
      return;
    }

    showCollectionPage("rings");

  });
}

  if (viewerBtn) {
    viewerBtn.addEventListener("click", () => {
      ghRunProductInternalInteraction(() => show3DViewer(), "3d-view");
    });
  }

  if (mediaBtn) {
    mediaBtn.addEventListener("pointerenter", hydrateWmpChrome, { passive: true });
    mediaBtn.addEventListener("touchstart", hydrateWmpChrome, { passive: true });
    mediaBtn.addEventListener("click", () => {
      ghRunProductInternalInteraction(() => showWMP(), "media-player");
    });
  }

  if (modelViewer) {
    modelViewer.addEventListener("load", () => {

      if (viewerLoading) {
        viewerLoading.classList.add("hidden");
      }

      viewerLoaded = true;

    });
  }


  /* =========================
     GOLD / SILVER BUTTONS
  ========================= */

  if (goldBtn) {
    goldBtn.addEventListener("click", () => {
      ghRunProductInternalInteraction(() => {
        currentMaterial = "gold";
        updateCartStatus("", false);
        if (activeShopifyProduct) {
          updateDynamicProductDisplay();
        } else {
          updateProduct(goldProduct);
        }

        goldBtn.classList.add("active-material");

        if (silverBtn) {
          silverBtn.classList.remove("active-material");
        }
      }, "material");
    });
  }

  if (silverBtn) {
    silverBtn.addEventListener("click", () => {
      ghRunProductInternalInteraction(() => {
        currentMaterial = "silver";
        updateCartStatus("", false);
        if (activeShopifyProduct) {
          updateDynamicProductDisplay();
        } else {
          updateProduct(silverProduct);
        }

        silverBtn.classList.add("active-material");

        if (goldBtn) {
          goldBtn.classList.remove("active-material");
        }
      }, "material");
    });
  }


  /* =========================
     WINDOWS MEDIA PLAYER
  ========================= */

  if (backToProduct) {
    backToProduct.addEventListener("click", () => {
      if (!ghBackWithinProductInternalHistory()) {
        showStorePage();
      }
    });
  }

  if (playPause && video) {
    playPause.addEventListener("click", () => {

      if (video.paused) {

        video.play().then(() => {
          showPauseOverlay();
        }).catch(() => {
          showPlayOverlay();
        });

      } else {

        video.pause();
        showPlayOverlay();

      }

    });
  }

  if (stopVideo && video) {
    stopVideo.addEventListener("click", () => {

      video.pause();
      video.currentTime = 0;

      showPlayOverlay();

    });
  }

  if (nextVideo && video) {
    nextVideo.addEventListener("click", () => {

      currentVideo++;

      if (currentVideo >= playlist.length) {
        currentVideo = 0;
      }

      loadCurrentVideoAndPlay();

    });
  }

  if (prevVideo && video) {
    prevVideo.addEventListener("click", () => {

      currentVideo--;

      if (currentVideo < 0) {
        currentVideo = playlist.length - 1;
      }

      loadCurrentVideoAndPlay();

    });
  }

  if (video && scrubber) {

    video.addEventListener("timeupdate", () => {
      updateScrubberVisual();
    });

    video.addEventListener("loadedmetadata", () => {
      updateScrubberVisual();
    });

    scrubber.addEventListener("input", () => {

      if (video.duration) {

        video.currentTime =
          (scrubber.value / 100) * video.duration;

        updateScrubberVisual();
      }

    });

    video.addEventListener("ended", () => {

      if (playlist.length <= 1) {
        currentVideo = 0;
        video.pause();
        video.currentTime = 0;
        showPlayOverlay();
        return;
      }

      currentVideo++;

      if (currentVideo >= playlist.length) {
        currentVideo = 0;
      }

      loadCurrentVideoAndPlay();

    });
  }


  /* =========================
     PHOTO GALLERY
  ========================= */

  if (openGalleryBtn) {
    openGalleryBtn.addEventListener("click", () => {
      ghRunProductInternalInteraction(() => showPhotoGallery(), "photo-gallery");
    });
  }

  if (galleryPrev) {
    galleryPrev.addEventListener("click", () => {

      galleryIndex--;

      if (galleryIndex < 0) {
        galleryIndex = galleryImages.length - 1;
      }

      galleryRotation = 0;

      updateGalleryImage();

    });
  }

  if (galleryNext) {
    galleryNext.addEventListener("click", () => {

      galleryIndex++;

      if (galleryIndex >= galleryImages.length) {
        galleryIndex = 0;
      }

      galleryRotation = 0;

      updateGalleryImage();

    });
  }

  if (galleryRotateLeft) {
    galleryRotateLeft.addEventListener("click", () => {

      galleryRotation -= 90;

      updateGalleryImage();

    });
  }

  if (galleryRotateRight) {
    galleryRotateRight.addEventListener("click", () => {

      galleryRotation += 90;

      updateGalleryImage();

    });
  }

  /* Gallery thumbnail click handlers are attached whenever the active product
     gallery is rendered, so dynamically loaded products can have any image count. */


  if (customInfoGalleryPrev) {
    customInfoGalleryPrev.addEventListener("click", () => {
      if (!customInfoGalleryImages.length) return;
      customInfoGalleryIndex--;
      if (customInfoGalleryIndex < 0) customInfoGalleryIndex = customInfoGalleryImages.length - 1;
      customInfoGalleryRotation = 0;
      updateCustomInfoGalleryImage();
    });
  }

  if (customInfoGalleryNext) {
    customInfoGalleryNext.addEventListener("click", () => {
      if (!customInfoGalleryImages.length) return;
      customInfoGalleryIndex++;
      if (customInfoGalleryIndex >= customInfoGalleryImages.length) customInfoGalleryIndex = 0;
      customInfoGalleryRotation = 0;
      updateCustomInfoGalleryImage();
    });
  }

  if (customInfoGalleryRotateLeft) {
    customInfoGalleryRotateLeft.addEventListener("click", () => {
      customInfoGalleryRotation -= 90;
      updateCustomInfoGalleryImage();
    });
  }

  if (customInfoGalleryRotateRight) {
    customInfoGalleryRotateRight.addEventListener("click", () => {
      customInfoGalleryRotation += 90;
      updateCustomInfoGalleryImage();
    });
  }

  customInfoGalleryThumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      customInfoGalleryIndex = Number(thumb.dataset.index) || 0;
      customInfoGalleryRotation = 0;
      updateCustomInfoGalleryImage();
    });
  });


  /*
    V113: EDU signup now uses Shopify's native customer form only. The old
    AJAX helper was removed completely so CAPTCHA/challenge handling remains
    Shopify-owned and there is only one submission path.
  */
  window.GHEduInlineSignupSubmit = null;

  /* =========================
     SIGNUP TRACKING — V116

     Signup attribution is intentionally handled only by
     gh-signup-v116.js. Keeping it out of the main application bundle
     prevents Shopify customer-form success state from creating duplicate
     analytics emissions across the three signup surfaces.
  ========================= */

  const grillzMainImage = document.getElementById("ghGrillzMainImage");
  const grillzThumbs = document.querySelectorAll(".gh-grillz-thumb");
  const grillzMainButton = document.querySelector(".gh-grillz-main-image-button");

  if (grillzThumbs.length && grillzMainImage) {
    grillzThumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const mainSrc = thumb.dataset.mainSrc || "";
        const fullSrc = thumb.dataset.fullSrc || mainSrc;
        const mainAlt = thumb.dataset.mainAlt || "GoldHearted custom grillz reference image";
        if (mainSrc) {
          grillzMainImage.src = mainSrc;
          grillzMainImage.alt = mainAlt;
        }
        if (grillzMainButton) {
          grillzMainButton.dataset.fullSrc = fullSrc;
          grillzMainButton.dataset.fullAlt = mainAlt;
        }
        grillzThumbs.forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  }

  if (grillzMainButton) {
    grillzMainButton.addEventListener("click", () => {
      const fullSrc = grillzMainButton.dataset.fullSrc || (grillzMainImage ? grillzMainImage.src : "");
      const fullAlt = grillzMainButton.dataset.fullAlt || (grillzMainImage ? grillzMainImage.alt : "");
      if (fullSrc) openPhotoFullscreenWithSrc(fullSrc, fullAlt);
    });
  }

  /* =========================
     COLLECTION SHOWCASE PREVIEWS
     Reused by Black Jesus and editable Collection 1/2/3 pages.
  ========================= */

  document.querySelectorAll(".gh-collection-showcase").forEach((showcase) => {
    const mainImage = showcase.querySelector(".gh-collection-showcase-main-image");
    const thumbs = showcase.querySelectorAll(".gh-collection-showcase-thumb");
    const mainButton = showcase.querySelector(".gh-collection-showcase-main-button");

    if (thumbs.length && mainImage) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener("click", () => {
          const mainSrc = thumb.dataset.mainSrc || "";
          const fullSrc = thumb.dataset.fullSrc || mainSrc;
          const mainAlt = thumb.dataset.mainAlt || "GoldHearted jewelry collection";

          if (mainSrc) {
            mainImage.src = mainSrc;
            mainImage.alt = mainAlt;
          }

          if (mainButton) {
            mainButton.dataset.fullSrc = fullSrc;
            mainButton.dataset.fullAlt = mainAlt;
          }

          thumbs.forEach((item) => item.classList.remove("is-active"));
          thumb.classList.add("is-active");
        });
      });
    }

    if (mainButton) {
      mainButton.addEventListener("click", () => {
        const fullSrc = mainButton.dataset.fullSrc || (mainImage ? mainImage.src : "");
        const fullAlt = mainButton.dataset.fullAlt || (mainImage ? mainImage.alt : "");
        if (fullSrc) openPhotoFullscreenWithSrc(fullSrc, fullAlt);
      });
    }
  });

  /* =========================
     CUSTOM ORDER PORTFOLIO FULLSCREEN
  ========================= */

  const customOrderGalleryOpeners = document.querySelectorAll(".gh-custom-order-gallery-open");
  customOrderGalleryOpeners.forEach((button) => {
    button.addEventListener("click", () => {
      const fullSrc = button.dataset.fullSrc || button.querySelector("img")?.src || "";
      const fullAlt = button.dataset.fullAlt || button.querySelector("img")?.alt || "";
      openPhotoFullscreenWithSrc(fullSrc, fullAlt);
    });
  });

  /* =========================
     FULLSCREEN PHOTO MODE
  ========================= */

  if (galleryMainImage && photoFullscreen && photoFullscreenImage) {

    galleryMainImage.addEventListener("click", () => {
      openPhotoFullscreenWithSrc(galleryMainImage.src, galleryMainImage.alt);
    });

    galleryMainImage.addEventListener("dblclick", () => {
      openPhotoFullscreenWithSrc(galleryMainImage.src, galleryMainImage.alt);
    });

  }

  if (customInfoGalleryMainImage && photoFullscreen && photoFullscreenImage) {
    customInfoGalleryMainImage.addEventListener("click", () => {
      openPhotoFullscreenWithSrc(customInfoGalleryMainImage.src, customInfoGalleryMainImage.alt);
    });

    customInfoGalleryMainImage.addEventListener("dblclick", () => {
      openPhotoFullscreenWithSrc(customInfoGalleryMainImage.src, customInfoGalleryMainImage.alt);
    });
  }

  if (photoFullscreenClose && photoFullscreen) {
    photoFullscreenClose.addEventListener("click", () => {
      photoFullscreen.classList.add("hidden");
    });
  }

  if (photoFullscreen) {
    photoFullscreen.addEventListener("click", (event) => {

      if (event.target === photoFullscreen) {
        photoFullscreen.classList.add("hidden");
      }

    });
  }

  document.addEventListener("keydown", (event) => {

    if (event.key === "Escape" && photoFullscreen) {
      photoFullscreen.classList.add("hidden");
    }

  });

  /* =========================
   INFO WINDOW CONTROLS
========================= */

if (infoBackBtn) {
  infoBackBtn.addEventListener("click", () => {
    const previousUrl = ghPopFreshPreviousUrl();
    if (previousUrl) {
      ghSaveWindowSnapshotForNextRoute();
      window.location.assign(previousUrl);
      return;
    }

    const activeInfoRoute = ghInfoRouteFromPath(window.location.pathname);
    if (activeInfoRoute) {
      ghSaveWindowSnapshotForNextRoute();
      window.location.assign("/");
    }
  });
}

if (infoCloseBtn) {

  infoCloseBtn.addEventListener("click", (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    /*
      Closing an XP info window should close the visible window first.
      Do not use browser history here, because taskbar URL syncing may leave
      the browser on /pages/faq, /pages/about, etc. and history.back() can make
      the close button look like it did nothing.
    */
    if (infoWindow) {
      infoWindow.classList.add("hidden");
      infoWindow.classList.remove("minimized", "active-window");
    }

    if (infoTask) {
      infoTask.classList.add("hidden");
      infoTask.classList.remove("active-task");
    }

    /*
      Every Info window that owns the current browser route must release that
      route when it closes. Most Info apps use real Shopify /pages/... routes,
      while Email Signup intentionally uses /#email-signup. Comparing the
      active Info window's canonical route with the browser URL keeps both
      kinds in sync and future-proofs any later hash-backed Info window.
    */
    let infoWindowOwnsCurrentRoute = false;
    try {
      const activeInfoRoute = ghGetInfoRouteForActivePage();
      if (activeInfoRoute && activeInfoRoute.href) {
        const routeUrl = new URL(activeInfoRoute.href, window.location.href);
        const browserUrl = new URL(window.location.href);
        infoWindowOwnsCurrentRoute = (
          routeUrl.origin === browserUrl.origin &&
          ghCleanRoutePath(routeUrl.pathname) === ghCleanRoutePath(browserUrl.pathname) &&
          routeUrl.search === browserUrl.search &&
          String(routeUrl.hash || "").toLowerCase() === String(browserUrl.hash || "").toLowerCase()
        );
      }
    } catch (error) {}

    if (ghInfoRouteFromPath(window.location.pathname) || infoWindowOwnsCurrentRoute) {
      ghReturnBrowserRouteToDesktopAfterClose();
    }

    window.setTimeout(activateTopVisibleWindow, 0);
    window.setTimeout(activateTopVisibleWindow, 60);
  });

}

if (infoMinBtn) {

  infoMinBtn.addEventListener("click", () => {

    if (infoWindow) {
      infoWindow.classList.add("minimized");
    }

    if (infoTask) {
      infoTask.classList.remove("active-task");
    }

  });

}

if (infoMaxBtn) {

  infoMaxBtn.addEventListener("click", () => {

    if (infoWindow) {
      infoWindow.classList.toggle("maximized");
      bringToFront(infoWindow);
    }

  });

}

if (ringsTask) {

  ringsTask.addEventListener("click", () => {

    if (windowEl) {
      windowEl.classList.remove("hidden");
      windowEl.classList.remove("minimized");
      bringToFront(windowEl);
    }

  });

}

if (infoTask) {

  infoTask.addEventListener("click", () => {

    if (infoWindow) {
      infoWindow.classList.remove("hidden");
      infoWindow.classList.remove("minimized");
      bringToFront(infoWindow);
    }

  });

}



/* =========================
   ALL PRODUCTS DESKTOP SHORTCUTS
========================= */

const productShortcuts =
  document.querySelectorAll("[data-product-shortcut]");

productShortcuts.forEach((shortcut) => {

  shortcut.addEventListener("click", (event) => {
    if (shortcut.tagName === "A" && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    if (shortcut.tagName === "A") event.preventDefault();

    const productType =
      shortcut.dataset.productShortcut;

  if (productType === "rings" || productType === "collection2" || productType === "collection3") {

  showCollectionPage(productType);

  if (windowEl) {
    windowEl.classList.remove("hidden");
    windowEl.classList.remove("minimized");
  }

  if (ringsTask) {
    ringsTask.classList.remove("hidden");
    ringsTask.innerText = productType === "collection3"
      ? getCollection3Label()
      : (productType === "collection2" ? getCollection2Label() : ghThemeText("ringsTaskTitle", "Collection 1"));
  }

  setTimeout(() => {

    if (windowEl) {
      bringToFront(windowEl);
    }

  }, 0);

  return;
}

    alert(
      productType +
      " product page is not built yet."
    );

  });

});

/* =========================================================
   GH PATCH - No-flash router for collection/product shortcuts
   Stops duplicate click handlers from briefly showing the template/default
   product view or the "page is not built yet" alert before the real route opens.
========================================================= */

function ghIsPlainPrimaryClick(event) {
  return !(
    event.defaultPrevented ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    (typeof event.button === "number" && event.button !== 0)
  );
}

function ghStopShortcutClick(event) {
  event.preventDefault();
  event.stopPropagation();
  if (typeof event.stopImmediatePropagation === "function") {
    event.stopImmediatePropagation();
  }
}

function ghPrepareProductShortcutLoading(shortcut) {
  if (!windowEl) return;

  const label =
    shortcut?.querySelector?.("span")?.textContent?.trim?.() ||
    shortcut?.dataset?.featuredProductHandle ||
    shortcut?.dataset?.shopifyProductHandle ||
    "Product";

  activateShoppingSlot(windowEl);
  windowEl.classList.remove("hidden");
  windowEl.classList.remove("minimized");
  windowEl.classList.remove("simple-toolbar-mode");
  windowEl.classList.remove("viewer-mode");
  windowEl.classList.remove("gallery-mode");

  if (ringsTask) {
    ringsTask.classList.remove("hidden");
    ringsTask.innerText = label;
  }

  if (productWindowTitleText) {
    productWindowTitleText.innerText = label;
  }

  if (productAddress) {
    productAddress.innerText = shortcut?.getAttribute?.("href") || "";
  }

  if (ringsCollectionPage) ringsCollectionPage.classList.add("hidden");
  if (collection2Page) collection2Page.classList.add("hidden");
  if (collection3Page) collection3Page.classList.add("hidden");
  if (productQuickLinksHost) productQuickLinksHost.classList.add("hidden");
  if (viewer3d) viewer3d.classList.add("hidden");
  if (photoGallery) photoGallery.classList.add("hidden");
  if (relatedProducts) relatedProducts.classList.add("hidden");

  /*
    Do not show the old/default product template while Shopify product data is loading.
    The real product view appears only after openDynamicShopifyProduct() has the correct data.
  */
  if (productLayout) {
    productLayout.classList.add("hidden");
  }

  if (windowContent) {
    windowContent.scrollTop = 0;
  }

  bringToFront(windowEl);
}

async function ghOpenProductShortcutWithoutFlash(shortcut) {
  if (!shortcut) return;

  const featuredHandle = shortcut.dataset.featuredProductHandle || "";
  const dynamicHandle = shortcut.dataset.shopifyProductHandle || "";
  const handle = featuredHandle || dynamicHandle;
  const productId = shortcut.dataset.productId || "";

  if (handle) {
    ghPrepareProductShortcutLoading(shortcut);

    // Always pass through fetchFeaturedProductByHandle, even when the product was
    // pre-warmed. That function merges the shortcut's Liquid-rendered metafields
    // (3D/video/fundraiser) into cached products before returning them.
    const product = await fetchFeaturedProductByHandle(
        handle,
        shortcut.dataset.featuredIconUrl || "",
        getFeaturedShortcutMediaOptions(shortcut)
      );

    if (!product) {
      alert("This product could not be opened yet. Check the product handle in the theme editor.");
      return;
    }

    const shortcutLabel = shortcut.querySelector("span")
      ? shortcut.querySelector("span").textContent.trim()
      : "";

    product.taskLabel = shortcutLabel || product.title || "Product";

    const backTarget =
      shortcut.dataset.ghBackTarget ||
      (shortcut.closest("#infoAllProductsPage") ? "allProducts" : (dynamicHandle ? "collection" : "desktop"));

    if (backTarget === "collection2") {
      applyCollectionNotesFallback(product, getCollection2NotesFallback());
    } else if (backTarget === "collection3") {
      applyCollectionNotesFallback(product, getCollection3NotesFallback());
    }

    ghPushXpRoute(shortcut.getAttribute("href") || product.url, {
      type: "product",
      handle: product.handle || handle
    });

    openDynamicShopifyProduct(product, backTarget);
    return;
  }

  if (productId === "interlockingPendant") {
    activeShopifyProduct = null;
    productBackTarget = "collection";
    cartVariants = Array.isArray(ghProductConfig.cartVariants) ? ghProductConfig.cartVariants : [];
    setupVariantControls();
    showStorePage();
  }
}

document.addEventListener("click", (event) => {
  if (!ghIsPlainPrimaryClick(event)) return;

  const shortcut = event.target.closest && event.target.closest(
    "#openWindow, #openCollection2, #openCollection3, " +
    "[data-product-shortcut], " +
    ".featured-product-desktop-icon, " +
    ".desktop-product-shortcut[data-featured-product-handle], " +
    ".collection-product-shortcut[data-featured-product-handle], " +
    ".desktop-product-shortcut[data-shopify-product-handle], " +
    ".collection-product-shortcut[data-shopify-product-handle], " +
    ".desktop-product-shortcut[data-product-id]"
  );

  if (!shortcut) return;

  const isNameChainShortcut =
    shortcut.classList.contains("gh-namechain-launcher") ||
    shortcut.getAttribute("data-namechain-launcher") === "true";

  if (isNameChainShortcut) return;

  const productShortcutType =
    shortcut.getAttribute("data-product-shortcut") ||
    (shortcut.id === "openWindow" ? "rings" : "") ||
    (shortcut.id === "openCollection2" ? "collection2" : "") ||
    (shortcut.id === "openCollection3" ? "collection3" : "");

  if (productShortcutType === "rings" || productShortcutType === "collection2" || productShortcutType === "collection3") {
    ghStopShortcutClick(event);

    const routeHandle = productShortcutType === "collection3"
      ? getCollection3Handle()
      : (productShortcutType === "collection2" ? getCollection2Handle() : getPrimaryCollectionHandle());

    const href = shortcut.getAttribute("href") || ("/collections/" + routeHandle);

    ghPushXpRoute(href, {
      type: "collection",
      handle: routeHandle
    });

    showCollectionPage(productShortcutType);
    return;
  }

  const isProductShortcut =
    shortcut.matches(".featured-product-desktop-icon, .desktop-product-shortcut[data-featured-product-handle], .collection-product-shortcut[data-featured-product-handle], .desktop-product-shortcut[data-shopify-product-handle], .collection-product-shortcut[data-shopify-product-handle], .desktop-product-shortcut[data-product-id]");

  if (isProductShortcut) {
    ghStopShortcutClick(event);
    ghOpenProductShortcutWithoutFlash(shortcut).catch((error) => {
      console.error("GoldHearted product shortcut open failed:", error);
      alert("This product could not be opened yet. Check the product handle in the theme editor.");
    });
  }
}, true);

/* =========================
   GOLDHEARTED MESSENGER
========================= */

const openAim = document.getElementById("openAim");
const aimWindow = document.getElementById("aimWindow");
const aimWindowTitle = document.getElementById("aimWindowTitle");

const aimCloseBtn = document.getElementById("aimCloseBtn");
const aimMinBtn = document.getElementById("aimMinBtn");
const aimMaxBtn = document.getElementById("aimMaxBtn");

const aimTask = document.getElementById("aim-task");

const aimSignOnPanel = document.getElementById("aimSignOnPanel");
const aimLoadingPanel = document.getElementById("aimLoadingPanel");
const aimChatPanel = document.getElementById("aimChatPanel");

const aimName = document.getElementById("aimName");
const aimEmail = document.getElementById("aimEmail");
const aimJoinList = document.getElementById("aimJoinList");

const aimSignOnBtn = document.getElementById("aimSignOnBtn");
const aimLoadingVideo = document.getElementById("aimLoadingVideo");

const aimMessage = document.getElementById("aimMessage");
const aimSendBtn = document.getElementById("aimSendBtn");
const aimTranscript = document.getElementById("aimTranscript");
const ghMessengerShopifyForms = document.getElementById("ghMessengerShopifyForms");

function showAimPanel(panelName) {

  if (aimSignOnPanel) {
    aimSignOnPanel.classList.add("hidden");
  }

  if (aimLoadingPanel) {
    aimLoadingPanel.classList.add("hidden");
  }

  if (aimChatPanel) {
    aimChatPanel.classList.add("hidden");
  }

  if (panelName === "signon" && aimSignOnPanel) {
    aimSignOnPanel.classList.remove("hidden");
  }

  if (panelName === "loading" && aimLoadingPanel) {
    aimLoadingPanel.classList.remove("hidden");
  }

  if (panelName === "chat" && aimChatPanel) {
    aimChatPanel.classList.remove("hidden");
  }
}

function openAimWindow() {

  if (!aimWindow) {
    return;
  }

  aimWindow.classList.remove("hidden");
  aimWindow.classList.remove("minimized");
  aimWindow.classList.remove("maximized");
  aimWindow.classList.remove("aim-loading-only");

 aimWindow.style.width = "";
 aimWindow.style.height = "";
 aimWindow.style.top = "";
 aimWindow.style.left = "";
 aimWindow.style.transform = "";

 unlockAimSignOnSize();

  aimWindow.classList.add("aim-signon-size");
  aimWindow.classList.remove("aim-chat-size");

  if (aimWindowTitle) {
    aimWindowTitle.innerText = ghThemeText(
      "messengerWindowTitle",
      ghThemeText("messengerTaskTitle", "Messenger")
    );
  }

  showAimPanel("signon");

  if (aimTask) {
    aimTask.classList.remove("hidden");
    aimTask.innerText = ghThemeText("messengerTaskTitle", "Messenger");
  }

  bringToFront(aimWindow);
}

function openAimLoading() {

  if (!aimWindow) {
    return;
  }

  aimWindow.classList.remove("aim-signon-size");
  aimWindow.classList.remove("aim-chat-size");

  aimWindow.classList.add("aim-loading-only");

  if (aimWindowTitle) {
    aimWindowTitle.innerText =
      ghThemeText("messengerWindowTitle", ghThemeText("messengerTaskTitle", "Messenger")) +
      " - Signing On";
  }

  showAimPanel("loading");

  if (aimLoadingVideo) {

    aimLoadingVideo.currentTime = 0;

    const sizeLoadingWindow = () => {

      const videoRatio =
        aimLoadingVideo.videoWidth / aimLoadingVideo.videoHeight;

      const maxWidth = window.innerWidth * 0.35;
      const maxHeight = window.innerHeight * 0.35;

      let width = maxWidth;
      let height = width / videoRatio;

      if (height > maxHeight) {
        height = maxHeight;
        width = height * videoRatio;
      }

      aimWindow.style.width = width + "px";
      aimWindow.style.height = height + "px";

      aimWindow.style.top = "50%";
      aimWindow.style.left = "50%";
      aimWindow.style.transform = "translate(-50%, -50%)";
    };

    if (aimLoadingVideo.readyState >= 1) {
      sizeLoadingWindow();
    } else {
      aimLoadingVideo.addEventListener(
        "loadedmetadata",
        sizeLoadingWindow,
        { once: true }
      );
    }

    aimLoadingVideo.play().catch(() => {});
  }

  bringToFront(aimWindow);

  setTimeout(() => {
    openAimChat();
  }, 2600);
}

function openAimChat() {

  if (!aimWindow) {
    return;
  }

  aimWindow.classList.remove("aim-loading-only");
  aimWindow.classList.remove("aim-signon-size");
  aimWindow.classList.add("aim-chat-size");

  aimWindow.style.width = "";
  aimWindow.style.height = "";
  aimWindow.style.top = "";
  aimWindow.style.left = "";
  aimWindow.style.transform = "";

  if (aimWindowTitle) {
    aimWindowTitle.innerText =
      ghThemeText("messengerWindowTitle", ghThemeText("messengerTaskTitle", "Messenger")) +
      " - Instant Message";
  }

  showAimPanel("chat");

  bringToFront(aimWindow);
}

function addAimMessage(sender, text, type) {

  if (!aimTranscript) {
    return;
  }

  const messageDiv = document.createElement("div");

  messageDiv.classList.add("aim-message");

  if (type === "user") {
    messageDiv.classList.add("aim-message-user");
  } else {
    messageDiv.classList.add("aim-message-bot");
  }

  messageDiv.innerHTML =
    "<strong>" + sender + ":</strong> " + text;

  aimTranscript.appendChild(messageDiv);

  aimTranscript.scrollTop = aimTranscript.scrollHeight;
}

if (openAim) {

  openAim.addEventListener("click", () => {
    openAimWindow();
    aimWindow.style.width = "";
aimWindow.style.height = "";
aimWindow.style.top = "";
aimWindow.style.left = "";
aimWindow.style.transform = "";

unlockAimSignOnSize();
  });

}

if (aimSignOnBtn) {

  aimSignOnBtn.addEventListener("click", () => {

    const nameValue = aimName ? aimName.value.trim() : "";
    const emailValue = aimEmail ? aimEmail.value.trim() : "";

    if (!nameValue || !emailValue) {
      alert("Please enter your name and email to sign on.");
      return;
    }

    openAimLoading();

  });

}

/* =========================
   AIM SEND MESSAGE
========================= */

function getAimMessageHTML() {

  if (!aimMessage) {
    return "";
  }

  if ("value" in aimMessage) {
    return aimMessage.value.trim();
  }

  return aimMessage.innerHTML.trim();
}

function getAimMessagePlainText() {

  if (!aimMessage) {
    return "";
  }

  if ("value" in aimMessage) {
    return aimMessage.value.trim();
  }

  return aimMessage.textContent.trim();
}

function clearAimMessage() {

  if (!aimMessage) {
    return;
  }

  if ("value" in aimMessage) {
    aimMessage.value = "";
  } else {
    aimMessage.innerHTML = "";
  }
}

function ghDeepQueryAll(root, selector) {
  const results = [];

  function walk(node) {
    if (!node) {
      return;
    }

    if (node.querySelectorAll) {
      node.querySelectorAll(selector).forEach((item) => results.push(item));
    }

    if (node.shadowRoot) {
      walk(node.shadowRoot);
    }

    if (node.children) {
      Array.from(node.children).forEach((child) => walk(child));
    }
  }

  walk(root);
  return results;
}

function ghSetFieldValue(field, value) {
  if (!field) {
    return;
  }

  field.value = value;
  field.dispatchEvent(new Event("input", { bubbles: true }));
  field.dispatchEvent(new Event("change", { bubbles: true }));
}

const GH_MESSENGER_FORMSPREE_ENDPOINT = "https://formspree.io/f/xjgdjqja";

async function ghSubmitMessengerToFormspree(nameValue, emailValue, messagePlainText) {
  const payload = {
    _subject: "New GH Instant Messenger message",
    source: "GoldHearted XP Messenger",
    name: nameValue,
    email: emailValue,
    message: messagePlainText,
    join_email_list: aimJoinList && aimJoinList.checked ? "Yes" : "No"
  };

  const response = await fetch(GH_MESSENGER_FORMSPREE_ENDPOINT, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    let errorText = "Messenger could not send. Please try again.";

    try {
      const data = await response.json();
      if (data && data.errors && data.errors.length) {
        errorText = data.errors.map((error) => error.message || error.code || "Error").join(" ");
      }
    } catch (error) {}

    throw new Error(errorText);
  }

  return true;
}

if (aimSendBtn) {

  aimSendBtn.addEventListener("click", async () => {

    if (!aimMessage) {
      return;
    }

    const messageHTML = getAimMessageHTML();
    const messagePlainText = getAimMessagePlainText();

    if (!messagePlainText) {
      return;
    }

    const nameValue =
      aimName && aimName.value.trim()
        ? aimName.value.trim()
        : "Customer";

    const emailValue =
      aimEmail && aimEmail.value.trim()
        ? aimEmail.value.trim()
        : "";

    if (!emailValue) {
      alert("Please enter your email before sending.");
      return;
    }

    addAimMessage(nameValue, messageHTML, "user");
    clearAimMessage();

    aimMessage.setAttribute("contenteditable", "false");
    aimMessage.classList.add("is-disabled");
    aimSendBtn.disabled = true;
    aimSendBtn.innerText = "Sending...";

    addAimMessage("King Cold", "Sending your message now...", "bot");

    try {
      await ghSubmitMessengerToFormspree(nameValue, emailValue, messagePlainText);

      window.GHAnalytics?.trackLead?.("contact_messenger", "ghInstantMessenger", {
        lead_category: "direct_contact",
        app_name: "XP Messenger"
      });

      aimSendBtn.innerText = "Sent";

      setTimeout(() => {
        addAimMessage(
          "King Cold",
          "Thank you. Message received. We’ll be in contact with you shortly.",
          "bot"
        );
      }, 450);
    } catch (error) {
      aimMessage.setAttribute("contenteditable", "true");
      aimMessage.classList.remove("is-disabled");
      aimSendBtn.disabled = false;
      aimSendBtn.innerText = "Send";

      setTimeout(() => {
        addAimMessage(
          "King Cold",
          "Message could not send yet. Please try again in a moment.",
          "bot"
        );
      }, 250);

      console.error("GH Messenger Formspree error:", error);
    }

  });

}

if (aimMessage) {

  aimMessage.addEventListener("keydown", (event) => {

    if (event.key === "Enter" && !event.shiftKey) {

      event.preventDefault();

      if (aimSendBtn) {
        aimSendBtn.click();
      }

    }

  });

}

if (aimCloseBtn) {

  aimCloseBtn.addEventListener("click", () => {

    if (aimWindow) {
      aimWindow.classList.add("hidden");
    }

    if (aimTask) {
      aimTask.classList.add("hidden");
      aimTask.classList.remove("active-task");
    }

    ghClearUtilityHash(GH_UTILITY_HASH_MESSENGER);

  });

}

if (aimMinBtn) {

  aimMinBtn.addEventListener("click", () => {

    if (aimWindow) {
      aimWindow.classList.add("minimized");
    }

    if (aimTask) {
      aimTask.classList.remove("active-task");
    }

    ghClearUtilityHash(GH_UTILITY_HASH_MESSENGER);

  });

}

/* =========================
   AIM SIGN ON MAXIMIZE SIZE LOCK
   Keeps sign-on screen same size when maximized
========================= */

function lockAimSignOnSizeWhenMaximized() {

  if (!aimWindow || !aimSignOnPanel) {
    return;
  }

  const aimContent =
    aimWindow.querySelector(".aim-content");

  const aimLogoBox =
    aimWindow.querySelector(".aim-logo-box");

  const aimLogoImg =
    aimWindow.querySelector(".aim-logo-box img");

  const aimInputs =
    aimWindow.querySelectorAll(".aim-input");

  /* Only lock size on the sign-on screen */
  if (
    !aimWindow.classList.contains("maximized") ||
    !aimWindow.classList.contains("aim-signon-size")
  ) {
    return;
  }

  if (aimContent) {
    aimContent.style.display = "flex";
    aimContent.style.alignItems = "flex-start";
    aimContent.style.justifyContent = "flex-start";
    aimContent.style.padding = "8px";
    aimContent.style.overflow = "hidden";
  }

  /* Original sign-on panel size from the small window */
  aimSignOnPanel.style.width = "244px";
  aimSignOnPanel.style.minWidth = "244px";
  aimSignOnPanel.style.maxWidth = "244px";

  aimSignOnPanel.style.height = "382px";
  aimSignOnPanel.style.minHeight = "382px";
  aimSignOnPanel.style.maxHeight = "382px";

  aimSignOnPanel.style.flex = "0 0 244px";
  aimSignOnPanel.style.alignSelf = "flex-start";

  if (aimLogoBox) {
    aimLogoBox.style.width = "244px";
    aimLogoBox.style.minWidth = "244px";
    aimLogoBox.style.maxWidth = "244px";

    aimLogoBox.style.height = "165px";
    aimLogoBox.style.minHeight = "165px";
    aimLogoBox.style.maxHeight = "165px";

    aimLogoBox.style.overflow = "hidden";
    aimLogoBox.style.flex = "0 0 165px";
  }

  if (aimLogoImg) {
    aimLogoImg.style.width = "244px";
    aimLogoImg.style.minWidth = "244px";
    aimLogoImg.style.maxWidth = "244px";

    aimLogoImg.style.height = "165px";
    aimLogoImg.style.minHeight = "165px";
    aimLogoImg.style.maxHeight = "165px";

    aimLogoImg.style.objectFit = "cover";
    aimLogoImg.style.objectPosition = "center center";
    aimLogoImg.style.display = "block";
  }

  aimInputs.forEach((input) => {
    input.style.width = "244px";
    input.style.maxWidth = "244px";
  });

}

function unlockAimSignOnSize() {

  if (!aimWindow || !aimSignOnPanel) {
    return;
  }

  const aimContent =
    aimWindow.querySelector(".aim-content");

  const aimLogoBox =
    aimWindow.querySelector(".aim-logo-box");

  const aimLogoImg =
    aimWindow.querySelector(".aim-logo-box img");

  const aimInputs =
    aimWindow.querySelectorAll(".aim-input");

  if (aimContent) {
    aimContent.style.display = "";
    aimContent.style.alignItems = "";
    aimContent.style.justifyContent = "";
    aimContent.style.padding = "";
    aimContent.style.overflow = "";
  }

  aimSignOnPanel.style.width = "";
  aimSignOnPanel.style.minWidth = "";
  aimSignOnPanel.style.maxWidth = "";
  aimSignOnPanel.style.height = "";
  aimSignOnPanel.style.minHeight = "";
  aimSignOnPanel.style.maxHeight = "";
  aimSignOnPanel.style.flex = "";
  aimSignOnPanel.style.alignSelf = "";

  if (aimLogoBox) {
    aimLogoBox.style.width = "";
    aimLogoBox.style.minWidth = "";
    aimLogoBox.style.maxWidth = "";
    aimLogoBox.style.height = "";
    aimLogoBox.style.minHeight = "";
    aimLogoBox.style.maxHeight = "";
    aimLogoBox.style.overflow = "";
    aimLogoBox.style.flex = "";
  }

  if (aimLogoImg) {
    aimLogoImg.style.width = "";
    aimLogoImg.style.minWidth = "";
    aimLogoImg.style.maxWidth = "";
    aimLogoImg.style.height = "";
    aimLogoImg.style.minHeight = "";
    aimLogoImg.style.maxHeight = "";
    aimLogoImg.style.objectFit = "";
    aimLogoImg.style.objectPosition = "";
    aimLogoImg.style.display = "";
  }

  aimInputs.forEach((input) => {
    input.style.width = "";
    input.style.maxWidth = "";
  });

}

if (aimMaxBtn) {

  aimMaxBtn.addEventListener("click", () => {

    if (!aimWindow) {
      return;
    }

    aimWindow.classList.toggle("maximized");

    if (
      aimWindow.classList.contains("maximized") &&
      aimWindow.classList.contains("aim-signon-size")
    ) {

      lockAimSignOnSizeWhenMaximized();

      setTimeout(() => {
        lockAimSignOnSizeWhenMaximized();
      }, 50);

      setTimeout(() => {
        lockAimSignOnSizeWhenMaximized();
      }, 150);

    } else {

      unlockAimSignOnSize();

    }

    bringToFront(aimWindow);

  });

}

if (aimTask) {

  aimTask.addEventListener("click", () => {

    if (aimWindow) {
      aimWindow.classList.remove("hidden");
      aimWindow.classList.remove("minimized");
      bringToFront(aimWindow);
    }

  });

}

/* =========================
   COLLECTION PRODUCT SHORTCUTS
========================= */

collectionProductShortcuts.forEach((shortcut) => {

  shortcut.addEventListener("click", async (event) => {

    if (shortcut.tagName === "A" && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
      return;
    }

    const isNameChainShortcut =
      shortcut.classList.contains("gh-namechain-launcher") ||
      shortcut.getAttribute("data-namechain-launcher") === "true";

    // NameChain.exe owns its launcher events so it can update the URL and
    // open its shared shopping-slot window without a second competing handler.
    if (isNameChainShortcut) {
      return;
    }

    if (shortcut.hasAttribute("data-product-shortcut")) {
      return;
    }

    if (shortcut.tagName === "A") {
      event.preventDefault();
    }

    const featuredHandle = shortcut.dataset.featuredProductHandle;
    if (featuredHandle) {
      try {
        const featuredProduct = await fetchFeaturedProductByHandle(
          featuredHandle,
          shortcut.dataset.featuredIconUrl || "",
          getFeaturedShortcutMediaOptions(shortcut)
        );
        if (featuredProduct) {
          const shortcutLabel = shortcut.querySelector("span") ? shortcut.querySelector("span").textContent.trim() : "";
          featuredProduct.taskLabel = shortcutLabel || "Featured Product";
          const featuredBackTarget =
            shortcut.dataset.ghBackTarget ||
            (shortcut.closest("#infoAllProductsPage") ? "allProducts" : "desktop");
          ghPushXpRoute(shortcut.getAttribute("href") || featuredProduct.url, {
            type: "product",
            handle: featuredProduct.handle || featuredHandle
          });
          openDynamicShopifyProduct(featuredProduct, featuredBackTarget);
          return;
        }
      } catch (error) {
        alert("This featured product could not be opened yet. Check the product handle in the theme editor.");
        return;
      }
    }

    const dynamicHandle = shortcut.dataset.shopifyProductHandle;
    if (dynamicHandle) {
      const dynamicProduct = findDynamicProductByHandle(dynamicHandle);
      if (dynamicProduct) {
        const dynamicBackTarget = shortcut.closest("#infoAllProductsPage") ? "allProducts" : "collection";
        ghPushXpRoute(shortcut.getAttribute("href") || dynamicProduct.url, {
          type: "product",
          handle: dynamicProduct.handle || dynamicHandle
        });
        openDynamicShopifyProduct(dynamicProduct, dynamicBackTarget);
        return;
      }
    }

    const productId = shortcut.dataset.productId;

    if (productId === "interlockingPendant") {
      activeShopifyProduct = null;
      cartVariants = Array.isArray(ghProductConfig.cartVariants) ? ghProductConfig.cartVariants : [];
      setupVariantControls();

      showStorePage();

      if (windowEl) {
        bringToFront(windowEl);
      }

      return;
    }

    alert("This product page is not built yet.");

  });

});
/* =========================
   LOG OFF TO PASSWORD PAGE
========================= */

const logOffButton = document.getElementById("logOffButton");

if (logOffButton) {

  logOffButton.addEventListener("click", () => {

    window.location.href = "/password";

  });

}
/* =========================
   AIM CHARACTER BAR FEATURES
========================= */

const aimEditor = document.getElementById("aimMessage");
const aimFormatButtons = document.querySelectorAll(".aim-format-btn");
const aimColorButtons = document.querySelectorAll(".aim-color-btn");
const aimEmojiButtons = document.querySelectorAll(".aim-emoji-btn");

function focusAimEditor() {
  if (aimEditor) {
    aimEditor.focus();
  }
}

function runAimCommand(command, value = null) {
  focusAimEditor();

  document.execCommand(command, false, value);
}

aimFormatButtons.forEach((button) => {

  button.addEventListener("click", () => {

    const format = button.dataset.format;

    if (format === "bold") {
      runAimCommand("bold");
    }

    if (format === "italic") {
      runAimCommand("italic");
    }

    if (format === "underline") {
      runAimCommand("underline");
    }

  });

});

aimColorButtons.forEach((button) => {

  button.addEventListener("click", () => {

    const color = button.dataset.color;

    runAimCommand("foreColor", color);

  });

});

aimEmojiButtons.forEach((button) => {

  button.addEventListener("click", () => {

    const emoji = button.dataset.emoji;

    focusAimEditor();

    document.execCommand("insertText", false, emoji);

  });

});
/* =========================
   METAL PRICING WINDOW
========================= */

const openMetalPricing = document.getElementById("openMetalPricing");
const metalWindow = document.getElementById("metalWindow");
const metalWindowTitle = document.getElementById("metalWindowTitle");

const metalCloseBtn = document.getElementById("metalCloseBtn");
const metalMinBtn = document.getElementById("metalMinBtn");
const metalMaxBtn = document.getElementById("metalMaxBtn");

const metalTask = document.getElementById("metal-task");
const metalRefreshBtn = document.getElementById("metalRefreshBtn");

const goldSpotPrice = document.getElementById("goldSpotPrice");
const silverSpotPrice = document.getElementById("silverSpotPrice");
const platinumSpotPrice = document.getElementById("platinumSpotPrice");
const metalLastUpdated = document.getElementById("metalLastUpdated");
const ghLiveMetalUrl = "https://goldhearted-metal-prices.goldheartedjewelryco.workers.dev/";
let ghMetalPricesLoading = false;

function formatLiveMetalPrice(value) {

  const number = Number(value);

  if (!Number.isFinite(number) || number <= 0) {
    return "--";
  }

  return "$" + number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + " / oz";
}

function setMetalLoadingText() {

  if (goldSpotPrice) {
    goldSpotPrice.innerText = "Updating...";
  }

  if (silverSpotPrice) {
    silverSpotPrice.innerText = "Updating...";
  }

  if (platinumSpotPrice) {
    platinumSpotPrice.innerText = "Updating...";
  }

  if (metalLastUpdated) {
    metalLastUpdated.innerText = "checking live price...";
  }
}

function renderLiveMetalPrices(data) {

  if (!data || !data.metals) {
    throw new Error("No metal data returned.");
  }

  if (goldSpotPrice) {
    goldSpotPrice.innerText = formatLiveMetalPrice(data.metals.gold && data.metals.gold.per_oz);
  }

  if (silverSpotPrice) {
    silverSpotPrice.innerText = formatLiveMetalPrice(data.metals.silver && data.metals.silver.per_oz);
  }

  if (platinumSpotPrice) {
    platinumSpotPrice.innerText = formatLiveMetalPrice(data.metals.platinum && data.metals.platinum.per_oz);
  }

  if (metalLastUpdated) {
    metalLastUpdated.innerText = data.updated_label || "updated today";
  }
}

async function refreshLiveMetalPrices() {

  if (ghMetalPricesLoading) {
    return;
  }

  ghMetalPricesLoading = true;
  setMetalLoadingText();

  try {
    const response = await fetch(ghLiveMetalUrl, {
      cache: "no-store"
    });

    const data = await response.json();

    if (!response.ok || data.success === false) {
      throw new Error(data.error || "Live metal update failed.");
    }

    renderLiveMetalPrices(data);
  } catch (error) {
    console.warn("GoldHearted live metal pricing failed:", error);

    if (metalLastUpdated) {
      metalLastUpdated.innerText = "live update unavailable";
    }
  }

  ghMetalPricesLoading = false;
}

function openMetalWindow() {

  if (!metalWindow) {
    return;
  }

  metalWindow.classList.remove("hidden");
  metalWindow.classList.remove("minimized");

  if (metalWindowTitle) {
    metalWindowTitle.innerText = ghThemeText(
      "metalWindowTitle",
      ghThemeText("metalTaskTitle", "Metal Pricing")
    );
  }

  if (metalTask) {
    metalTask.classList.remove("hidden");
    metalTask.innerText = ghThemeText("metalTaskTitle", "Metal Pricing");
  }

  closeStartMenu();

  refreshLiveMetalPrices();

  bringToFront(metalWindow);
}

if (openMetalPricing) {

  openMetalPricing.addEventListener("click", () => {

    openMetalWindow();

  });

}

if (metalRefreshBtn) {

  metalRefreshBtn.addEventListener("click", () => {

    refreshLiveMetalPrices();

  });

}

if (metalCloseBtn) {

  metalCloseBtn.addEventListener("click", () => {

    if (metalWindow) {
      metalWindow.classList.add("hidden");
    }

    if (metalTask) {
      metalTask.classList.add("hidden");
      metalTask.classList.remove("active-task");
    }

    ghClearUtilityHash(GH_UTILITY_HASH_METAL);

  });

}

if (metalMinBtn) {

  metalMinBtn.addEventListener("click", () => {

    if (metalWindow) {
      metalWindow.classList.add("minimized");
    }

    if (metalTask) {
      metalTask.classList.remove("active-task");
    }

    ghClearUtilityHash(GH_UTILITY_HASH_METAL);

  });

}

if (metalMaxBtn) {

  metalMaxBtn.addEventListener("click", () => {

    if (metalWindow) {
      metalWindow.classList.toggle("maximized");
      bringToFront(metalWindow);
    }

  });

}

if (metalTask) {

  metalTask.addEventListener("click", () => {

    if (metalWindow) {
      metalWindow.classList.remove("hidden");
      metalWindow.classList.remove("minimized");
      bringToFront(metalWindow);
    }

  });

}

updateMetalTimestamp();

/* =========================
   CLEAN TASKBAR LABELS
========================= */

function cleanTaskbarLabels() {

  const taskLabels = [
    ringsTask,
    infoTask,
    aimTask,
    metalTask,
    getAppWindowById("namechain-task")
  ];

  taskLabels.forEach((task) => {

    if (!task) {
      return;
    }

    task.innerText = task.innerText
      .replace("💎", "")
      .trim();

  });

}

setInterval(cleanTaskbarLabels, 300);

/* =========================
   FORCE TASKBAR CLOSED ON LOAD
========================= */

function resetTaskbarOnLoad() {

  const initialPageType = String(ghProductConfig.pageType || ghThemeText("pageType", ""));
  const initialInfoRoute = ghInfoRouteFromPath(window.location.pathname);
  const keepShoppingTaskVisible = initialPageType === "product" || (initialPageType === "collection" && !initialInfoRoute);
  const keepInfoTaskVisible = !!initialInfoRoute;

  if (ringsTask) {
    ringsTask.classList.toggle("hidden", !keepShoppingTaskVisible);
    ringsTask.classList.remove("active-task");
    if (!keepShoppingTaskVisible) {
      ringsTask.innerText = ghThemeText("ringsTaskTitle", "Collection Template");
    }
  }

  if (infoTask) {
    infoTask.classList.toggle("hidden", !keepInfoTaskVisible);
    infoTask.classList.remove("active-task");
    if (!keepInfoTaskVisible) {
      infoTask.innerText = ghThemeText("aboutWindowTitle", "Info");
    }
  }

  if (aimTask) {
    aimTask.classList.add("hidden");
    aimTask.classList.remove("active-task");
    aimTask.innerText = ghThemeText("messengerTaskTitle", "Messenger");
  }

  if (metalTask) {
    metalTask.classList.add("hidden");
    metalTask.classList.remove("active-task");
    metalTask.innerText = ghThemeText("metalTaskTitle", "Metal Pricing");
  }



  const namechainTask = getAppWindowById("namechain-task");
  if (namechainTask) {
    namechainTask.classList.add("hidden");
    namechainTask.classList.remove("active-task");
  }
}

resetTaskbarOnLoad();

/* =========================
   SEO DIRECT-LANDING SUPPORT
   Real /products/... and /collections/... URLs keep the XP desktop shell,
   but automatically open the content the visitor/search engine selected.
========================= */

async function initializeSeoLandingPage() {
  const pageType = String(ghProductConfig.pageType || ghThemeText("pageType", ""));
  const directInfoRoute = ghInfoRouteFromPath(window.location.pathname);

  if (directInfoRoute) {
    ghOpenInfoRoute(directInfoRoute.pageId, { push: false });

    /* Browser/session restoration can reapply an old inner-scroll position
       after the first paint. Reset the actual active info-page scroller again
       so direct links and refreshes always begin with the current page heading. */
    const directInfoPage = document.getElementById(directInfoRoute.targetPageId);
    if (directInfoPage) {
      directInfoPage.scrollTop = 0;
      window.requestAnimationFrame(() => { directInfoPage.scrollTop = 0; });
      window.setTimeout(() => { directInfoPage.scrollTop = 0; }, 120);
      window.setTimeout(() => { directInfoPage.scrollTop = 0; }, 350);
    }
    return;
  }


  if (pageType === "product" && ghProductConfig.cartProductHandle) {
    try {
      const directFeaturedShortcut = getFeaturedShortcutForHandle(ghProductConfig.cartProductHandle);
      const directProduct = await fetchFeaturedProductByHandle(
        ghProductConfig.cartProductHandle,
        directFeaturedShortcut
          ? (directFeaturedShortcut.dataset.featuredIconUrl || ghProductConfig.goldImage || "")
          : (ghProductConfig.goldImage || ""),
        getFeaturedShortcutMediaOptions(directFeaturedShortcut)
      );

      if (directProduct) {
        directProduct.taskLabel = directProduct.title || ghProductConfig.cartProductTitle || "Product";
        openDynamicShopifyProduct(directProduct, "desktop");
      }
    } catch (error) {
      // Server-rendered product content/config remains available even if enhancement fails.
    }
    return;
  }

  if (pageType === "collection" && ghProductConfig.currentCollectionHandle) {
    const handle = String(ghProductConfig.currentCollectionHandle || "");
    if (handle && handle === getCollection3Handle()) {
      showCollectionPage("collection3");
    } else if (handle && handle === getCollection2Handle()) {
      showCollectionPage("collection2");
    } else {
      showCollectionPage("rings");
    }
    return;
  }

  if (pageType === "page" && ghProductConfig.isNameChainPage) {
    const openNameChain = () => {
      if (typeof window.GHOpenNameChainWindow === "function") {
        window.GHOpenNameChainWindow();
        return true;
      }
      return false;
    };

    if (!openNameChain()) {
      window.setTimeout(openNameChain, 80);
    }
  }
}

const ghInitialUtilityHash = ghNormalizeUtilityHash(window.location.hash);

initializeSeoLandingPage()
  .catch((error) => {
    console.error("GoldHearted SEO route initialization failed:", error);
  })
  .finally(() => {
    window.requestAnimationFrame(() => {
      document.body?.classList.remove("gh-route-pending");
    });

    // Hashes are UI state only. Reopen the requested utility after the real
    // Shopify route has initialized, including direct loads such as
    // /pages/custom-name-chain#metal-pricing.
    ghScheduleUtilityWindowForHash(ghInitialUtilityHash, 40);
  });

/*
  Direct collection URLs can be entered in the address bar before the XP
  window state has fully settled.  Re-apply the requested collection after
  DOM readiness/load as a small recovery pass so a hard refresh or pasted
  /collections/... URL always opens the collection window instead of leaving
  the visitor on the bare desktop.
*/
function ghRecoverDirectCollectionLanding() {
  const pageType = String(ghProductConfig.pageType || ghThemeText("pageType", ""));
  const handle = String(ghProductConfig.currentCollectionHandle || "").trim();
  if (pageType !== "collection" || !handle) return;

  const openRequestedCollection = () => {
    if (handle === getCollection3Handle()) {
      showCollectionPage("collection3");
    } else if (handle === getCollection2Handle()) {
      showCollectionPage("collection2");
    } else {
      showCollectionPage("rings");
    }
    document.body?.classList.remove("gh-route-pending");
  };

  // Immediate recovery plus two readiness checkpoints.  Re-opening the same
  // collection is idempotent and avoids a visible wrong-template flash.
  window.setTimeout(openRequestedCollection, 40);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openRequestedCollection, { once: true });
  } else {
    window.setTimeout(openRequestedCollection, 0);
  }
  if (document.readyState !== "complete") {
    window.addEventListener("load", openRequestedCollection, { once: true });
  }
}

ghRecoverDirectCollectionLanding();

/* =========================
   BROWSER BACK / FORWARD
   The URL can change without a full page reload. Keep the XP shopping slot
   synchronized when the customer uses the browser Back or Forward buttons.
========================= */

function closeShoppingSlotForBrowserRoute() {
  const productWindow = getAppWindowById("window");
  const namechainWindow = getAppWindowById("namechainWindow");
  const productTask = getAppWindowById("rings-task");
  const namechainTask = getAppWindowById("namechain-task");

  [productWindow, namechainWindow].forEach((target) => {
    if (!target) return;
    target.classList.add("hidden");
    target.classList.remove("minimized", "active-window");
  });

  [productTask, namechainTask].forEach((target) => {
    if (!target) return;
    target.classList.add("hidden");
    target.classList.remove("active-task");
  });

  window.setTimeout(() => window.GHActivateTopVisibleWindow?.(), 0);
}

let ghBrowserRouteSyncToken = 0;

function getFeaturedShortcutForHandle(handle) {
  const cleanHandle = String(handle || "").trim();
  if (!cleanHandle) return null;

  return Array.from(collectionProductShortcuts).find((shortcut) =>
    shortcut && String(shortcut.dataset.featuredProductHandle || "").trim() === cleanHandle
  ) || null;
}

function getFeaturedShortcutMediaOptions(shortcut) {
  if (!shortcut) return {};

  return {
    modelUrl: shortcut.getAttribute("data-featured-model-url") || "",
    videos: [
      shortcut.getAttribute("data-featured-video-1-url") || "",
      shortcut.getAttribute("data-featured-video-2-url") || "",
      shortcut.getAttribute("data-featured-video-3-url") || ""
    ],
    donationNote: shortcut.getAttribute("data-featured-donation-note") || "",
    donationLinkLabel: shortcut.getAttribute("data-featured-donation-link-label") || "",
    donationLinkUrl: shortcut.getAttribute("data-featured-donation-link-url") || "",
    fundraiserEnabled: shortcut.getAttribute("data-featured-fundraiser-enabled") || "",
    fundraiserTitle: shortcut.getAttribute("data-featured-fundraiser-title") || "",
    fundraiserNonprofitName: shortcut.getAttribute("data-featured-fundraiser-nonprofit-name") || "",
    fundraiserNonprofitUrl: shortcut.getAttribute("data-featured-fundraiser-nonprofit-url") || "",
    fundraiserGoal: shortcut.getAttribute("data-featured-fundraiser-goal") || "",
    fundraiserRaised: shortcut.getAttribute("data-featured-fundraiser-raised") || "",
    fundraiserPerSale: shortcut.getAttribute("data-featured-fundraiser-per-sale") || "",
    fundraiserPerSaleSilver: shortcut.getAttribute("data-featured-fundraiser-per-sale-silver") || "",
    fundraiserPerSaleGold: shortcut.getAttribute("data-featured-fundraiser-per-sale-gold") || "",
    fundraiserPerSalePlatinum: shortcut.getAttribute("data-featured-fundraiser-per-sale-platinum") || "",
    fundraiserBlurb: shortcut.getAttribute("data-featured-fundraiser-blurb") || "",
    fundraiserLogoUrl: shortcut.getAttribute("data-featured-fundraiser-logo-url") || "",
    fundraiserCurrency: shortcut.getAttribute("data-featured-fundraiser-currency") || "",
    notesEnabled: shortcut.getAttribute("data-featured-notes-enabled") || "",
    notesLabel: shortcut.getAttribute("data-featured-notes-label") || "",
    notesPlaceholder: shortcut.getAttribute("data-featured-notes-placeholder") || "",
    notesHelp: shortcut.getAttribute("data-featured-notes-help") || "",
    cartButtonLabel: shortcut.getAttribute("data-featured-cart-label") || ""
  };
}

function warmFeaturedProductShortcuts() {
  const shortcuts = Array.from(document.querySelectorAll(
    ".featured-product-desktop-icon[data-featured-product-handle]"
  ));

  if (!shortcuts.length) return;

  const warm = () => {
    shortcuts.slice(0, 2).forEach((shortcut) => {
      const handle = String(shortcut.dataset.featuredProductHandle || "").trim();
      if (!handle) return;

      fetchFeaturedProductByHandle(
        handle,
        shortcut.dataset.featuredIconUrl || "",
        getFeaturedShortcutMediaOptions(shortcut)
      ).catch(() => {});
    });
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(warm, { timeout: 700 });
  } else {
    window.setTimeout(warm, 120);
  }
}

warmFeaturedProductShortcuts();

async function syncXpShoppingSlotToBrowserRoute() {
  const syncToken = ++ghBrowserRouteSyncToken;
  const path = ghCleanRoutePath(window.location.pathname);
  const namechainUrl = ghDesktop && ghDesktop.dataset ? ghDesktop.dataset.namechainPageUrl : "";
  let namechainPath = "/pages/custom-name-chain";

  if (namechainUrl) {
    try {
      namechainPath = ghCleanRoutePath(new URL(namechainUrl, window.location.href).pathname);
    } catch (error) {}
  }

  if (path === namechainPath) {
    // Remove the old product/collection view before restoring NameChain.
    closeShoppingSlotForBrowserRoute();
    if (syncToken !== ghBrowserRouteSyncToken) return;

    if (typeof window.GHOpenNameChainWindow === "function") {
      window.GHOpenNameChainWindow();
    }
    return;
  }

  const productMatch = path.match(/^\/products\/([^/]+)$/i);
  if (productMatch) {
    const handle = decodeURIComponent(productMatch[1]);
    const featuredShortcut = getFeaturedShortcutForHandle(handle);

    // Hide NameChain/the previous shopping view immediately. This prevents the
    // old app from remaining visible while product data is being resolved.
    closeShoppingSlotForBrowserRoute();

    try {
      const routedProduct =
        findDynamicProductByHandle(handle) ||
        await fetchFeaturedProductByHandle(
          handle,
          featuredShortcut ? (featuredShortcut.dataset.featuredIconUrl || "") : "",
          getFeaturedShortcutMediaOptions(featuredShortcut)
        );

      if (syncToken !== ghBrowserRouteSyncToken) return;
      if (ghCleanRoutePath(window.location.pathname) !== path) return;

      if (routedProduct) {
        const shortcutLabel = featuredShortcut && featuredShortcut.querySelector("span")
          ? featuredShortcut.querySelector("span").textContent.trim()
          : "";

        routedProduct.taskLabel = shortcutLabel || routedProduct.title || "Product";
        const backTarget = featuredShortcut && featuredShortcut.dataset.ghBackTarget
          ? featuredShortcut.dataset.ghBackTarget
          : "desktop";
        openDynamicShopifyProduct(routedProduct, backTarget);
        return;
      }
    } catch (error) {
      console.error("GoldHearted browser-route product restore failed:", error);
    }

    // Last-resort safety: if Shopify product data could not be enhanced in-place,
    // reload the already-selected browser URL so the server-rendered product route
    // still opens the correct XP product on the next load.
    if (syncToken === ghBrowserRouteSyncToken && ghCleanRoutePath(window.location.pathname) === path) {
      window.location.reload();
    }
    return;
  }

  const collectionMatch = path.match(/^\/collections\/([^/]+)$/i);
  if (collectionMatch) {
    const handle = decodeURIComponent(collectionMatch[1]);
    closeShoppingSlotForBrowserRoute();
    if (syncToken !== ghBrowserRouteSyncToken) return;

    if (handle === getCollection3Handle()) {
      showCollectionPage("collection3");
    } else if (handle === getCollection2Handle()) {
      showCollectionPage("collection2");
    } else {
      showCollectionPage("rings");
    }
    return;
  }

  if (path === "/") {
    closeShoppingSlotForBrowserRoute();
  }
}


/* =========================
   FINAL CLEAN WINDOW HOOKS
   One click system, one taskbar system, one close/minimize fallback
========================= */

function restoreAndFocusAppWindow(targetWindow) {

  if (!targetWindow) {
    return;
  }

  targetWindow.classList.remove("hidden");
  targetWindow.classList.remove("minimized");

  bringToFront(targetWindow);
}

/* Any click inside a visible window brings that window forward. */
document.addEventListener("pointerdown", (event) => {

  const clickedWindow =
    event.target.closest && event.target.closest(".window");

  if (!clickedWindow) {
    return;
  }

  bringToFront(clickedWindow);

  if (startMenu && !startMenu.classList.contains("hidden")) {
    closeStartMenu();
  }

}, true);

/* NameChain taskbar focus safety: mobile taps/pointer events should bring it forward immediately. */
document.addEventListener("pointerdown", (event) => {

  const namechainTask =
    event.target.closest && event.target.closest("#namechain-task");

  if (!namechainTask || typeof window.GHRestoreNameChainWindow !== "function") {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  window.GHRestoreNameChainWindow(event);

}, true);

/* Taskbar buttons restore/focus their own window. */
document.addEventListener("click", (event) => {

  const taskButton =
    event.target.closest &&
    event.target.closest("#rings-task, #info-task, #aim-task, #metal-task, #namechain-task");

  if (!taskButton) {
    return;
  }

  if (taskButton.id === "namechain-task" && typeof window.GHRestoreNameChainWindow === "function") {
    event.preventDefault();
    event.stopPropagation();
    window.GHRestoreNameChainWindow(event);
    return;
  }

  const targetWindow =
    getAppWindowForTask(taskButton);

  restoreAndFocusAppWindow(targetWindow);

}, true);

/* Close/minimize buttons activate the next highest visible window. */
[
  "closeBtn",
  "infoCloseBtn",
  "aimCloseBtn",
  "metalCloseBtn",
  "namechainCloseBtn",
  "minBtn",
  "infoMinBtn",
  "aimMinBtn",
  "metalMinBtn",
  "namechainMinBtn"
].forEach((buttonId) => {

  const button = document.getElementById(buttonId);

  if (!button) {
    return;
  }

  button.addEventListener("click", () => {
    setTimeout(activateTopVisibleWindow, 0);
  });

});

function enforceActiveInfoPageOnly() {

  const infoWindowCheck =
    document.getElementById("infoWindow");

  if (!infoWindowCheck) {
    return;
  }

  const pages =
    infoWindowCheck.querySelectorAll(".info-page");

  pages.forEach((page) => {

    const shouldShow =
      page.classList.contains("active-info-page");

    const isCustomOrderPage =
      page.id === "infoCustomOrderPage";

    const isCustomGrillzPage =
      page.id === "infoCustomGrillzPage";

    const isGoldHeartedEduPage =
      page.id === "infoCustomInfoPage";

    const isAboutPage =
      page.id === "infoAboutPage";

    const isFaqPage =
      page.id === "infoFaqPage";

    const isAllProductsPage =
      page.id === "infoAllProductsPage";

    const isFixedPaneScrollablePage =
      isCustomOrderPage || isCustomGrillzPage || isGoldHeartedEduPage || isAboutPage || isFaqPage || isAllProductsPage;

    page.classList.toggle("hidden", !shouldShow);

    page.style.setProperty(
      "display",
      shouldShow ? "block" : "none",
      "important"
    );

    page.style.setProperty(
      "visibility",
      shouldShow ? "visible" : "hidden",
      "important"
    );

    page.style.setProperty(
      "opacity",
      shouldShow ? "1" : "0",
      "important"
    );

    if (shouldShow && isFixedPaneScrollablePage) {
      // Custom Jewelry, Custom Grillz, GoldHearted EDU, About, FAQ, and All Products use independently
      // scrollable panes inside the shared Info-window slot.
      page.style.setProperty("flex", "1 1 0", "important");
      page.style.setProperty("height", "0", "important");
      page.style.setProperty("min-height", "0", "important");
      page.style.setProperty("overflow-y", "auto", "important");
      page.style.setProperty("overflow-x", "hidden", "important");
      page.style.removeProperty("overflow");
    } else {
      page.style.removeProperty("flex");
      page.style.removeProperty("min-height");
      page.style.removeProperty("overflow-y");
      page.style.removeProperty("overflow-x");

      page.style.setProperty(
        "height",
        shouldShow ? "auto" : "0",
        "important"
      );

      page.style.setProperty(
        "overflow",
        shouldShow ? "visible" : "hidden",
        "important"
      );
    }

  });

}

enforceActiveInfoPageOnly();

document.addEventListener("click", () => {
  setTimeout(enforceActiveInfoPageOnly, 0);
});


/* =========================================================
   NAMECHAIN TASKBAR BRING-TO-FRONT HARD FIX
   Makes the NameChain taskbar tab behave exactly like the other XP task tabs.
========================================================= */
function forceNameChainTaskbarFront(event) {

  const taskButton =
    event?.target?.closest &&
    event.target.closest("#namechain-task");

  if (!taskButton) {
    return;
  }

  const namechainWindow = document.getElementById("namechainWindow");

  if (!namechainWindow) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  namechainWindow.classList.remove("hidden", "minimized");
  taskButton.classList.remove("hidden");

  // Normalize before focusing so this never gets trapped behind older high z-index mobile rules.
  normalizeVisibleWindowZStack(namechainWindow);
  bringToFront(namechainWindow);

  // Extra direct state sync for mobile/touch browsers.
  getAppWindows().forEach((singleWindow) => {
    singleWindow.classList.toggle("active-window", singleWindow === namechainWindow);
  });

  ["rings-task", "info-task", "aim-task", "metal-task", "namechain-task"].forEach((taskId) => {
    const currentTask = document.getElementById(taskId);
    if (currentTask) {
      currentTask.classList.toggle("active-task", taskId === "namechain-task");
    }
  });

  taskButton.classList.remove("hidden");

  // Keep all windows under the fixed taskbar but above every inactive app window.
  namechainWindow.style.setProperty("z-index", String(GH_WINDOW_Z_CEILING), "important");

  window.GHResizeNameChainViewer?.();
}

["pointerdown", "pointerup", "click", "touchend"].forEach((eventName) => {
  document.addEventListener(eventName, forceNameChainTaskbarFront, true);
});

window.GHForceNameChainTaskbarFront = function() {
  const fakeEvent = {
    target: document.getElementById("namechain-task"),
    preventDefault() {},
    stopPropagation() {}
  };
  forceNameChainTaskbarFront(fakeEvent);
};

/* =========================
   TURN OFF COMPUTER TO GOOGLE
========================= */

const shutdownButton =
  document.querySelector(".shutdown-icon");

if (shutdownButton) {

  shutdownButton.addEventListener("click", () => {

    window.location.href = "https://www.google.com";

  });

}

});
/* =========================
   JUDGE.ME CANCEL REVIEW PATCH
   Keeps Judge.me inside the XP window and lets Cancel Review close the form.
========================= */
document.addEventListener("click", function(event) {
  const target = event.target;
  if (!target || !target.closest) return;

  const reviewShell = document.getElementById("judgeMeWidgetShell");
  if (!reviewShell || !reviewShell.contains(target)) return;

  const clickable = target.closest("button, a, input[type='button'], input[type='submit']");
  if (!clickable) return;

  const text = String(clickable.innerText || clickable.value || clickable.getAttribute("aria-label") || "").trim().toLowerCase();

  if (text.includes("cancel") && text.includes("review")) {
    event.preventDefault();
    event.stopPropagation();

    const formWrapper = clickable.closest(".jdgm-form-wrapper") || reviewShell.querySelector(".jdgm-form-wrapper");
    const form = clickable.closest(".jdgm-form") || reviewShell.querySelector(".jdgm-form");

    [formWrapper, form].forEach(function(item) {
      if (item) {
        item.classList.add("gh-review-form-closed");
        item.style.display = "none";
      }
    });

    reviewShell.querySelectorAll(".jdgm-write-rev-link, .jdgm-write-rev-link.jdgm-btn, .jdgm-widget-actions-wrapper a, .jdgm-widget-actions-wrapper button").forEach(function(item) {
      item.classList.remove("gh-review-form-closed");
      item.style.display = "inline-flex";
    });
  }

  if (text.includes("write") && text.includes("review")) {
    setTimeout(function() {
      reviewShell.querySelectorAll(".jdgm-form-wrapper, .jdgm-form").forEach(function(item) {
        item.classList.remove("gh-review-form-closed");
        item.style.display = "";
      });
    }, 50);
  }
}, true);

/* =========================
   GOLDHEARTED EDU INVITE REQUESTS
   Manual approval flow for private calendar events.
   V82: floating mini-window so class cards never expand.
========================= */
document.addEventListener("DOMContentLoaded", function() {
  function getEduInviteModalLayer() {
    let layer = document.getElementById("ghEduInviteModalLayer");
    if (layer) return layer;

    layer = document.createElement("div");
    layer.id = "ghEduInviteModalLayer";
    layer.className = "gh-edu-invite-modal-layer";
    layer.hidden = true;
    layer.setAttribute("aria-hidden", "true");
    document.body.appendChild(layer);
    return layer;
  }

  function portalEduInviteForm(form, toggle) {
    if (!form) return null;
    const layer = getEduInviteModalLayer();

    if (!form.__ghEduPlaceholder) {
      form.__ghEduPlaceholder = document.createComment("GoldHearted EDU invite form portal");
      form.parentNode.insertBefore(form.__ghEduPlaceholder, form);
      form.__ghEduOriginalParent = form.parentNode;
    }

    form.__ghEduToggle = toggle || form.__ghEduToggle || null;
    layer.appendChild(form);
    layer.hidden = false;
    layer.setAttribute("aria-hidden", "false");
    document.body.classList.add("gh-edu-invite-modal-open");
    return layer;
  }

  function restoreEduInviteForm(form) {
    if (!form) return;
    const placeholder = form.__ghEduPlaceholder;
    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(form, placeholder);
      placeholder.remove();
    } else if (form.__ghEduOriginalParent) {
      form.__ghEduOriginalParent.appendChild(form);
    }
    form.__ghEduPlaceholder = null;
    form.__ghEduOriginalParent = null;
  }

  function closeEduInviteForm(form) {
    if (!form) return;
    form.hidden = true;
    form.setAttribute("aria-modal", "false");

    const toggle = form.__ghEduToggle || null;
    if (toggle) toggle.setAttribute("aria-expanded", "false");

    restoreEduInviteForm(form);

    const layer = document.getElementById("ghEduInviteModalLayer");
    if (layer && !layer.querySelector("[data-edu-invite-form]:not([hidden])")) {
      layer.hidden = true;
      layer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("gh-edu-invite-modal-open");
    }
  }

  document.querySelectorAll("[data-edu-invite-toggle]").forEach(function(toggle) {
    toggle.addEventListener("click", function() {
      const card = toggle.closest(".gh-edu-class-card");
      const form = card ? card.querySelector("[data-edu-invite-form]") : null;
      if (!form) return;

      const opening = form.hidden;
      document.querySelectorAll("[data-edu-invite-form]").forEach(function(other) {
        if (other !== form) closeEduInviteForm(other);
      });

      if (!opening) {
        closeEduInviteForm(form);
        return;
      }

      portalEduInviteForm(form, toggle);
      form.hidden = false;
      form.setAttribute("aria-modal", "true");
      toggle.setAttribute("aria-expanded", "true");

      const status = form.querySelector("[data-edu-invite-status]");
      if (status) {
        status.textContent = "";
        status.classList.remove("is-error", "is-success");
      }

      requestAnimationFrame(function() {
        setTimeout(function() {
          const firstField = form.querySelector("input:not([type='hidden'])");
          if (firstField) firstField.focus({ preventScroll: true });
        }, 20);
      });
    });
  });

  document.querySelectorAll("[data-edu-invite-cancel]").forEach(function(cancel) {
    cancel.addEventListener("click", function() {
      closeEduInviteForm(cancel.closest("[data-edu-invite-form]"));
    });
  });

  document.addEventListener("keydown", function(event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-edu-invite-form]:not([hidden])").forEach(closeEduInviteForm);
  });

  document.querySelectorAll("[data-edu-invite-form]").forEach(function(form) {
    form.addEventListener("submit", async function(event) {
      event.preventDefault();

      const endpoint = form.getAttribute("data-formspree-endpoint");
      const submit = form.querySelector(".gh-edu-invite-submit");
      const status = form.querySelector("[data-edu-invite-status]");
      const formData = new FormData(form);
      formData.append("Page URL", window.location.href);

      if (!endpoint) {
        if (status) {
          status.textContent = "Invite request endpoint is missing.";
          status.classList.add("is-error");
        }
        return;
      }

      if (submit) {
        submit.disabled = true;
        submit.dataset.originalLabel = submit.dataset.originalLabel || submit.textContent;
        submit.textContent = "Sending...";
      }
      if (status) {
        status.textContent = "Sending invite request...";
        status.classList.remove("is-error", "is-success");
      }

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          body: formData,
          headers: { "Accept": "application/json" }
        });

        if (!response.ok) throw new Error("EDU invite request failed");

        form.reset();
        if (status) {
          status.textContent = form.getAttribute("data-success-message") || "Request sent. If approved, you’ll receive the private Google Calendar invitation by email.";
          status.classList.add("is-success");
        }
        window.GHAnalytics?.trackLead?.("edu_invite_request", "ghEduInviteForm", {
          lead_category: "edu_class",
          app_name: "GoldHearted EDU"
        });
        setTimeout(function() {
          closeEduInviteForm(form);
        }, 650);
      } catch (error) {
        if (status) {
          status.textContent = "Could not send your request. Please try again.";
          status.classList.add("is-error");
        }
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = submit.dataset.originalLabel || "Send Request";
        }
      }
    });
  });
});

/* =========================
   GOLDHEARTED CUSTOM REVIEW FORM
========================= */
document.addEventListener("DOMContentLoaded", function() {
  const openReviewForm = document.getElementById("ghOpenReviewForm");
  const reviewPanel = document.getElementById("ghReviewFormPanel");
  const cancelReviewForm = document.getElementById("ghCancelReviewForm");

  const customOrderForm = document.getElementById("ghCustomOrderForm");
  const customOrderStatus = document.getElementById("ghCustomOrderStatus");

  if (customOrderForm) {
    customOrderForm.addEventListener("submit", async (event) => {
      event.preventDefault();

      const endpoint = customOrderForm.getAttribute("data-formspree-endpoint");
      const submitButton = customOrderForm.querySelector("button[type='submit']");

      if (!endpoint) {
        if (customOrderStatus) {
          customOrderStatus.textContent = "Form endpoint is missing.";
          customOrderStatus.classList.add("is-error");
        }
        return;
      }

      if (customOrderStatus) {
        customOrderStatus.textContent = "Sending custom request...";
        customOrderStatus.classList.remove("is-error");
      }
      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        const customOrderEmail = customOrderForm.querySelector('input[name="Email"]');
        const customOrderReplyTo = customOrderForm.querySelector('input[name="_replyto"]');
        if (customOrderEmail && customOrderReplyTo) {
          customOrderReplyTo.value = customOrderEmail.value.trim();
        }

        const response = await fetch(endpoint, {
          method: "POST",
          body: new FormData(customOrderForm),
          headers: { "Accept": "application/json" }
        });

        if (!response.ok) {
          throw new Error("Formspree custom order submit failed");
        }

        window.GHAnalytics?.trackLead?.("custom_jewelry", "ghCustomOrderForm", {
          lead_category: "custom_jewelry",
          app_name: "Custom Order"
        });

        customOrderForm.reset();
        if (customOrderStatus) {
          customOrderStatus.textContent = "Request sent. I’ll review the details and reply with the next step.";
          customOrderStatus.classList.remove("is-error");
        }
      } catch (error) {
        if (customOrderStatus) {
          customOrderStatus.textContent = "Could not send. Please try again or email us directly.";
          customOrderStatus.classList.add("is-error");
        }
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    });
  }

  const reviewForm = document.getElementById("ghCustomReviewForm");
  const reviewStatus = document.getElementById("ghReviewFormStatus");

  if (openReviewForm && reviewPanel) {
    openReviewForm.addEventListener("click", function() {
      reviewPanel.classList.remove("hidden");
      if (reviewStatus) reviewStatus.textContent = "";
      setTimeout(function() {
        const firstInput = reviewPanel.querySelector("input, textarea, select");
        if (firstInput) firstInput.focus();
      }, 50);
    });
  }

  if (cancelReviewForm && reviewPanel) {
    cancelReviewForm.addEventListener("click", function() {
      reviewPanel.classList.add("hidden");
      if (reviewStatus) reviewStatus.textContent = "";
    });
  }

  if (reviewForm) {
    reviewForm.addEventListener("submit", async function(event) {
      event.preventDefault();

      const endpoint = reviewForm.getAttribute("data-formspree-endpoint");
      const submitButton = reviewForm.querySelector("button[type='submit']");
      const formData = new FormData(reviewForm);
      const payload = {};

      formData.forEach(function(value, key) {
        payload[key] = value;
      });

      payload.product_page = window.location.href;
      payload.product_address = (document.getElementById("productAddress") || {}).textContent || "";

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = "Submitting...";
      }
      if (reviewStatus) {
        reviewStatus.textContent = "Submitting your review...";
        reviewStatus.classList.remove("is-error");
      }

      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error("Review could not be submitted.");
        }

        reviewForm.reset();
        if (reviewStatus) {
          reviewStatus.textContent = "Thank you. Your review was submitted and will be reviewed before it appears.";
          reviewStatus.classList.remove("is-error");
        }
        if (submitButton) {
          submitButton.textContent = "Submitted";
        }

        setTimeout(function() {
          reviewPanel.classList.add("hidden");
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = "Submit review";
          }
        }, 1800);
      } catch (error) {
        if (reviewStatus) {
          reviewStatus.textContent = "Something went wrong. Please try again.";
          reviewStatus.classList.add("is-error");
        }
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = "Submit review";
        }
      }
    });
  }

  /* =========================
     MOBILE PRODUCT TOOLBAR SCROLL INDICATOR
     Real moving thumb so customers know the toolbar can be swiped.
  ========================= */

  function initMobileProductToolbarScrollIndicator() {
    const productWindow = document.getElementById("window");
    const toolbar = document.querySelector("#window .xp-toolbar");

    if (!productWindow || !toolbar) {
      return;
    }

    /* Completely new mobile toolbar scroller:
       use a real input[type=range] slider instead of the old custom thumb. */
    toolbar.querySelectorAll(".gh-mobile-toolbar-scroll-track, .gh-mobile-toolbar-scroll-thumb").forEach(function(oldPiece) {
      oldPiece.remove();
    });

    productWindow.querySelectorAll(".gh-mobile-toolbar-scroll-shell, .gh-mobile-toolbar-range-wrap").forEach(function(oldScroller) {
      oldScroller.remove();
    });

    let inner = toolbar.querySelector(".gh-toolbar-range-inner");

    if (!inner) {
      inner = document.createElement("div");
      inner.className = "gh-toolbar-range-inner";

      while (toolbar.firstChild) {
        inner.appendChild(toolbar.firstChild);
      }

      toolbar.appendChild(inner);
    }

    const rangeWrap = document.createElement("div");
    rangeWrap.className = "gh-mobile-toolbar-range-wrap";
    rangeWrap.innerHTML = '<input class="gh-mobile-toolbar-range" type="range" min="0" max="1000" value="0" step="1" aria-label="Scroll product toolbar">';
    productWindow.appendChild(rangeWrap);

    const rangeInput = rangeWrap.querySelector(".gh-mobile-toolbar-range");

    if (!rangeInput) {
      return;
    }

    let toolbarOffset = 0;
    let isToolbarPointerDown = false;
    let isToolbarDragging = false;
    let toolbarStartX = 0;
    let toolbarStartY = 0;
    let toolbarStartOffset = 0;
    let suppressNextToolbarClick = false;

    function isMobileToolbarOpen() {
      return window.innerWidth <= 768 &&
        !productWindow.classList.contains("hidden") &&
        !productWindow.classList.contains("minimized");
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function maxToolbarOffset() {
      return Math.max(0, inner.scrollWidth - toolbar.clientWidth);
    }

    function placeRange() {
      const windowRect = productWindow.getBoundingClientRect();
      const toolbarRect = toolbar.getBoundingClientRect();
      const top = toolbarRect.bottom - windowRect.top - 15;
      const left = toolbarRect.left - windowRect.left + 10;
      const width = Math.max(44, toolbarRect.width - 20);

      rangeWrap.style.top = Math.max(30, top) + "px";
      rangeWrap.style.left = Math.max(4, left) + "px";
      rangeWrap.style.width = width + "px";
    }

    function applyToolbarOffset(nextOffset) {
      const maxOffset = maxToolbarOffset();
      toolbarOffset = clamp(nextOffset, 0, maxOffset);

      if (window.innerWidth <= 768) {
        inner.style.transform = "translateX(" + (-toolbarOffset) + "px)";
      } else {
        inner.style.transform = "";
      }

      rangeInput.value = maxOffset > 0
        ? String(Math.round((toolbarOffset / maxOffset) * 1000))
        : "0";
    }

    function updateRangeScroller() {
      if (!isMobileToolbarOpen()) {
        rangeWrap.style.display = "none";
        inner.style.transform = "";
        rangeInput.value = "0";
        return;
      }

      placeRange();

      const maxOffset = maxToolbarOffset();

      if (maxOffset <= 6) {
        rangeWrap.style.display = "none";
        applyToolbarOffset(0);
        return;
      }

      rangeWrap.style.display = "block";
      applyToolbarOffset(toolbarOffset);
    }

    rangeInput.addEventListener("input", function() {
      const maxOffset = maxToolbarOffset();
      const nextValue = parseInt(rangeInput.value, 10) || 0;
      applyToolbarOffset((nextValue / 1000) * maxOffset);
    });

    function beginToolbarDrag(event) {
      if (!isMobileToolbarOpen()) {
        return;
      }

      isToolbarPointerDown = true;
      isToolbarDragging = false;
      toolbarStartX = event.clientX;
      toolbarStartY = event.clientY;
      toolbarStartOffset = toolbarOffset;
    }

    function moveToolbarDrag(event) {
      if (!isToolbarPointerDown || !isMobileToolbarOpen()) {
        return;
      }

      const deltaX = event.clientX - toolbarStartX;
      const deltaY = event.clientY - toolbarStartY;

      if (!isToolbarDragging) {
        if (Math.abs(deltaX) < 7 || Math.abs(deltaX) < Math.abs(deltaY)) {
          return;
        }

        isToolbarDragging = true;
      }

      applyToolbarOffset(toolbarStartOffset - deltaX);
      event.preventDefault();
    }

    function endToolbarDrag() {
      if (isToolbarDragging) {
        suppressNextToolbarClick = true;
        window.setTimeout(function() {
          suppressNextToolbarClick = false;
        }, 120);
      }

      isToolbarPointerDown = false;
      isToolbarDragging = false;
    }

    toolbar.addEventListener("pointerdown", beginToolbarDrag);
    document.addEventListener("pointermove", moveToolbarDrag, { passive: false });
    document.addEventListener("pointerup", endToolbarDrag);
    document.addEventListener("pointercancel", endToolbarDrag);

    toolbar.addEventListener("click", function(event) {
      if (suppressNextToolbarClick) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    window.addEventListener("resize", updateRangeScroller);
    window.addEventListener("orientationchange", function() {
      setTimeout(updateRangeScroller, 250);
    });

    if (window.ResizeObserver) {
      const rangeScrollerResizeObserver = new ResizeObserver(function() {
        setTimeout(updateRangeScroller, 25);
      });
      rangeScrollerResizeObserver.observe(productWindow);
      rangeScrollerResizeObserver.observe(toolbar);
      rangeScrollerResizeObserver.observe(inner);
    }

    if (window.MutationObserver) {
      const rangeScrollerMutationObserver = new MutationObserver(function() {
        setTimeout(updateRangeScroller, 50);
      });
      rangeScrollerMutationObserver.observe(productWindow, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style"]
      });
    }

    window.setInterval(function() {
      if (window.innerWidth <= 768 && !productWindow.classList.contains("hidden")) {
        updateRangeScroller();
      }
    }, 250);

    setTimeout(updateRangeScroller, 100);
    setTimeout(updateRangeScroller, 600);
    setTimeout(updateRangeScroller, 1200);
  }

  initMobileProductToolbarScrollIndicator();

});

/* =========================================================
   GH V1: KEEP CART WALLPAPER MATCHED TO DESKTOP WALLPAPER
   Saves the visible desktop wallpaper and reuses it on /cart when a
   global/cart wallpaper setting is not already present.
========================================================= */
(function () {
  try {
    const desktop = document.getElementById("desktop");
    const cartDesktop = document.querySelector(".cart-page-desktop");

    if (desktop && window.getComputedStyle) {
      const desktopWallpaper = window.getComputedStyle(desktop).backgroundImage;
      if (desktopWallpaper && desktopWallpaper !== "none") {
        window.localStorage.setItem("ghXpDesktopWallpaper", desktopWallpaper);
      }
    }

    if (cartDesktop && !cartDesktop.style.getPropertyValue("--gh-cart-wallpaper")) {
      const savedWallpaper = window.localStorage.getItem("ghXpDesktopWallpaper");
      if (savedWallpaper && savedWallpaper !== "none") {
        cartDesktop.style.setProperty("--gh-cart-wallpaper", savedWallpaper);
      }
    }
  } catch (error) {
    // Wallpaper syncing is cosmetic only; never block the cart page.
  }
})();

/* =========================================================
   GH V94 - TASKBAR WINDOW-STATE TRUTH SYNC
   Taskbar tabs are visible only while their matching XP window is actually
   open (minimized windows still keep their tab). This clears stale tabs that
   could remain after close/navigation/start-menu interactions on mobile.
========================================================= */
(function ghInstallTaskbarWindowTruthSync() {
  const pairs = [
    ["rings-task", "window"],
    ["info-task", "infoWindow"],
    ["aim-task", "aimWindow"],
    ["metal-task", "metalWindow"],
    ["namechain-task", "namechainWindow"]
  ];

  function syncTaskbarToWindows() {
    pairs.forEach(([taskId, windowId]) => {
      const task = document.getElementById(taskId);
      const appWindow = document.getElementById(windowId);
      if (!task || !appWindow) return;

      const isOpen = !appWindow.classList.contains("hidden");
      const isMinimized = appWindow.classList.contains("minimized");
      const isActive = isOpen && !isMinimized && appWindow.classList.contains("active-window");

      task.classList.toggle("hidden", !isOpen);
      task.classList.toggle("active-task", isActive);

      // Mobile: if a tab becomes active, reveal the whole left edge of that
      // tab so its icon and the beginning of its title are never stranded
      // behind the horizontal taskbar scroll position.
      if (isActive && window.matchMedia && window.matchMedia("(max-width: 768px)").matches) {
        const apps = document.getElementById("taskbar-apps");
        if (apps) {
          window.requestAnimationFrame(() => {
            const taskLeft = task.offsetLeft;
            const taskRight = taskLeft + task.offsetWidth;
            const viewLeft = apps.scrollLeft;
            const viewRight = viewLeft + apps.clientWidth;
            if (taskLeft < viewLeft || taskRight > viewRight) {
              apps.scrollTo({ left: Math.max(0, taskLeft - 2), behavior: "smooth" });
            }
          });
        }
      }
    });
  }

  function install() {
    syncTaskbarToWindows();

    const observer = new MutationObserver(syncTaskbarToWindows);
    pairs.forEach(([, windowId]) => {
      const appWindow = document.getElementById(windowId);
      if (appWindow) observer.observe(appWindow, { attributes: true, attributeFilter: ["class"] });
    });

    document.addEventListener("click", () => window.setTimeout(syncTaskbarToWindows, 0), true);
    window.addEventListener("popstate", () => window.setTimeout(syncTaskbarToWindows, 0));
    window.addEventListener("hashchange", () => window.setTimeout(syncTaskbarToWindows, 0));
    window.GHSyncTaskbarToWindows = syncTaskbarToWindows;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", install, { once: true });
  } else {
    install();
  }
})();


/* =========================================================
   GH V105 - CUSTOM PROJECT DATE GUARD
   Custom jewelry and NameChain request dates cannot be selected
   sooner than the configured number of calendar days from today.
   This is a request-date guard only; it does not promise delivery.
========================================================= */
(function ghInstallCustomDateGuard() {
  function toLocalISODate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function minimumDateFor(days) {
    const date = new Date();
    date.setHours(12, 0, 0, 0);
    date.setDate(date.getDate() + days);
    return toLocalISODate(date);
  }

  function applyDateGuard(input) {
    const days = Math.max(0, parseInt(input.getAttribute("data-gh-min-days") || "7", 10) || 7);
    const minDate = minimumDateFor(days);
    input.min = minDate;

    // If a browser restores a stale value that is now too early, clear it.
    if (input.value && input.value < minDate) {
      input.value = "";
    }

    input.addEventListener("change", function() {
      const currentMin = minimumDateFor(days);
      input.min = currentMin;
      if (input.value && input.value < currentMin) {
        input.setCustomValidity(`Please choose a date at least ${days} days from today.`);
        input.reportValidity();
        input.value = "";
      } else {
        input.setCustomValidity("");
      }
    });
  }

  function install() {
    document.querySelectorAll('input[type="date"][data-gh-min-days]').forEach(applyDateGuard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", install, { once: true });
  } else {
    install();
  }
})();


/* GH V108 - open FAQ policy accordions from hyperlink hashes */
(function ghInstallFaqPolicyHashNavigation() {
  function openTarget() {
    const hash = String(window.location.hash || "");
    if (!hash || !hash.startsWith("#gh-policy")) return;
    const id = hash.slice(1);
    const target = document.getElementById(id);
    if (!target) return;
    const hub = document.getElementById("gh-policies-legal");
    if (hub && hub.tagName === "DETAILS") hub.open = true;
    if (target.tagName === "DETAILS") target.open = true;
    window.setTimeout(() => {
      try { target.scrollIntoView({ block: "start", behavior: "smooth" }); } catch (error) { target.scrollIntoView(); }
    }, 80);
  }

  document.addEventListener("click", (event) => {
    const link = event.target && event.target.closest ? event.target.closest("a.gh-faq-policy-anchor") : null;
    if (!link) return;
    const href = link.getAttribute("href") || "";
    if (!href.startsWith("#gh-policy")) return;
    window.setTimeout(openTarget, 0);
  });

  window.addEventListener("hashchange", openTarget);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => { window.setTimeout(openTarget, 100); }, { once: true });
  } else {
    window.setTimeout(openTarget, 100);
  }
})();
